﻿var cacheVersion = 1;
var savedTimes = {};

function loadInto(el, url, callback) {
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function (e) {
        if (xhr.readyState === 4 && xhr.status === 200) {
            el.innerHTML = xhr.responseText;
            if (callback) callback();
        }
    };

    xhr.open("GET", url, true);
    xhr.setRequestHeader('Content-type', 'text/html');
    xhr.send();
}

function selfHost() {
    return window.location.protocol + "//" + window.location.host;
}

var briefTimer;
function addBrief(msg, data, large, confetti) {
    if (data && data.messages && data.messages.length > 0) return;
    clearTimeout(briefTimer);
    briefTimer = setTimeout(function () {
        let brief = document.querySelector("body > .brief");
        brief.parentNode.removeChild(brief);
    }, 4500);
    let body = document.querySelector("body");
    let brief = document.querySelector("body > .brief");

    if (confetti) throwConfetti();
    if (!brief) {
        body.insertAdjacentHTML("beforeend", '<div class="brief"><div class="content"></div></div>');
        brief = document.querySelector("body > .brief");

        brief.addEventListener("click", function (e) {
            stopAll(e);
        });
    }
    large ? addClass(brief, "large") : removeClass(brief, "large");
    let content = brief.querySelector(".content");
    let text = brief.textContent;
    if (text.indexOf(msg) < 0) {
        if (msg.indexOf("<") >= 0 && msg.indexOf(">") >= 0) {
            content.insertAdjacentHTML("afterbegin", msg);
        }
        else {
            content.insertAdjacentHTML("afterbegin", '<p>' + msg + '</p>');
        }
    }
}

function addOverlayMessage(msg, extra, confetti) {
    let body = document.querySelector("body");
    let overlay = document.querySelector("body > .overlay");
    if (confetti) throwConfetti();
    if (!overlay) {
        addClass(body, "noscroll");
        body.insertAdjacentHTML("beforeend", '<div class="overlay"><div><div class="content"></div><a class="button close">OK</a></div></div>');
        overlay = document.querySelector("body > .overlay");

        overlay.addEventListener("click", function (e) {
            hideMessageOverlay();
            stopAll(e);
        });

        overlay.querySelector(".close").addEventListener("click", function (e) {
            hideMessageOverlay();
            stopAll(e);
        });

        overlay.firstChild.addEventListener("click", function (e) {
            stopAll(e);
        });
    }
    let content = overlay.querySelector(".content");
    let text = content.textContent;
    if (text.indexOf(msg) < 0) {
        if (msg.indexOf("<") >= 0 && msg.indexOf(">") >= 0) {
            content.insertAdjacentHTML("afterbegin", msg + (extra ? '<span class="extra">' + extra + "<br>" + new Error().stack.replace(/(?:\r\n|\r|\n)/g, '<br>') + '</span>' : ""));
        }
        else {
            content.insertAdjacentHTML("afterbegin", '<p>' + msg + '</p>' + (extra ? '<span class="extra">' + extra + "<br>" + new Error().stack.replace(/(?:\r\n|\r|\n)/g, '<br>') + '</span>' : ""));
        }
    }
}

function hideMessageOverlay() {
    let body = document.querySelector("body");
    let overlay = document.querySelector("body > .overlay");
    body.removeChild(overlay);
    removeClass("body", "noscroll");
}

function handleResponse(url, result, callback, postdata, source, eventExtra, isFetch) {
    let u = url.split('?');
    if (u.length > 1) u = u[1];

    let goal = url.split('/').pop().split('?').pop();

    let postdataLength = 0;
    if (typeof postdata === "string") {
        postdataLength = postdata.length;
    }

    if (goal && goal.length > 0 && (goal.indexOf('=') > 0 || url.indexOf("umbraco") > 0) && (postdata instanceof FormData || postdataLength > 3)) {
        goal = goal.split('=').pop();
        goal += source && source.getAttribute("eventextra") ? source.getAttribute("eventextra") : "";
        if (eventExtra) goal += eventExtra;
        plausible(goal);
    }
    let event = source && source.getAttribute("data-event");
    if (event) { plausible(event); }

    parseTimeStampCookie(u);

    let data = result;
    if (result && result.length > 5 && result.substring(0, 5) === "error") {
        if (result.length > 14 && result.substring(0, 14) === "error.internal") {
            showApiError(result, true, url);
        }
        else {
            showApiError(result, false);
        }
        return true;
    }

    if (result && result.length > 5 && result.indexOf("<form") >= 0) {
        if (result.substring(0, 5) !== "<form") result = result.substring(result.indexOf("<form"), result.indexOf("</form>") + 7);
        let body = document.querySelector("body");
        let div = document.createElement("div");
        addClass(div, "hidden");
        div.innerHTML = result;
        body.appendChild(div);
        body.lastChild.firstChild.submit();
        return true;
    }
    if (result && result.length > 1 && result.substring(0, 1) !== "<") {
        try {
            data = JSON.parse(result);
            if (data.messages && data.messages.length) {
                showApiMessages(data.messages);
            }
        }
        catch (ex) {
            data = result;
        }
    }
    if (result && result.length > 4 && (result.substr(0, 4) === "url:" || result.indexOf("url:") > 0)) {
        if (navigator.userAgent.indexOf("Firefox") != -1) {
            setTimeout(function () { document.location.href = result.substr(result.indexOf("url:") + 4); }, 100);
        }
        else {
            document.location.href = result.substr(result.indexOf("url:") + 4);
        }
        return true;
    }
    if (callback) {
        callback(data, source);
    }
    else if (source) {
        let result = source.querySelector(".result[data-status='" + data + "']");
        if (result) {
            let url = result.getAttribute("data-url");
            if (url) {
                if (navigator.userAgent.indexOf("Firefox") != -1) {
                    setTimeout(function () { document.location = url; }, 100);
                }
                else {
                    document.location = url;
                }
            }
            else {
                forEach(source.querySelectorAll(".result"), function (el) {
                    removeClass(el, "active");
                });
                addClass(result, "active");
                scrollToElement(result);
            }
        }
    }

    if (source) {
        let submit = source.querySelector("input[type=submit]");
        if (submit) submit.removeAttribute("disabled");
    }
}

urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results === null) {
        return null;
    }
    else {
        return decodeURIComponent(results[1]) || 0;
    }
};

function handleError(msg, url, data, error, callback = undefined) {
    customLog(2, msg, url, data, error);
    showApiError(genericError, false);
    if (callback) callback(-1);
}

async function httpr(url, callback, postdata, source, eventExtra) {
    if (isDebug) {
        let u = url.split('?');
        if (u.length > 1) u = u[1];
        savedTimes[u] = new Date().getTime();
    }

    let fetchAvailable = (typeof fetch !== 'undefined');

    if (source) {
        let submit = source.querySelector("input[type=submit]");
        if (submit) submit.setAttribute("disabled", "disabled");
    }

    let aft = afToken()?.value;
    if (postdata && typeof postdata !== "string") {
        postdata.append("__RequestVerificationToken", aft);
    }

    let method = postdata !== undefined ? 'POST' : 'GET';
    if (fetchAvailable) {
        let responseUrl = url;
        let headers = {};
        if (method == "POST") headers["X-CSRF-TOKEN"] = aft;
        fetch(url, {
            method: method,
            headers: headers,
            body: postdata ? postdata : null
        }).then(response => {
            if (!response.ok) {
                handleError("Network response was not ok", response.url, undefined, undefined, callback)
            }
            responseUrl = response.url;
            return response.text();
        }).then(data => {
            handleResponse(responseUrl, data, callback, postdata, source, eventExtra, true);
        }).catch(error => {
            handleError("apierror", url, undefined, error, callback)
        });
    } else {
        let request = new XMLHttpRequest();
        request.open(method, url, true);
        if (method == 'POST') request.setRequestHeader('X-CSRF-TOKEN', aft);
        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                handleResponse(request.responseURL, request.responseText, callback, postdata, source, eventExtra, false);
            } else {
                handleError("apierror", url, undefined, error, callback)
            }
        };

        request.onerror = function (data) {
            handleError("onerror", url, data, undefined, callback)
        };

        if (postdata !== undefined) {
            try {
                request.send(postdata);
            }
            catch (ex) {
                handleError("onerror", url, undefined, ex, callback)
            }
        }
        else {
            request.send();
        }
    }
}

function afToken() {
    return document.querySelector('input[name=__RequestVerificationToken');
}

function maxFromProperties(o, a) {
    let max = 0;
    if (!a || a.length === 0) return max;
    for (let i = 0; i < a.length; i++) {
        let k = a[i];
        if (o[k] && o[k] > max) max = o[k];
    }
    return max;
}

function scrollToElement(el) {
    let p = el.getBoundingClientRect().top + window.pageYOffset - 100;
    if (window.navigator.userAgent.indexOf("Edge") > 0) {
        document.body.scrollTop = p;
    }
    else {
        window.scrollTo({
            top: p,
            behavior: "smooth"
        });
    }
}

function isInt(value) {
    return !isNaN(value) &&
        parseInt(Number(value)) == value &&
        !isNaN(parseInt(value, 10));
}

function isNullOrWhiteSpace(value) {
    return typeof value !== "string" || !value || !value.trim();
}

function cssVar(v) {
    return window.getComputedStyle(document.documentElement).getPropertyValue('--' + v);
}

function _log(s, alwaysShow, text) {
    if (enableLog && console && (alwaysShow === true || enableLogDebug)) {
        if (text) console.log(text);
        console.log(s);
    }
}

var forEach = function (arr, callback) {
    if (typeof arr === "string") arr = document.querySelectorAll(arr);
    Array.prototype.forEach.call(arr, callback);
};

var hasClass, addClass, removeClass;
hasClass = function (el, className) { if (el) return el.classList.contains(className); };
addClass = function (el, className) {
    if (typeof el === "string") {
        forEach(document.querySelectorAll(el), function (iel) { addClass(iel, className); });
    }
    else {
        if (el) el.classList.add(className);
    }
};
removeClass = function (el, className) {
    if (typeof el === "string") {
        forEach(document.querySelectorAll(el), function (iel) { removeClass(iel, className); });
    }
    else {
        if (el) el.classList.remove(className);
    }
};

function addEvent(path, event, func) {
    let el = document.querySelector(path);
    if (el) {
        el.addEventListener(event, func);
    }
}

function addEvents(path, event, func) {
    forEach(path, function (el) {
        el.addEventListener(event, func);
    });
}

function toggleClass(el, className) {
    if (typeof el === "string") el = document.querySelector(el);

    if (hasClass(el, className)) {
        removeClass(el, className);
    }
    else {
        addClass(el, className);
    }
}

function addClasses(els, className) {
    if (!els || els.length === 0) return;
    els.forEach(function (el) {
        addClass(el, className);
    });
}

function removeClasses(els, className) {
    if (!els || els.length === 0) return;
    els.forEach(function (el) {
        removeClass(el, className);
    });
}

function translate(key) {
    var v = Local[key];
    if (v !== undefined) return v;
    return key;
}

addDomReadyEventListener(() => {
    document.body.addEventListener('keyup', function (e) {
        if (e.key === 'Tab') {
            let el = document.documentElement;
            el.classList.remove('nfo');
            el.classList.add('tab');
        }
    });

    addEvents(".jslink", "click", function (e) {
        let a = e.target.closest(".jslink");
        let href = a ? a.getAttribute("href") : undefined;
        if (href) {
            stopAll(e);
            document.location = href;
        }
    });

    forEach("form.cf.toggle", function (el) {
        forEach(el.payment, function (iel) {
            iel.addEventListener('change', function (e) {
                let form = iel.closest("form");
                let target = form.getAttribute("data-toggle").split(":");
                let toggle = form.querySelector(".toggle");
                let element = form.querySelector("input[name=" + target[0] + "]:checked");
                if (element && element.value === target[1]) {
                    removeClass(toggle, "hidden");
                    forEach(toggle.querySelectorAll("input"), function (inp) {
                        if (inp.getAttribute("data-toggle") === "required") inp.required = true;
                    });
                }
                else {
                    addClass(toggle, "hidden");
                    forEach(toggle.querySelectorAll("input"), function (inp) {
                        if (inp.getAttribute("data-toggle") === "required") inp.required = false;
                    });
                }
            });
        });
    });
});

function stopAll(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
}

function hasAny(arr, value, key) {
    return first(arr, value, key) !== null;
}

function isVisible(elem) {
    return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
}

function isValidEmail(email) {
    if (email && email.length === 41 && email.substr(-5) === '.GUID') return true;
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase());
}

function unique(a) {
    return a.sort().filter(function (value, index, array) {
        return (index === 0) || (value !== array[index - 1]);
    });
}

function first(arr, value, key, ci) {
    if (!arr || !value) return null;
    for (let i = 0; i < arr.length; i++) {
        if (key) {
            if (ci) {
                if (arr[i][key].toLowerCase() === value.toLowerCase()) {
                    return arr[i];
                }
            }
            else {
                if (arr[i][key] === value) {
                    return arr[i];
                }
            }
        }
        else {
            if (arr[i] === value) {
                return arr[i];
            }
        }
    }
    return null;
}

function removeElement(el) {
    el.parentNode.removeChild(el);
}

function getWidth(el) {
    return parseFloat(getComputedStyle(el, null).width.replace("px", ""));
}
function getHeight(el) {
    return parseFloat(getComputedStyle(el, null).height.replace("px", ""));
}
function getOffset(el) {
    let rect = el.getBoundingClientRect();
    return {
        top: rect.top + document.body.scrollTop,
        left: rect.left + document.body.scrollLeft
    };
}

function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
}

function prettyDate(d) {
    return new Date(Date.parse(d)).toLocaleString('da-DK', { day: 'numeric', month: 'long', year: 'numeric' });
}

function throwConfetti() {
}

function parseTimeStampCookie(u) {
    let timeStamps = useTimestamps ? getCookie("TimeStamps") : undefined;
    if (timeStamps && timeStamps.startsWith("[")) {
        try {
            let parsed = JSON.parse(timeStamps);
            let lc = [];
            forEach(parsed, function (ts) {
                lc.push({ "note": ts.Note, "milliseconds": ts.Milliseconds });
            });
            try {
                showTimestamps({ "timeStamps": lc }, u);
            }
            catch (exi) {
                customLog(2, "showtimestamps failed", exi);
            }
        }
        catch (ex) {
            customLog(2, "timestamp parse failed", ex);
        }
    }
}

function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}
﻿(function () {
    var location = window.location;
    var document = window.document;

    var scriptEl = document.currentScript;
    var endpoint = scriptEl.getAttribute("data-api") || defaultEndpoint(scriptEl);
    var hasDomainLanguage = scriptEl.getAttribute("data-domainLanguage") == "1";

    function onIgnoredEvent(reason, options) {
        if (reason) console.warn("Ignoring Event: " + reason);
        options && options.callback && options.callback();
    }

    function defaultEndpoint(el) {
        return new URL(el.src).origin + "/api/event";
    }

    function trigger(eventName, options) {
        if (
            location.protocol === "file:"
        ) {
            return onIgnoredEvent("localhost", options);
        }
        if (
            window._phantom ||
            window.__nightmare ||
            window.navigator.webdriver ||
            window.Cypress
        ) {
            return onIgnoredEvent(null, options);
        }
        try {
            if (window.localStorage.plausible_ignore === "true") {
                return onIgnoredEvent("localStorage flag", options);
            }
        } catch (e) { }

        var payload = {};
        let href = location.href.toLowerCase().replace("/?", "?");
        let referrer = document.referrer || null;
        if (referrer) {
            referrer = referrer.toLowerCase().replace("/?", "?");
            referrer = referrer.endsWith("/") ? referrer.substring(0, referrer.length - 1) : referrer;
        }
        payload.n = eventName;
        payload.u = href.endsWith("/") ? href.substring(0, href.length - 1) : href;
        payload.d = scriptEl.getAttribute("data-domain");
        payload.r = referrer;
        if (options && options.meta) {
            payload.m = JSON.stringify(options.meta);
        }
        if (options && options.props) {
            payload.p = options.props;
        }
        if (hasDomainLanguage) {
            let language = location.host.split('.')[0].split('-')[0];
            if (language && language.length == 2) {
                if (!payload.p) payload.p = {};
                payload.p.browserLanguage = navigator.language || navigator.userLanguage;
                payload.p.language = language;
            }
        }

        var propAttributes = scriptEl.getAttributeNames().filter(function (name) {
            return name.substring(0, 6) === "event-";
        });

        var props = payload.p || {};

        propAttributes.forEach(function (attribute) {
            var propKey = attribute.replace("event-", "");
            var propValue = scriptEl.getAttribute(attribute);
            props[propKey] = props[propKey] || propValue;
        });

        payload.p = props;

        // TODO: better send

        var url = endpoint;
        var data = JSON.stringify(payload);
        var callback = function () {
            options && options.callback && options.callback();
        }; // Replace with your actual callback function

        try {
            // Use Fetch API with keepalive
            fetch(url, {
                method: 'POST',
                keepalive: true,
                headers: {
                    'Content-Type': 'text/plain'
                },
                body: data
            }).then(() => {
                // Ignore the response
                if (typeof callback === 'function') {
                    callback();
                }
            }).catch((error) => {
                console.error('Error:', error);
                // Use XMLHttpRequest as a fallback
                var xhr = new XMLHttpRequest();
                xhr.open('POST', url, true);
                xhr.setRequestHeader('Content-Type', 'text/plain');
                xhr.send(data);
                xhr.onload = function () {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        if (typeof callback === 'function') {
                            callback();
                        }
                    }
                };
            });
        } catch (error) {
            console.error('Error:', error);
        }

        //    var request = new XMLHttpRequest();
        //    request.open("POST", endpoint, true);
        //    request.setRequestHeader("Content-Type", "text/plain");

        //    request.send(JSON.stringify(payload));

        //    request.onreadystatechange = function () {
        //        if (request.readyState === 4) {
        //            options && options.callback && options.callback();
        //        }
        //    };
    }

    var queue = (window.plausible && window.plausible.q) || [];
    window.plausible = trigger;
    for (var i = 0; i < queue.length; i++) {
        trigger.apply(this, queue[i]);
    }

    var lastPage;

    function page() {
        if (lastPage === location.pathname) return;
        lastPage = location.pathname;
        trigger("pageview");
    }

    var his = window.history;
    if (his.pushState) {
        var originalPushState = his["pushState"];
        his.pushState = function () {
            originalPushState.apply(this, arguments);
            page();
        };
        window.addEventListener("popstate", page);
    }

    function handleVisibilityChange() {
        if (!lastPage && document.visibilityState === "visible") {
            page();
        }
    }

    if (document.visibilityState === "prerender") {
        document.addEventListener("visibilitychange", handleVisibilityChange);
    } else {
        page();
    }
    function getLinkEl(link) {
        while (link && (typeof link.tagName === 'undefined' || !isLink(link) || !link.href)) {
            link = link.parentNode
        }
        return link
    }

    function isLink(element) {
        return element && element.tagName && element.tagName.toLowerCase() === 'a'
    }

    function shouldFollowLink(event, link) {
        // If default has been prevented by an external script, Plausible should not intercept navigation.
        if (event.defaultPrevented) { return false }

        var targetsCurrentWindow = !link.target || link.target.match(/^_(self|parent|top)$/i)
        var isRegularClick = !(event.ctrlKey || event.metaKey || event.shiftKey) && event.type === 'click'
        return targetsCurrentWindow && isRegularClick
    }

    var MIDDLE_MOUSE_BUTTON = 1

    function handleLinkClickEvent(event) {
        if (event.type === 'auxclick' && event.button !== MIDDLE_MOUSE_BUTTON) { return }

        var link = getLinkEl(event.target)
        var hrefWithoutQuery = link && link.href && link.href.split('?')[0]

        if (isElementOrParentTagged(link, 0)) {
            // Return to prevent sending multiple events with the same action.
            // Clicks on tagged links are handled by another function.
            return
        }
        if (isOutboundLink(link)) {
            return sendLinkClickEvent(event, link, { name: 'Outbound Link: Click', props: { url: link.href } })
        }
        if (isDownloadToTrack(hrefWithoutQuery)) {
            return sendLinkClickEvent(event, link, { name: 'File Download', props: { url: hrefWithoutQuery } })
        }
    }

    function sendLinkClickEvent(event, link, eventAttrs) {
        var followedLink = false

        function followLink() {
            if (!followedLink) {
                followedLink = true
                window.location = link.href
            }
        }

        if (shouldFollowLink(event, link)) {
            plausible(eventAttrs.name, { props: eventAttrs.props, callback: followLink })
            setTimeout(followLink, 5000)
            event.preventDefault()
        } else {
            plausible(eventAttrs.name, { props: eventAttrs.props })
        }
    }

    document.addEventListener('click', handleLinkClickEvent)
    document.addEventListener('auxclick', handleLinkClickEvent)

    function isOutboundLink(link) {
        return link && link.href && link.host && link.host !== location.host
    }
    var defaultFileTypes = ['pdf', 'xlsx', 'docx', 'txt', 'rtf', 'csv', 'exe', 'key', 'pps', 'ppt', 'pptx', '7z', 'pkg', 'rar', 'gz', 'zip', 'avi', 'mov', 'mp4', 'mpeg', 'wmv', 'midi', 'mp3', 'wav', 'wma']
    var fileTypesAttr = scriptEl.getAttribute('file-types')
    var addFileTypesAttr = scriptEl.getAttribute('add-file-types')
    var fileTypesToTrack = (fileTypesAttr && fileTypesAttr.split(",")) || (addFileTypesAttr && addFileTypesAttr.split(",").concat(defaultFileTypes)) || defaultFileTypes;

    function isDownloadToTrack(url) {
        if (!url) { return false }

        var fileType = url.split('.').pop();
        return fileTypesToTrack.some(function (fileTypeToTrack) {
            return fileTypeToTrack === fileType
        })
    }
    // Finds event attributes by iterating over the given element's (or its
    // parent's) classList. Returns an object with `name` and `props` keys.
    function getTaggedEventAttributes(htmlElement) {
        var taggedElement = isTagged(htmlElement) ? htmlElement : htmlElement && htmlElement.parentNode
        var eventAttrs = { name: null, props: {} }

        var classList = taggedElement && taggedElement.classList
        if (!classList) { return eventAttrs }

        for (var i = 0; i < classList.length; i++) {
            var className = classList.item(i)

            var matchList = className.match(/plausible-event-(.+)(=|--)(.+)/)
            if (!matchList) { continue }

            var key = matchList[1]
            var value = matchList[3].replace(/\+/g, ' ')

            if (key.toLowerCase() === 'name') {
                eventAttrs.name = value
            } else {
                eventAttrs.props[key] = value
            }
        }

        return eventAttrs
    }

    function handleTaggedFormSubmitEvent(event) {
        var form = event.target
        var eventAttrs = getTaggedEventAttributes(form)
        if (!eventAttrs.name) { return }

        event.preventDefault()
        var formSubmitted = false

        function submitForm() {
            if (!formSubmitted) {
                formSubmitted = true
                form.submit()
            }
        }

        setTimeout(submitForm, 5000)
        plausible(eventAttrs.name, { props: eventAttrs.props, callback: submitForm })
    }

    function isForm(element) {
        return element && element.tagName && element.tagName.toLowerCase() === 'form'
    }

    var PARENTS_TO_SEARCH_LIMIT = 3

    function handleTaggedElementClickEvent(event) {
        if (event.type === 'auxclick' && event.button !== MIDDLE_MOUSE_BUTTON) { return }

        var clicked = event.target

        var clickedLink
        var taggedElement
        // Iterate over parents to find the tagged element. Also search for
        // a link element to call for different tracking behavior if found.
        for (var i = 0; i <= PARENTS_TO_SEARCH_LIMIT; i++) {
            if (!clicked) { break }

            // Clicks inside forms are not tracked. Only form submits are.
            if (isForm(clicked)) { return }
            if (isLink(clicked)) { clickedLink = clicked }
            if (isTagged(clicked)) { taggedElement = clicked }
            clicked = clicked.parentNode
        }

        if (taggedElement) {
            var eventAttrs = getTaggedEventAttributes(taggedElement)

            if (clickedLink) {
                eventAttrs.props.url = clickedLink.href
                sendLinkClickEvent(event, clickedLink, eventAttrs)
            } else {
                plausible(eventAttrs.name, { props: eventAttrs.props })
            }
        }
    }

    function isTagged(element) {
        var classList = element && element.classList
        if (classList) {
            for (var i = 0; i < classList.length; i++) {
                if (classList.item(i).match(/plausible-event-name(=|--)(.+)/)) { return true }
            }
        }
        return false
    }

    function isElementOrParentTagged(element, parentsChecked) {
        if (!element || parentsChecked > PARENTS_TO_SEARCH_LIMIT) { return false }
        if (isTagged(element)) { return true }
        return isElementOrParentTagged(element.parentNode, parentsChecked + 1)
    }

    document.addEventListener('submit', handleTaggedFormSubmitEvent)
    document.addEventListener('click', handleTaggedElementClickEvent)
    document.addEventListener('auxclick', handleTaggedElementClickEvent)
})();

﻿
var allSVGs = {};
allSVGs["ice"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.27 154.52"><path class="s-ice-a" d="M23.58,105.72c0,10-.43,19.43.75,29.64a57.13,57.13,0,0,0,2.75,11.94c.92,2.68,2.27,5,4.88,6.38a10.43,10.43,0,0,0,5.9.73c9.08-1.08,8.88-17.21,8.92-23.44.07-8.57-.79-17.12-1.1-25.68" /><path class="s-ice-b" d="M25.69,0c-4.92.11-9.76,1-13.81,3.25-7.78,4.38-9.4,14.18-10,22.35C0,48.5-1.46,72.41,2.64,95.14c.95,5.25,4,9.73,9.43,11.22C20.8,108.78,29.23,109,38.24,109c7.48,0,17.62.69,23.34-5,7.45-7.45,8.76-18.87,8.69-28.9-.08-12-1-24-2.24-35.9-1-9.59-1-20.08-7.47-27.92-5.3-6.44-13-8.86-21-10.11A80.36,80.36,0,0,0,25.69,0Z" /><path class="s-ice-c" d="M49.17,93.15c1.2-12.71,1.92-25.48,2-38.25,0-6.39-.05-12.79-.34-19.17-.22-5,.41-12.15-3.06-16.24a4.41,4.41,0,0,0-4-1.67c-3.72.72-4,5.88-4.07,8.85-.14,4.65,0,9.32-.15,14-.37,14.17-.35,28.35-.09,42.52l.06,3a17.51,17.51,0,0,0,.85,6,6.23,6.23,0,0,0,4.26,4c5.2,1.06,4-4.41,5-7.25" /><path class="s-ice-c" d="M29.78,90.4c1.45-16.77,1.6-33.63,1.53-50.47,0-6.57,0-12.46-1-19.08a9,9,0,0,0-1.75-4.11,3.86,3.86,0,0,0-3.68-1.67,4.33,4.33,0,0,0-2.88,3,14.73,14.73,0,0,0-.53,4.5c-.14,11.58-.4,23.16-.53,34.74-.06,5.71-.09,11.43-.06,17.15,0,5.28-.29,10.49,1,15.64a5.09,5.09,0,0,0,1.38,2.74A4.25,4.25,0,0,0,29,92c1.07-1.62.68-4,1.25-5.79" /></svg>';
allSVGs["tree"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105.14 123.58"><path class="s-tree-a" d="M30.88,76.18c1.82,3.39,5.43,5.09,8.48,7.16a25.26,25.26,0,0,1,7.89,9.38c5.21,9.88-2.06,20.3-1.7,30.56a.31.31,0,0,0,.31.3H64.54a.5.5,0,0,0,.42-.78c-2.81-3.93-3.57-8.89-3.37-13.66a53.43,53.43,0,0,1,1-7.76c.52-2.74.72-5.66,1.75-8.27.49-1.25,1.63-1.74,2.66-2.44,4.72-3.07,7.27-8.64,8.61-13.93.16-.64.35-3.32-1.06-2.79a1.48,1.48,0,0,0-.63.56c-2.61,3.9-4.1,9.1-8.73,11.2a2,2,0,0,1-2-.06c-2.31-2.18.3-9.31,1.84-11.6.81-1.3,2.61-2.66,2.44-4.34a4.67,4.67,0,0,0-2.64-3.3c-1.85-.86-3.42.74-4.27,2.26-2.07,3.69-1.17,8.07-2.86,11.83-2.89,5.85-5.38-4.18-5.35-6.61-.12-2.64,0-5.24-.64-7.82-.75-3-4.32-.42-5.41,1-1.29,1.88.25,4,1.15,5.71,1.06,2,2.54,7.36-1.1,8a4.12,4.12,0,0,1-2.92-1c-4-2.8-6.56-7-10.21-10.2a2.32,2.32,0,0,0-1.7-.77C28.87,69.78,29.79,74.34,30.88,76.18Z" /><path class="s-tree-b" d="M101,40.82a7.69,7.69,0,0,1,.28-3.19c1.21-5,1.36-10-1.6-14.4A13.63,13.63,0,0,0,89,17.09c-2.28.11-2.6-.92-3.09-2.83A16.84,16.84,0,0,0,62.1,4.83a5.39,5.39,0,0,1-3.3,1C57.31,5.5,56.43,4,55.36,3.07c-3.2-3-8-3.69-12.13-2.54C37.34,2,33.21,7.66,32.89,13.64a2.75,2.75,0,0,1-.35,1.42,1.9,1.9,0,0,1-1.51.62c-2.79,0-5.54-.63-8.33-.23A15.45,15.45,0,0,0,9.94,26.89c-.46,1.75-.32,3.58-.66,5.34a4.22,4.22,0,0,1-3.11,3.48,9,9,0,0,0-4.34,3.13C-1,42.6-.39,48.4,2.47,52c.93,1.15,2.3,1.79,3.34,2.81,2.2,2.15.28,5.45.46,8.11,1.09,14,20.65,18.95,29.47,8.72a3.89,3.89,0,0,1,4.87-.73,53.53,53.53,0,0,0,7.44,3.28c3.86,1.23,8,0,11.9.93,1.51.45,2.19,1.51,3.35,2.38,4.26,2.84,9.81,3.29,14.76,2.45,4.65-.85,9.66-2.78,12.28-6.94,1-1.61,1-3.49,1.49-5.28.48-2.76,2.94-2.57,5.06-3.24,6.85-2.6,10-11.3,7.23-17.91C103.34,44.52,101.43,43,101,40.82Z" /></svg>';
allSVGs["mbike"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 0 322.5 188.4"><path class="s-mbike-a" d="M163.7,131.46a5.06,5.06,0,0,0,4,2h25.65c4.75,28.76,29,51.47,58.47,53.77,1.72.14,3.46.21,5.17.21h0a64.74,64.74,0,0,0,47.41-20.75,64,64,0,0,0,16.91-49,64.78,64.78,0,0,0-31.44-50.2L297,50.17a5,5,0,0,0-4.62-6.92H225.07A5,5,0,0,0,220.62,46l-4,7.86L205.7,37.13l5.9-16.44h10.89a5,5,0,0,0,0-10h-33.2a5,5,0,1,0,0,10H201l-4.29,12H108.47l4.29-11.25a5,5,0,0,0-.52-4.57L107.63,10h15.18a5,5,0,0,0,0-10H98.26a5,5,0,0,0-4.15,7.79l8.38,12.49-16,41.95a64.69,64.69,0,1,0,9.12,4.15l6-15.86Zm29.39-88.78-27,75.42L108.24,42.68ZM280.88,63a63.2,63.2,0,0,0-18.67-4.41c-1.74-.14-3.5-.21-5.24-.21A64.65,64.65,0,0,0,225,66.85l-2.18-3.36,5.26-10.24h56.8Zm-58.63,17.9,27.68,42.53H202.48A54,54,0,0,1,216.93,85.9,52.34,52.34,0,0,1,222.25,80.89Zm8.26-5.64A54.55,54.55,0,0,1,257,68.37c1.47,0,3,.06,4.45.18a53.1,53.1,0,0,1,15.63,3.67l-18.89,45.52Zm80.81,43.2A54.09,54.09,0,0,1,297,159.87,54.7,54.7,0,0,1,257,177.4h0c-1.45,0-2.93-.06-4.4-.17a54.82,54.82,0,0,1-49.07-43.81h55.65a5.1,5.1,0,0,0,4.63-3.09L286,76.79A54.67,54.67,0,0,1,311.32,118.45Zm-136.55,5L201.47,49l15.29,23.5a65.41,65.41,0,0,0-7.18,6.66,63.86,63.86,0,0,0-17.1,44.31ZM10,122.89A54.52,54.52,0,0,1,82.92,71.57L67.5,112,56.94,125.31a5,5,0,1,0,7.84,6.21l11-13.93a5.06,5.06,0,0,0,.75-1.32L92,75.83a54.51,54.51,0,1,1-82,47.06Z" /></svg>';
allSVGs["wroad"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 968 101.14"><path class="s-wroad-a" d="M0,81.22H51.52A31.07,31.07,0,0,0,82.6,50.15V45.08A31.07,31.07,0,0,1,113.68,14H798.61a31.08,31.08,0,0,1,31.08,31.08v5.07a31.08,31.08,0,0,0,62.15,0V45.08a31.08,31.08,0,0,1,62.16,0v56.06" /><path class="s-wroad-b" d="M954,101.14V45.08a31.08,31.08,0,0,0-62.16,0v5.07a31.08,31.08,0,0,1-62.15,0V45.08A31.08,31.08,0,0,0,798.61,14H113.68A31.07,31.07,0,0,0,82.6,45.08v5.07A31.07,31.07,0,0,1,51.52,81.22H2.16" /></svg>';
allSVGs["sroad"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 968 95.29"><path class="s-sroad-a" d="M968,14H103.92a31.09,31.09,0,0,0-31.1,31.1v5.07a31.09,31.09,0,0,1-31.1,31.1H0" /><path class="s-sroad-b" d="M968,14H103.92a31.09,31.09,0,0,0-31.1,31.1v5.07a31.09,31.09,0,0,1-31.1,31.1H1.5" /></svg>';
allSVGs["troph1"] = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="4 0 121 114"><defs><clipPath id="tr1-a" transform="translate(7.69)"><path class="tr1-a" d="M102,56.45a45,45,0,0,1-45,45c-24.85,0-45-22.15-45-47s20.15-43,45-43A45,45,0,0,1,102,56.45Z" /></clipPath><clipPath id="tr1-b" transform="translate(7.69)"><circle class="tr1-a" cx="57" cy="56.45" r="45" /></clipPath></defs><path class="tr1-b" d="M114,56.45c0,2.66-4.17,5-4.53,7.55s3,6,2.23,8.51-5.39,3.6-6.48,6,1.15,6.61-.26,8.8-6.19,1.91-7.9,3.89-.75,6.65-2.73,8.37-6.47.09-8.68,1.52-2.57,6.17-5,7.26-6.21-1.73-8.74-1-4.21,5.19-6.83,5.56-5.45-3.43-8.11-3.43-5.55,3.79-8.11,3.43-4.34-4.83-6.83-5.56-6.38,2.07-8.75,1-2.77-5.85-5-7.27-6.69.2-8.67-1.51-1-6.39-2.73-8.37S10.46,89.48,9,87.27s.83-6.41-.26-8.8S3,75.05,2.3,72.51,4.91,66.62,4.53,64,0,59.11,0,56.45s4.17-5,4.53-7.55-3-6-2.23-8.51,5.39-3.59,6.48-6-1.15-6.61.26-8.8,6.19-1.91,7.9-3.89.75-6.65,2.73-8.37,6.47-.09,8.68-1.51,2.57-6.18,5-7.27,6.21,1.74,8.74,1S46.27.4,48.89,0,54.34,3.45,57,3.45,62.55-.34,65.11,0s4.34,4.84,6.83,5.57,6.38-2.08,8.75-1,2.77,5.86,5,7.27,6.69-.2,8.67,1.51,1,6.4,2.73,8.37,6.48,1.68,7.9,3.89-.83,6.41.26,8.8,5.74,3.43,6.48,6-2.61,5.89-2.23,8.51S114,53.79,114,56.45Z" transform="translate(7.69)" /><circle class="tr1-c" cx="64.69" cy="56.45" r="45" /><path class="tr1-d" d="M79.61,73.47l0,0a5.75,5.75,0,0,0,2,1.68,6.06,6.06,0,0,1,1.91,2.26A3.68,3.68,0,0,1,84,79.11c0,2-.9,3.76-.87,5.74a.07.07,0,0,0,.08.07h4.51a.12.12,0,0,0,.1-.19,5.23,5.23,0,0,1-.81-3.3,11.8,11.8,0,0,1,.23-1.87,11.12,11.12,0,0,1,.43-2c.11-.31.39-.42.64-.59a4.71,4.71,0,0,0,.72-.62,6.41,6.41,0,0,0,1.36-2.75c0-.15.08-.8-.26-.67a.37.37,0,0,0-.15.13c-.35.47-.55,1-.87,1.54a3.17,3.17,0,0,1-1.24,1.17.46.46,0,0,1-.48,0c-.36-.29-.19-1.08-.1-1.46A4.1,4.1,0,0,1,87.85,73c.2-.31.63-.64.59-1a1.12,1.12,0,0,0-.64-.8c-.44-.2-.82.18-1,.55-.5.89-.28,1.95-.69,2.86-.09.21-.33.57-.6.39a.56.56,0,0,1-.18-.22,3.82,3.82,0,0,1-.51-1.77A8.57,8.57,0,0,0,84.63,71a.38.38,0,0,0-.37-.34.77.77,0,0,0-.35.12,1.68,1.68,0,0,0-.59.47c-.31.46.07,1,.28,1.38s.62,1.78-.26,1.94a1,1,0,0,1-.71-.23,32,32,0,0,1-2.47-2.47.54.54,0,0,0-.41-.18.39.39,0,0,0-.28.22A1.72,1.72,0,0,0,79.61,73.47Z" transform="translate(7.69)" /><path class="tr1-e" d="M96.55,64.92a1.87,1.87,0,0,1,.07-.77,4.24,4.24,0,0,0-.39-3.48,3.29,3.29,0,0,0-2.59-1.48.85.85,0,0,1-.48-.11C93,59,93,58.7,92.89,58.5a3.81,3.81,0,0,0-.32-.68,4,4,0,0,0-5.42-1.6,1.31,1.31,0,0,1-.8.23c-.36-.07-.57-.43-.83-.65a2.74,2.74,0,0,0-1-.6,3.48,3.48,0,0,0-1.92,0,3.3,3.3,0,0,0-1.88,1.35,3.84,3.84,0,0,0-.62,1.82.63.63,0,0,1-.08.34.45.45,0,0,1-.37.15,15,15,0,0,0-2-.05,3.73,3.73,0,0,0-3.08,2.76c-.11.43-.08.87-.16,1.29a1,1,0,0,1-.76.85,2.25,2.25,0,0,0-1,.75,2.72,2.72,0,0,0,.16,3.17,8.83,8.83,0,0,0,.81.68c.53.52.06,1.32.11,2a3.39,3.39,0,0,0,.84,2,4.39,4.39,0,0,0,3.21,1.42,4.34,4.34,0,0,0,1.91-.43,4.78,4.78,0,0,0,1.16-.89,1.07,1.07,0,0,1,.78-.32,1.47,1.47,0,0,1,.4.14,12.34,12.34,0,0,0,1.79.79,6.33,6.33,0,0,0,1.94.13,3,3,0,0,1,.94.1c.37.11.53.36.81.57a3.2,3.2,0,0,0,1.1.49,5.42,5.42,0,0,0,2.47.1,5.27,5.27,0,0,0,2.19-.86,2.86,2.86,0,0,0,.78-.81,4.69,4.69,0,0,0,.36-1.28.89.89,0,0,1,.24-.46c.25-.22.67-.2,1-.32a3,3,0,0,0,.89-.55,3.43,3.43,0,0,0,.86-3.78,11.17,11.17,0,0,0-.64-1A1.26,1.26,0,0,1,96.55,64.92Z" transform="translate(7.69)" /><g class="tr1-f"><path class="tr1-g" d="M223.15,35.45H139.94a27.42,27.42,0,0,0-27.42,27.42v4.47a27.42,27.42,0,0,1-54.84,0V62.87A27.42,27.42,0,0,0,30.26,35.45c-15.14,0-27.42,10.28-27.42,25.42v51.46" transform="translate(7.69)" /><path class="tr1-h" d="M223.15,35.45H139.94a27.42,27.42,0,0,0-27.42,27.42v4.47a27.42,27.42,0,0,1-54.84,0V62.87A27.42,27.42,0,0,0,30.26,35.45c-15.14,0-27.42,10.28-27.42,25.42v51.46" transform="translate(7.69)" /></g><g class="tr1-i"><path class="tr1-d" d="M32.38,90l0,0A4.52,4.52,0,0,0,34,91.34a4.92,4.92,0,0,1,1.5,1.79,3.08,3.08,0,0,1,.36,1.3c0,1.56-.71,2.95-.69,4.51a.06.06,0,0,0,.06.06h3.56a.1.1,0,0,0,.08-.15,4.16,4.16,0,0,1-.65-2.6,10.37,10.37,0,0,1,.19-1.47,9.23,9.23,0,0,1,.33-1.58c.1-.24.31-.33.51-.46a3,3,0,0,0,.57-.49,5.11,5.11,0,0,0,1.07-2.16c0-.12.06-.63-.21-.53a.38.38,0,0,0-.12.1c-.27.37-.43.83-.68,1.21a2.41,2.41,0,0,1-1,.92.35.35,0,0,1-.38,0c-.28-.23-.14-.85-.08-1.15a3.33,3.33,0,0,1,.43-1c.16-.25.5-.51.47-.83a.91.91,0,0,0-.5-.63c-.36-.16-.66.14-.82.43-.39.71-.22,1.54-.54,2.25-.07.17-.26.45-.47.31a.49.49,0,0,1-.15-.17,3.11,3.11,0,0,1-.4-1.4,6.67,6.67,0,0,0-.12-1.48c0-.15-.13-.28-.29-.27a.71.71,0,0,0-.28.09,1.39,1.39,0,0,0-.46.37c-.25.36,0,.76.22,1.09s.48,1.4-.21,1.53a.76.76,0,0,1-.55-.19,23.79,23.79,0,0,1-2-1.94.41.41,0,0,0-.32-.14.3.3,0,0,0-.22.17A1.36,1.36,0,0,0,32.38,90Z" transform="translate(7.69)" /><path class="tr1-j" d="M45.72,83.25a1.39,1.39,0,0,1,.05-.6,3.33,3.33,0,0,0-.3-2.74,2.61,2.61,0,0,0-2-1.17.63.63,0,0,1-.38-.08c-.14-.1-.15-.3-.21-.46a2.84,2.84,0,0,0-.25-.53,3.11,3.11,0,0,0-.83-1,3.17,3.17,0,0,0-3.44-.29,1,1,0,0,1-.63.18c-.28,0-.45-.34-.65-.52a2.29,2.29,0,0,0-.8-.46,2.68,2.68,0,0,0-1.51,0,2.65,2.65,0,0,0-1.48,1.06,3.06,3.06,0,0,0-.49,1.43.52.52,0,0,1-.06.28.38.38,0,0,1-.29.11,11.91,11.91,0,0,0-1.58,0,2.94,2.94,0,0,0-2.43,2.18c-.09.33-.06.68-.13,1a.79.79,0,0,1-.59.66,1.65,1.65,0,0,0-.82.6A2.12,2.12,0,0,0,27,85.37a8.14,8.14,0,0,0,.63.54c.42.41.06,1,.09,1.54A2.7,2.7,0,0,0,28.36,89a3.48,3.48,0,0,0,2.53,1.12,3.44,3.44,0,0,0,1.51-.34,3.87,3.87,0,0,0,.91-.7.82.82,0,0,1,.61-.25.89.89,0,0,1,.31.11,9.4,9.4,0,0,0,1.42.62,5.18,5.18,0,0,0,1.52.11,2.3,2.3,0,0,1,.74.07c.29.09.42.29.64.45a2.57,2.57,0,0,0,.86.39,4.43,4.43,0,0,0,2,.08A4.29,4.29,0,0,0,43.08,90a2.19,2.19,0,0,0,.61-.64,3.55,3.55,0,0,0,.29-1,.63.63,0,0,1,.19-.36c.2-.17.53-.16.77-.25a2.28,2.28,0,0,0,.7-.43,2.65,2.65,0,0,0,.67-3,8.45,8.45,0,0,0-.49-.82A1,1,0,0,1,45.72,83.25Z" transform="translate(7.69)" /></g><circle class="tr1-k" cx="64.69" cy="56.45" r="45" /></svg>';
allSVGs["troph2"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="-3 0 120 109.54"><path class="tr2-a" d="M114,54.77c0,5.93-4.84,11-6.58,16.38-1.8,5.55-.94,12.51-4.3,17.13s-10.3,6-15,9.37-8,9.54-13.53,11.35c-5.36,1.73-11.69-1.23-17.62-1.23s-12.26,3-17.62,1.23c-5.55-1.81-8.91-8-13.53-11.35s-11.57-4.71-15-9.37S8.38,76.7,6.58,71.15C4.84,65.8,0,60.7,0,54.77s4.84-11,6.58-16.38c1.8-5.55.94-12.51,4.3-17.13s10.3-6,15-9.37,8-9.54,13.53-11.34C44.74-1.19,51.07,1.77,57,1.77s12.26-3,17.62-1.22c5.55,1.8,8.91,8,13.53,11.34s11.57,4.71,15,9.37,2.5,11.58,4.3,17.13C109.16,43.74,114,48.84,114,54.77Z" /><path class="tr2-b" d="M69.58,103.56a32.79,32.79,0,0,1-6-.77A35.8,35.8,0,0,0,57,102a35.8,35.8,0,0,0-6.59.84,32.79,32.79,0,0,1-6,.77,9.78,9.78,0,0,1-3.13-.45c-2.87-.93-5.06-3.28-7.39-5.77A33.58,33.58,0,0,0,29.27,93a34.93,34.93,0,0,0-5.67-3.11c-3.07-1.44-6-2.8-7.72-5.2s-2.12-5.53-2.55-8.88a34.14,34.14,0,0,0-1.22-6.4,32.69,32.69,0,0,0-2.7-5.68c-1.59-2.86-3.23-5.82-3.23-8.91s1.64-6.05,3.23-8.91a32.6,32.6,0,0,0,2.7-5.67,34.45,34.45,0,0,0,1.22-6.4c.43-3.36.83-6.52,2.55-8.89s4.65-3.76,7.72-5.2a34.88,34.88,0,0,0,5.67-3.1,34.82,34.82,0,0,0,4.63-4.39c2.33-2.5,4.52-4.85,7.39-5.78A10.06,10.06,0,0,1,44.42,6a32.84,32.84,0,0,1,6,.78A35.79,35.79,0,0,0,57,7.59a35.79,35.79,0,0,0,6.59-.83,32.84,32.84,0,0,1,6-.78,10.06,10.06,0,0,1,3.13.45c2.87.93,5.06,3.28,7.39,5.78a34.82,34.82,0,0,0,4.63,4.39,34.88,34.88,0,0,0,5.67,3.1c3.07,1.44,6,2.8,7.72,5.2s2.12,5.53,2.55,8.88a34.4,34.4,0,0,0,1.22,6.41,33.34,33.34,0,0,0,2.7,5.67c1.58,2.86,3.23,5.82,3.23,8.91s-1.65,6-3.23,8.91a33.44,33.44,0,0,0-2.7,5.68,34.14,34.14,0,0,0-1.22,6.4c-.43,3.35-.83,6.51-2.55,8.88s-4.65,3.76-7.72,5.2A34.93,34.93,0,0,0,84.73,93a33.58,33.58,0,0,0-4.63,4.39c-2.33,2.49-4.52,4.84-7.39,5.78A10.07,10.07,0,0,1,69.58,103.56Z" /><path class="tr2-c" d="M44.42,7a32.44,32.44,0,0,1,5.81.76A36.34,36.34,0,0,0,57,8.59a36.56,36.56,0,0,0,6.78-.85A32.22,32.22,0,0,1,69.58,7a9,9,0,0,1,2.82.4c2.62.85,4.73,3.11,7,5.51a34.47,34.47,0,0,0,4.77,4.51A34.51,34.51,0,0,0,90,20.6c3,1.39,5.73,2.7,7.33,4.89s2,5.2,2.37,8.42a36.3,36.3,0,0,0,1.25,6.59,33.93,33.93,0,0,0,2.78,5.84c1.6,2.88,3.11,5.6,3.11,8.43s-1.51,5.55-3.11,8.43a34.38,34.38,0,0,0-2.78,5.85,36,36,0,0,0-1.25,6.58c-.41,3.22-.8,6.26-2.37,8.43S92.93,87.55,90,88.94a35.22,35.22,0,0,0-5.84,3.2,34,34,0,0,0-4.77,4.52c-2.24,2.39-4.35,4.65-7,5.5a9,9,0,0,1-2.82.4,32.44,32.44,0,0,1-5.81-.76A37.2,37.2,0,0,0,57,101a37.42,37.42,0,0,0-6.78.85,32.22,32.22,0,0,1-5.8.76,9,9,0,0,1-2.82-.4c-2.62-.85-4.73-3.11-7-5.51a34.47,34.47,0,0,0-4.77-4.51A35.22,35.22,0,0,0,24,88.94c-2.95-1.39-5.73-2.69-7.33-4.89s-2-5.2-2.37-8.42a36,36,0,0,0-1.25-6.58,34.38,34.38,0,0,0-2.78-5.85c-1.6-2.88-3.11-5.6-3.11-8.43s1.51-5.55,3.11-8.43a33.68,33.68,0,0,0,2.78-5.85,36,36,0,0,0,1.25-6.58c.41-3.22.8-6.26,2.37-8.42S21.07,22,24,20.6a34.51,34.51,0,0,0,5.84-3.2,34.47,34.47,0,0,0,4.77-4.51c2.24-2.4,4.35-4.66,7-5.51A9,9,0,0,1,44.42,7m0-2a11.06,11.06,0,0,0-3.44.5c-5,1.63-8.1,7.25-12.3,10.31s-10.52,4.28-13.6,8.52S12.8,34.83,11.16,39.88c-1.58,4.86-6,9.5-6,14.89s4.4,10,6,14.89c1.64,5,.86,11.37,3.92,15.57s9.36,5.44,13.6,8.53,7.26,8.67,12.3,10.31a11.36,11.36,0,0,0,3.44.49c4,0,8.41-1.61,12.58-1.61s8.56,1.61,12.58,1.61a11.36,11.36,0,0,0,3.44-.49c5-1.64,8.1-7.26,12.3-10.31s10.52-4.29,13.6-8.53,2.28-10.52,3.92-15.56c1.58-4.87,6-9.5,6-14.9s-4.4-10-6-14.89c-1.64-5.05-.86-11.37-3.92-15.57s-9.36-5.44-13.6-8.52S78.06,7.11,73,5.48A11.06,11.06,0,0,0,69.58,5c-4,0-8.41,1.61-12.58,1.61S48.44,5,44.42,5Z" /><path class="tr2-d" d="M92,50.27a35.16,35.16,0,0,0-70,2.95" /><path class="tr2-e" d="M22,53.22c0,.51,0,1,0,1.55a35.16,35.16,0,0,0,69.5,7.42" /><path class="tr2-c" d="M94.1,51.55l4.11-8.73a2,2,0,0,0-2.42-2.76l-12.53,4a2,2,0,0,0-.37,3.65l8.42,4.72A2,2,0,0,0,94.1,51.55Z" /><path class="tr2-a" d="M81.2,54.77c0,2.5-2.35,4.61-3.08,6.86S78,67.05,76.58,69,72,71.3,70.05,72.73s-3.23,4.3-5.57,5.06S59.5,77,57,77s-5.22,1.56-7.48.82S45.9,74.15,44,72.73,38.85,71,37.42,69s-.78-5-1.54-7.37-3.08-4.36-3.08-6.86,2.35-4.6,3.08-6.86.12-5.42,1.54-7.36S42,38.24,44,36.81s3.23-4.3,5.57-5.06,5,.82,7.48.82,5.22-1.55,7.48-.82,3.62,3.64,5.57,5.06,5.1,1.77,6.53,3.74.78,5,1.54,7.36S81.2,52.27,81.2,54.77Z" /><path class="tr2-f" d="M81.2,54.77c0,2.5-2.35,4.61-3.08,6.86S78,67.05,76.58,69,72,71.3,70.05,72.73s-3.23,4.3-5.57,5.06S59.5,77,57,77s-5.22,1.56-7.48.82S45.9,74.15,44,72.73,38.85,71,37.42,69s-.78-5-1.54-7.37-3.08-4.36-3.08-6.86,2.35-4.6,3.08-6.86.12-5.42,1.54-7.36S42,38.24,44,36.81s3.23-4.3,5.57-5.06,5,.82,7.48.82,5.22-1.55,7.48-.82,3.62,3.64,5.57,5.06,5.1,1.77,6.53,3.74.78,5,1.54,7.36S81.2,52.27,81.2,54.77Z" /><g class="tr2-g"><path class="tr2-c" d="M56.89,54.7c-2.7,0-3.5.33-5.74,2.27L48,55.33l1.46-14.67H64.67V46.3H54.17l-.32,3.32a8,8,0,0,1,3-.4C62.11,49.22,67,53.7,67,59a9.28,9.28,0,0,1-3.06,7,10.37,10.37,0,0,1-7.37,2.9,10.55,10.55,0,0,1-5.78-1.67A9.9,9.9,0,0,1,47,62.93l5.71-1.81a4.26,4.26,0,0,0,3.86,2.11A4.43,4.43,0,0,0,59.72,62,3.94,3.94,0,0,0,61,59a4,4,0,0,0-1.3-3,3.7,3.7,0,0,0-2.83-1.32Z" /></g></svg>';
allSVGs["troph3"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="-3 0 120.76 114.76"><path class="tr3-a" d="M98.39,16.37c4.2,4.2,2.78,12.38,5.34,17.4,2.65,5.2,10,8.9,10.94,14.54s-5,11.51-5.92,17.21,3,13,.32,18.2c-2.55,5-10.72,6.24-14.92,10.43s-5.41,12.37-10.43,14.92c-5.2,2.65-12.56-1.21-18.2-.32S54,115.57,48.31,114.67,39,106.38,33.77,103.73c-5-2.56-13.2-1.14-17.4-5.34S13.59,86,11,81C8.39,75.8,1,72.1.09,66.45S5.12,54.94,6,49.24s-3-13-.33-18.2c2.56-5,10.73-6.23,14.92-10.43S26,8.25,31,5.69C36.24,3,43.6,6.91,49.24,6S60.76-.81,66.45.09,75.8,8.39,81,11C86,13.59,94.2,12.17,98.39,16.37Z" /><circle class="tr3-b" cx="57.38" cy="57.38" r="42" /><line class="tr3-c" x1="54.48" y1="55.78" x2="26.06" y2="83.02" /><line class="tr3-c" x1="66.35" y1="17.25" x2="54.77" y2="55.77" /><line class="tr3-c" x1="57.41" y1="15.34" x2="55.21" y2="55.33" /><line class="tr3-c" x1="31.78" y1="24.28" x2="53.79" y2="57.1" /><line class="tr3-c" x1="24.6" y1="31.46" x2="53.89" y2="58.27" /><polyline class="tr3-c" points="94.77 39.22 56.97 54.1 89.78 31.31" /><line class="tr3-c" x1="97.4" y1="66.17" x2="58.29" y2="54.02" /><polyline class="tr3-c" points="94.77 75.55 59.49 55.23 39.25 20.03" /><polyline class="tr3-c" points="75.14 94.3 60.34 56.95 48.04 16.81" /><line class="tr3-c" x1="89.64" y1="82.73" x2="56.68" y2="60.02" /><line class="tr3-c" x1="82.75" y1="89.61" x2="55.36" y2="59.88" /><line class="tr3-c" x1="66.49" y1="97.08" x2="60.34" y2="58.12" /><line class="tr3-c" x1="57.7" y1="97.67" x2="54.48" y2="57.82" /><line class="tr3-c" x1="48.04" y1="97.67" x2="54.21" y2="56.87" /><polyline class="tr3-c" points="39.54 94.45 59.17 59.29 97.11 48.01" /><polyline class="tr3-c" points="31.48 89.32 58.29 60.17 98.72 57.53" /><line class="tr3-c" x1="20.64" y1="75.55" x2="56.24" y2="54.6" /><line class="tr3-c" x1="16.69" y1="66.32" x2="57.7" y2="59.58" /><line class="tr3-c" x1="15.96" y1="56.8" x2="57.31" y2="59.98" /><polyline class="tr3-c" points="17.13 47.72 57.85 54.46 20.06 39.22" /><line class="tr3-c" x1="74.7" y1="20.03" x2="60.19" y2="58.26" /><line class="tr3-c" x1="82.61" y1="25.31" x2="60.08" y2="59.02" /><path class="tr3-d" d="M57.38,55.94a1.43,1.43,0,0,1,1,.42,1.46,1.46,0,0,1,.42,1,1.43,1.43,0,0,1-1.44,1.44,1.46,1.46,0,0,1-1-.42,1.43,1.43,0,0,1-.42-1,1.43,1.43,0,0,1,1.44-1.44m0-2.16a3.55,3.55,0,0,0-2.54,1.06,3.59,3.59,0,1,0,2.54-1.06Z" /><path class="tr3-d" d="M57.38,17.78a39.6,39.6,0,1,1-28,11.6,39.33,39.33,0,0,1,28-11.6m0-5.4A45,45,0,1,0,89.2,25.56,44.9,44.9,0,0,0,57.38,12.38Z" /></svg>';
allSVGs["troph4"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="-3 0 116 110"><circle class="tr4-a" cx="55" cy="55" r="55" /><circle class="tr4-b" cx="55" cy="55" r="50" /><circle class="tr4-c" cx="55" cy="55" r="30" /><g class="tr4-d"><path class="tr4-e" d="M37.53,65.49l.82-2.7C43.8,59,49.8,52.87,49.8,50.24a3.6,3.6,0,0,0-1.08-2.58,3.73,3.73,0,0,0-2.62-1.07,3.69,3.69,0,0,0-2.61,1.07,3.6,3.6,0,0,0-1.08,2.58H37.62a8.33,8.33,0,0,1,2.49-5.94,8.55,8.55,0,0,1,12,0,8.33,8.33,0,0,1,2.49,5.94c0,2.76-1.72,5.52-4,7.94a29.63,29.63,0,0,1-2.68,2.57H54.5v4.74Z" /><path class="tr4-e" d="M64.48,53.81c-2.26,0-2.92.28-4.79,1.89L57,54.34l1.21-12.23H71v4.7H62.21l-.27,2.77a6.69,6.69,0,0,1,2.54-.34,8.55,8.55,0,0,1,8.41,8.16,7.67,7.67,0,0,1-2.55,5.81,8.57,8.57,0,0,1-6.13,2.42,8.76,8.76,0,0,1-4.82-1.39,8.26,8.26,0,0,1-3.15-3.57L61,59.16a3.55,3.55,0,0,0,3.22,1.75,3.66,3.66,0,0,0,2.62-1,3.27,3.27,0,0,0,1.08-2.48,3.34,3.34,0,0,0-1.08-2.49,3.11,3.11,0,0,0-2.35-1.1Z" /></g><polygon class="tr4-c" points="16.65 49.1 18.57 52.98 22.85 53.61 19.75 56.63 20.48 60.9 16.65 58.88 12.82 60.9 13.55 56.63 10.45 53.61 14.73 52.98 16.65 49.1" /><polygon class="tr4-c" points="93.35 49.1 95.27 52.98 99.55 53.61 96.45 56.63 97.18 60.9 93.35 58.88 89.52 60.9 90.25 56.63 87.15 53.61 91.43 52.98 93.35 49.1" /><path class="tr4-e" d="M55,27.93A27.07,27.07,0,1,1,27.93,55,27.11,27.11,0,0,1,55,27.93M55,27A28,28,0,1,0,83,55,28,28,0,0,0,55,27Z" /></svg>';
allSVGs["troph5"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="-6 0 110.35 118.56"><polygon class="tr5-a" points="87.57 108.64 74.68 106.24 70.2 118.56 43.78 72.31 61.15 62.39 87.57 108.64" /><polygon class="tr5-a" points="10.78 108.64 23.67 106.24 28.15 118.56 54.57 72.31 37.2 62.39 10.78 108.64" /><path class="tr5-a" d="M98.35,78.64V30.48a7.25,7.25,0,0,0-3.64-6.29l-39-22.45a13,13,0,0,0-13,0l-39,22.45A7.25,7.25,0,0,0,0,30.48V78.64a7.28,7.28,0,0,0,3.64,6.3L45.55,109a7.27,7.27,0,0,0,7.25,0l41.91-24.1A7.28,7.28,0,0,0,98.35,78.64Z" /><path class="tr5-b" d="M94.18,76.24V32.88a7.24,7.24,0,0,0-3.65-6.29l-34.85-20a13,13,0,0,0-13,0L7.82,26.59a7.23,7.23,0,0,0-3.64,6.29V76.24a7.26,7.26,0,0,0,3.64,6.3l37.73,21.7a7.27,7.27,0,0,0,7.25,0l37.73-21.7A7.27,7.27,0,0,0,94.18,76.24Z" /><path class="tr5-c" d="M89.41,73.5V35.63a7.27,7.27,0,0,0-3.65-6.3L55.68,12a13.06,13.06,0,0,0-13,0L12.59,29.33a7.27,7.27,0,0,0-3.65,6.3V73.5a7.24,7.24,0,0,0,3.65,6.29l33,19a7.27,7.27,0,0,0,7.25,0l33-19A7.24,7.24,0,0,0,89.41,73.5Z" /><path class="tr5-d" d="M84.18,69.6V37.74a7.27,7.27,0,0,0-3.65-6.3L55.68,17.15a13,13,0,0,0-13,0L17.82,31.44a7.26,7.26,0,0,0-3.64,6.3V69.6a7.23,7.23,0,0,0,3.64,6.29l27.73,16a7.27,7.27,0,0,0,7.25,0l27.73-16A7.24,7.24,0,0,0,84.18,69.6Z" /><path class="tr5-e" d="M31.24,74.79H66.88a2,2,0,0,0,2-1.52L76.2,43,63.89,61.89,62.74,41,54.56,59.32,49.39,38.38,44.83,60.5,35.89,40,34.7,61.49,22.59,43.62l6.7,29.61A2,2,0,0,0,31.24,74.79Z" /><polygon class="tr5-e" points="49.61 33.43 53.05 38.04 49.61 42.27 45.74 37.85 49.61 33.43" /><polygon class="tr5-e" points="63.86 36.2 66.32 41.4 62.13 44.87 59.2 39.77 63.86 36.2" /><polygon class="tr5-e" points="77.73 39.18 79.18 44.75 74.4 47.38 72.48 41.83 77.73 39.18" /><polygon class="tr5-e" points="34.82 36.22 39.16 39.98 36.72 44.85 31.99 41.37 34.82 36.22" /><polygon class="tr5-e" points="21.07 39.19 26 42.15 24.44 47.37 19.18 44.76 21.07 39.19" /></svg>';
allSVGs["troph6"] = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-3 0 118 111.7"><defs><clipPath id="tr6-a"><circle class="tr6-a" cx="56" cy="55.85" r="45" /></clipPath></defs><path class="tr6-b" d="M112,55.85c0,1.38-2,2.68-2.15,4s1.73,3,1.53,4.31-2.42,2.34-2.72,3.67,1.27,3.19.87,4.49-2.75,2-3.25,3.22.78,3.34.19,4.57-3,1.52-3.7,2.7.28,3.42-.5,4.55-3.19,1-4,2.12-.24,3.42-1.17,4.42-3.32.56-4.32,1.5-.74,3.34-1.81,4.19-3.37.07-4.5.84-1.23,3.2-2.42,3.89-3.33-.44-4.57.15-1.68,3-3,3.48-3.22-.93-4.54-.53-2.11,2.69-3.46,3-3-1.41-4.41-1.21-2.49,2.34-3.86,2.45-2.81-1.85-4.19-1.85-2.83,2-4.18,1.85-2.52-2.24-3.87-2.45-3.08,1.51-4.41,1.21-2.16-2.59-3.46-3-3.27,1-4.55.53-1.73-2.88-3-3.48-3.39.53-4.58-.16-1.28-3.11-2.41-3.88-3.43,0-4.5-.84-.81-3.26-1.81-4.2-3.39-.49-4.32-1.49-.32-3.35-1.17-4.42-3.28-1-4-2.12.18-3.36-.5-4.55-3.1-1.46-3.7-2.7.69-3.29.19-4.57-2.84-1.9-3.25-3.22,1.18-3.15.87-4.49S.82,65.56.62,64.2s1.63-2.93,1.53-4.31S0,57.23,0,55.85s2.05-2.68,2.15-4S.42,48.85.62,47.5,3,45.16,3.34,43.83s-1.27-3.19-.87-4.49,2.75-2,3.25-3.22-.78-3.34-.19-4.57,3-1.52,3.7-2.7-.28-3.42.5-4.55,3.19-1.05,4-2.12S14,18.76,15,17.76s3.32-.56,4.32-1.5.74-3.34,1.81-4.2,3.37-.06,4.5-.83S26.81,8,28,7.34s3.33.44,4.57-.15,1.68-3,3-3.48,3.22.93,4.54.53,2.11-2.69,3.46-3,3,1.41,4.41,1.21S50.44.11,51.81,0,54.62,1.85,56,1.85,58.83-.1,60.18,0s2.52,2.24,3.87,2.45S67.13.94,68.46,1.24s2.16,2.59,3.46,3,3.27-1,4.55-.53,1.73,2.88,3,3.48,3.39-.53,4.58.15,1.28,3.12,2.41,3.89,3.43,0,4.5.84.81,3.26,1.81,4.2,3.39.49,4.32,1.49.32,3.35,1.17,4.42,3.28,1,4,2.12-.18,3.36.5,4.55,3.1,1.46,3.7,2.7-.69,3.29-.19,4.57,2.84,1.9,3.25,3.22-1.18,3.14-.87,4.49,2.52,2.31,2.72,3.67-1.63,2.93-1.53,4.31S112,54.47,112,55.85Z" /><circle class="tr6-c" cx="56" cy="55.85" r="45" /><path class="tr6-d" d="M26.19,47.34a13.18,13.18,0,0,1-.59-3.89A12.88,12.88,0,0,1,45.8,32.9a10.32,10.32,0,0,1,19.36,5,10,10,0,0,1-.2,2l.2,0a9,9,0,0,1,8,5.07,9.65,9.65,0,0,1,2.65-.4,9.8,9.8,0,0,1-.07,19.59L26.7,64a8.33,8.33,0,0,1-.51-16.64" /><path class="tr6-e" d="M62.59,55.54c-.18,3.5-1.43,6.68-6.35,6.68s-6.36-3.17-6.36-6.68c0-6.23,5.59-16.36,6.36-16.36S62.92,49.07,62.59,55.54Z" /><path class="tr6-e" d="M41.78,68c-.16,3-1.24,5.8-5.51,5.8S30.75,71,30.75,68c0-5.4,4.85-14.2,5.52-14.2S42.07,62.34,41.78,68Z" /><path class="tr6-e" d="M40.6,36c-.12,2.2-.9,4.2-4,4.2s-4-2-4-4.2c0-3.91,3.5-10.27,4-10.27S40.8,32,40.6,36Z" /><g class="tr6-f"><path class="tr6-d" d="M66,83.75a9.53,9.53,0,0,1-.42-2.8A9.23,9.23,0,0,1,80,73.39a7.41,7.41,0,0,1,13.75,5l.14,0A6.48,6.48,0,0,1,99.71,82a6.91,6.91,0,0,1,1.89-.29,7,7,0,0,1,0,14.06l-35.2-.12A6,6,0,0,1,66,83.75" /></g><path class="tr6-e" d="M56,12.85a43,43,0,1,1-43,43,43,43,0,0,1,43-43m0-2a45,45,0,1,0,45,45,45,45,0,0,0-45-45Z" /><path class="tr6-e" d="M81.6,77c-.12,2.2-.9,4.2-4,4.2s-4-2-4-4.2c0-3.91,3.5-10.27,4-10.27S81.8,73,81.6,77Z" /></svg>';
allSVGs["troph7"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="-3 0 122 111.1"><path class="tr7-a" d="M116,55.55c0,5.93-6.79,10.72-8.53,16.07-1.8,5.55.82,13.4-2.54,18s-11.7,4.59-16.37,8-7.08,11.3-12.63,13.1c-5.36,1.74-12-3.17-17.93-3.17s-12.57,4.91-17.93,3.17c-5.55-1.8-8-9.74-12.63-13.1s-13-3.31-16.37-8-.74-12.47-2.54-18C6.79,66.27,0,61.48,0,55.55S6.79,44.83,8.53,39.47c1.8-5.55-.82-13.4,2.54-18s11.7-4.58,16.37-8S34.52,2.17,40.07.37c5.36-1.74,12,3.18,17.93,3.18S70.57-1.37,75.93.37c5.55,1.8,8,9.74,12.63,13.1s13,3.32,16.37,8,.74,12.48,2.54,18C109.21,44.83,116,49.61,116,55.55Z" /><path class="tr7-b" d="M44,7.05A21.16,21.16,0,0,1,50.2,8.53,24.9,24.9,0,0,0,58,10.28a24.9,24.9,0,0,0,7.8-1.75A21.16,21.16,0,0,1,72,7.05a5.35,5.35,0,0,1,1.65.24c2.29.74,4,3.21,5.85,5.82a24,24,0,0,0,5.08,5.81A24.28,24.28,0,0,0,91.77,22c3,.94,5.88,1.82,7.27,3.73s1.33,4.85,1.3,8a24.23,24.23,0,0,0,.73,7.82,23.52,23.52,0,0,0,3.9,6.52c1.93,2.57,3.76,5,3.76,7.48S106.9,60.45,105,63a23.66,23.66,0,0,0-3.9,6.52,24.32,24.32,0,0,0-.73,7.83c0,3.15.07,6.12-1.3,8s-4.24,2.79-7.27,3.73a24,24,0,0,0-7.16,3.08A24,24,0,0,0,79.53,98c-1.83,2.61-3.56,5.07-5.85,5.82a5.35,5.35,0,0,1-1.65.24,20.89,20.89,0,0,1-6.23-1.49,25.16,25.16,0,0,0-7.8-1.74,25.16,25.16,0,0,0-7.8,1.74A20.89,20.89,0,0,1,44,104.05a5.35,5.35,0,0,1-1.65-.24c-2.29-.75-4-3.21-5.85-5.82a24,24,0,0,0-5.08-5.81,24,24,0,0,0-7.16-3.08c-3-.94-5.88-1.83-7.27-3.73s-1.33-4.85-1.3-8a24.32,24.32,0,0,0-.73-7.83A23.52,23.52,0,0,0,11,63c-1.93-2.57-3.76-5-3.76-7.47S9.1,50.64,11,48.07a23.52,23.52,0,0,0,3.9-6.52,24.23,24.23,0,0,0,.73-7.82c0-3.15-.07-6.12,1.3-8S21.2,22.94,24.23,22a24.28,24.28,0,0,0,7.16-3.08,24,24,0,0,0,5.08-5.81C38.3,10.5,40,8,42.32,7.29A5.35,5.35,0,0,1,44,7.05m0-2a7.22,7.22,0,0,0-2.27.34c-5,1.64-7.29,8.85-11.49,11.91s-11.78,3-14.87,7.25S14.67,35.89,13,40.93c-1.58,4.87-7.76,9.22-7.76,14.62S11.45,65.29,13,70.16c1.64,5-.75,12.18,2.31,16.38S26,90.71,30.21,93.8s6.45,10.27,11.49,11.91a7.52,7.52,0,0,0,2.27.34c4.4,0,9.45-3.23,14-3.23s9.63,3.23,14,3.23a7.52,7.52,0,0,0,2.27-.34c5-1.64,7.29-8.86,11.49-11.91s11.78-3,14.87-7.26.67-11.33,2.31-16.38c1.58-4.87,7.76-9.22,7.76-14.61S104.55,45.8,103,40.93c-1.64-5,.75-12.18-2.31-16.38S90,20.39,85.79,17.3,79.34,7,74.3,5.39A7.22,7.22,0,0,0,72,5.05c-4.4,0-9.45,3.23-14,3.23S48.37,5.05,44,5.05Z" /><path class="tr7-b" d="M23.5,49.13c.17,4.46-.2,14.56.22,19a17,17,0,0,0,2.71,8.29c1.8,2.5,5,3.53,7.9,4.28C39.13,82,44,82.14,48.92,82.39a194.75,194.75,0,0,0,19.63.12A79.81,79.81,0,0,0,80,81.42c3-.57,6.42-1.33,8.79-3.4s3.36-5.07,3.8-8c.56-3.72,1.12-13.93,1.12-18.22" /><path class="tr7-c" d="M32.23,35.7a44.73,44.73,0,0,1,5.15-1.38A90.39,90.39,0,0,1,57.74,32.4a112.87,112.87,0,0,1,15.14,1.29c6.66,1,13.7,2.79,18.18,7.82,3.8,4.27,5.13,10.25,5,16,0,1.09-.5,2.54-1.57,2.39a1.64,1.64,0,0,1-1.11-1,10.24,10.24,0,0,1-.76-3.14c-.13-.82,0-2.28-.48-3a.82.82,0,0,0-1-.38,1,1,0,0,0-.46.84c-.39,2.75,1.33,5.45.65,8.19a2.44,2.44,0,0,1-1.78,1.95,2.18,2.18,0,0,1-2.06-1.15,6.49,6.49,0,0,1-.7-2.39L86,54.52a4.32,4.32,0,0,0-.63-1.93A1.49,1.49,0,0,0,83.62,52a2.09,2.09,0,0,0-.78,1.9c-.12,5,1.68,10.1,0,14.78-.36,1-1.23,2.15-2.28,1.87S79.19,69.06,79,68.2c-.94-3.66.07-7.85-1.65-11.31-.41-.83-1.71-2.2-2.52-.92a2.86,2.86,0,0,0-.32,1.29,66.06,66.06,0,0,1-.77,7.84,2.62,2.62,0,0,1-.87,1.67c-2.22,1.6-2.84-4.35-3-5.49C69.58,59.7,69,56.58,67.2,56a1.41,1.41,0,0,0-1.38.3c-.87.87-.63,2.88-.73,4l-.46,5.22a6.16,6.16,0,0,1-.33,1.75,1.63,1.63,0,0,1-2.53,1,3.47,3.47,0,0,1-1-1.22c-1.87-3.47-1.3-7.74-3.26-11.16a2.71,2.71,0,0,0-1.45-1.36c-2.66-.82-3.05,3.22-3,4.89.09,2,.22,4,.28,6a41,41,0,0,1,.19,5.86,3.44,3.44,0,0,1-.48,1.54,2.63,2.63,0,0,1-3.2.73c-2.15-1-2.5-3.59-2.75-5.67-.34-2.85-.64-5.71-1-8.55a3.42,3.42,0,0,0-.45-1.45c-.78-1.14-2-.94-3-.18a4.75,4.75,0,0,0-1.55,3.57,23.9,23.9,0,0,1-.26,3.49,2.71,2.71,0,0,1-1.93,2.28c-2,.31-2.71-2.44-2.88-3.93-.21-1.84,0-3.89-1.12-5.49a2,2,0,0,0-2-1c-2.64.75-2.28,5.9-2.22,7.91,0,1.19-.5,3.1-2.12,2.19a2.74,2.74,0,0,1-1-2.53c0-4.11.27-7.93-.61-12-.2-.9-.6-2-1.51-2.12s-1.71.79-1.86,1.72.07,1.88,0,2.82-.69,2-1.64,2c-1.17,0-1.78-1.38-1.94-2.54a16.93,16.93,0,0,1,2.61-11.51A17.63,17.63,0,0,1,32.23,35.7Z" /><path class="tr7-d" d="M29.26,41.61a1.31,1.31,0,0,0-.41,1.56c.37,1.24,2.51,2,3.29.74a1.6,1.6,0,0,0,0-1.61A2.14,2.14,0,0,0,29.26,41.61Z" /><path class="tr7-b" d="M37.92,39.08c-1.49.44-2.65,2.66-.42,3.3a2.35,2.35,0,0,0,2-.2A1.71,1.71,0,0,0,40,40,1.69,1.69,0,0,0,37.92,39.08Z" /><path class="tr7-e" d="M42.68,44.56a1,1,0,0,0-.71.9,1.48,1.48,0,0,0,.58,1.21c1.12.92,3.79.38,2.8-1.44A2.41,2.41,0,0,0,42.68,44.56Z" /><path class="tr7-b" d="M47,38A2,2,0,0,0,45,40c.13,1.47,2.13,1.94,3.14,1a1.79,1.79,0,0,0,.33-2.26A1.57,1.57,0,0,0,47,38Z" /><path class="tr7-e" d="M52.45,44.77a1.64,1.64,0,0,0,3.09-.49c.52-2.74-3.64-2.18-3.19.14A1.79,1.79,0,0,0,52.45,44.77Z" /><path class="tr7-d" d="M58.25,36.12a1.68,1.68,0,0,0-1,1.32,1.94,1.94,0,0,0,2.48,2.17A1.81,1.81,0,0,0,60.86,38,2,2,0,0,0,58.25,36.12Z" /><path class="tr7-b" d="M64.84,43.88A1.82,1.82,0,0,0,64.62,45a1.93,1.93,0,0,0,1.11,1.57c1.13.53,2.67,0,2.49-1.42C68,43.29,65.6,42.66,64.84,43.88Z" /><path class="tr7-b" d="M72,39.85a1.46,1.46,0,0,0,.3,1.55c1.21,1.44,3.12,0,2.78-1.63C74.66,38,72.48,38.61,72,39.85Z" /><path class="tr7-e" d="M76.7,44.32a1.64,1.64,0,0,0-.74,1,1.68,1.68,0,0,0,3,1.44A1.71,1.71,0,0,0,76.7,44.32Z" /><path class="tr7-d" d="M81.59,41.29a1.51,1.51,0,0,0,0,.86,1.79,1.79,0,0,0,3.15.44C86.09,40.21,82.07,39.62,81.59,41.29Z" /><polygon class="tr7-e" points="58 16.11 56.44 19.27 52.95 19.77 55.48 22.23 54.88 25.7 58 24.06 61.12 25.7 60.52 22.23 63.05 19.77 59.56 19.27 58 16.11" /><polygon class="tr7-b" points="72.02 17.91 71.05 19.88 68.87 20.2 70.45 21.73 70.08 23.9 72.02 22.88 73.97 23.9 73.6 21.73 75.18 20.2 73 19.88 72.02 17.91" /><polygon class="tr7-b" points="43.98 17.91 43 19.88 40.82 20.2 42.4 21.73 42.03 23.9 43.98 22.88 45.92 23.9 45.55 21.73 47.13 20.2 44.95 19.88 43.98 17.91" /></svg>';
allSVGs["troph8"] = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-3 0 118.77 110"><defs><clipPath id="tr8-a"><circle class="tr8-a" cx="55" cy="55" r="52" /></clipPath><clipPath id="tr8-b"><path class="tr8-a" d="M43.07,84.41c.12-.3.23-.59.34-.88.23-.59.45-1.17.64-1.72l0-.08c.32-1,.68-1.91,1-2.86.23-.62.45-1.25.64-1.88.14-.45.59-1.31,0-1.64a3.62,3.62,0,0,0-.55-.2,1.56,1.56,0,0,1-1-1.39L42.71,55.88H26.81l-.21,2.3-.46,5.27-.51,5.82c-.12,1.4-.27,2.8-.36,4.2a2.57,2.57,0,0,1-.18.83,1.64,1.64,0,0,1-.54.7c-.42.29-.93.34-1,.93a3.46,3.46,0,0,0,.36,1.63c.13.36.26.72.4,1.08.4,1,.79,2.08,1.17,3.13.2.57.42,1.16.66,1.78.11.28.21.56.33.86l.26.66c.24.58.47,1.16.73,1.77,2.55,6,5.38,20,6.65,22.13h1.35c1.27-2.15,4.1-16.16,6.65-22.13.26-.61.5-1.19.73-1.77C42.9,84.85,43,84.63,43.07,84.41Z" /></clipPath></defs><circle class="tr8-b" cx="55" cy="55" r="55" /><circle class="tr8-c" cx="55" cy="55" r="45" /><g class="tr8-d"><path class="tr8-e" d="M111.45,86.51c-3.34-4.32-20.54-5.61-22-5.71L79.27,85.92l-9.35-5.11c-2.14.16-18.57,1.49-21.83,5.7-3,3.83,0,19.35,0,19.35h63.36S114.41,90.34,111.45,86.51Z" /><path class="tr8-f" d="M87.72,61.78H71.82l-1.67,19c0,2.11,4.07,5.86,9.38,5.86s9.86-3.75,9.86-5.86Z" /><path class="tr8-g" d="M80,77.24c2.54.33,6.14-1.8,8.76-3.91l-.06-.63v0a12.62,12.62,0,0,1-8.45,3.69c-3.06,0-6.73-1.91-9.32-4.25l-.07.8h0A18.21,18.21,0,0,0,80,77.24Z" /><path class="tr8-h" d="M96.89,53.71c-1.43-.68-3.29,1-4.14,3.84s-.39,5.6,1,6.28,3.29-1,4.14-3.85S98.33,54.38,96.89,53.71Z" /><path class="tr8-h" d="M62.58,53.5c1.62-.53,3.52,1.37,4.24,4.24s0,5.64-1.61,6.17S61.7,62.53,61,59.66,61,54,62.58,53.5Z" /><path class="tr8-f" d="M97.49,49.05c0,12.53-7.93,26.67-17.72,26.67S62.05,61.58,62.05,49.05,70,30.36,79.77,30.36,97.49,36.53,97.49,49.05Z" /><polygon class="tr8-g" points="48.68 74.56 48.68 74.56 48.68 74.57 48.68 74.56" /><path class="tr8-i" d="M70.06,56.18a1.48,1.48,0,1,0-1.49-1.48A1.49,1.49,0,0,0,70.06,56.18Z" /><path class="tr8-i" d="M88.06,56.18a1.48,1.48,0,1,0-1.48-1.48A1.49,1.49,0,0,0,88.06,56.18Z" /><path class="tr8-j" d="M66,50.32c-.45-.76,1.94-1.12,4.36-1.1,4.06,0,6.23,2,4.28,1.92C73.2,51.08,66.15,50.54,66,50.32Z" /><path class="tr8-j" d="M92.33,50.49c.46-.75-1.92-1.16-4.34-1.19-4.06,0-6.27,1.89-4.32,1.85C85.13,51.11,92.2,50.71,92.33,50.49Z" /><path class="tr8-k" d="M84.18,65c-.84,4.73-8.47,4.73-9.31,0A5.55,5.55,0,0,0,84.18,65Z" /><path class="tr8-l" d="M76.42,60.4s0,0,0,0a.21.21,0,0,1,.12-.17,22.9,22.9,0,0,0,2.19-6.68c.55,0-.56,5.12-1,6.33a12.43,12.43,0,0,1,1.72-.11c1.64,0,3,.28,3,.63S81,61,79.4,61,76.51,60.74,76.42,60.4Z" /><path class="tr8-m" d="M97.71,42.84a5.42,5.42,0,0,0-.65-1.67c-2.64-5-6.67-9.14-12.33-10.53a21.31,21.31,0,0,0-5-.59,17.83,17.83,0,0,0-12.51,4.59c-1.56,0-3.84.23-1.05.71a4.83,4.83,0,0,0-3.46,1.75c4.35-1.63.76.08-.65,1.86-1.17,1.59,1.27-.77,2.28-.55a21.29,21.29,0,0,0-2.46,10.47,33.88,33.88,0,0,0,.69,6.61h1.18s.8-4.86,2.43-6.92c1.33-1.68,2-5.17,2.51-8.29a8.32,8.32,0,0,0,2.06,4.07s-1.08-2.42,0-3.48c0,0,1,3.72,2.35,4.64a3.43,3.43,0,0,1,.62-1.9s1.55,5.79,16.93,2.59c0,0,4.62,6,5.09,9.29h1.16a33.86,33.86,0,0,0,.68-6.61,23.58,23.58,0,0,0-1.11-7.45Z" /><path class="tr8-n" d="M52.3,40.68l-17.43.47H17.1S13.7,62,16.5,66.68s18.37.2,18.37.2,16.61,4.85,18.63-.2S52.3,40.68,52.3,40.68Z" /><path class="tr8-f" d="M43.07,84.41c.12-.3.23-.59.34-.88.23-.59.45-1.17.64-1.72l0-.08c.32-1,.68-1.91,1-2.86.23-.62.45-1.25.64-1.88.14-.45.59-1.31,0-1.64a3.62,3.62,0,0,0-.55-.2,1.56,1.56,0,0,1-1-1.39L42.71,55.88H26.81l-.21,2.3-.46,5.27-.51,5.82c-.12,1.4-.27,2.8-.36,4.2a2.57,2.57,0,0,1-.18.83,1.64,1.64,0,0,1-.54.7c-.42.29-.93.34-1,.93a3.46,3.46,0,0,0,.36,1.63c.13.36.26.72.4,1.08.4,1,.79,2.08,1.17,3.13.2.57.42,1.16.66,1.78.11.28.21.56.33.86l.26.66c.24.58.47,1.16.73,1.77,2.55,6,5.38,20,6.65,22.13h1.35c1.27-2.15,4.1-16.16,6.65-22.13.26-.61.5-1.19.73-1.77C42.9,84.85,43,84.63,43.07,84.41Z" /><path class="tr8-h" d="M50.84,47.71c-1.6-.46-3.36,1.52-3.91,4.42s.29,5.62,1.89,6.08,3.35-1.53,3.91-4.42S52.44,48.16,50.84,47.71Z" /><path class="tr8-h" d="M18.13,47.76c1.4-.61,3.08,1.19,3.74,4s.07,5.61-1.34,6.22-3.08-1.19-3.74-4S16.72,48.37,18.13,47.76Z" /><path class="tr8-o" d="M65.43,80.62c-1.88-1.89-6.55-3.5-11.34-4.37-1.55-.29-3.08-.52-4.48-.71-1.8-.23-3.38-.4-4.5-.5a73.77,73.77,0,0,1-4,11.8c-1.3,3-2.68,5.85-3.88,8.14a2.76,2.76,0,0,1-4.89,0c-1.2-2.29-2.58-5.09-3.88-8.14a76,76,0,0,1-4-11.8c-1.12.1-2.69.27-4.49.5-1.4.19-2.94.42-4.48.71-4.79.87-9.59,2.36-11.35,4.37C.5,84.68,5.08,109,5.08,109H64.43S69.5,84.68,65.43,80.62Z" /><path class="tr8-f" d="M52.48,43.15c0,12.52-7.94,26.67-17.72,26.67S17,55.67,17,43.15,25,24.46,34.76,24.46,52.48,30.62,52.48,43.15Z" /><path class="tr8-n" d="M31.5,34.68s2,9,20.89,6.22c-.9-11-8.45-16.44-17.63-16.44C25,24.46,17,30.62,17,43.15A17,17,0,0,0,31.5,34.68Z" /><g class="tr8-p"><path class="tr8-g" d="M34.76,69.82c-3.22,0-6.23-1.54-8.83-4L23.5,64.68c2.62,2.55,7,6,11,6,3,0,7.38-2.45,10-5l-.92.11C41,68.28,38,69.82,34.76,69.82Z" /></g><path class="tr8-g" d="M35.82,51.42l.21.21a2.24,2.24,0,0,1,.4.68,1.42,1.42,0,0,1-1.19,2,4.67,4.67,0,0,1-2.48-.22,5.76,5.76,0,0,1-.69-.29l-.26-.14.29,0a25.48,25.48,0,0,0,2.9-.14,1,1,0,0,0,1-1.05,3.29,3.29,0,0,0-.08-.7Z" /><path class="tr8-e" d="M28.55,59.58c1.39,2.54,3.7,4.16,6.24,4s4.66-2,5.76-4.69Z" /><path class="tr8-q" d="M30.82,60.23a4.29,4.29,0,0,0,3.88,2.5,4.3,4.3,0,0,0,3.58-2.92Z" /><path class="tr8-i" d="M27.39,50.08a1.7,1.7,0,1,0-1.7-1.7A1.7,1.7,0,0,0,27.39,50.08Z" /><path class="tr8-i" d="M43.48,50.22a1.7,1.7,0,1,0-1.7-1.7A1.7,1.7,0,0,0,43.48,50.22Z" /><path class="tr8-j" d="M38.28,44.7c-.8.34.53-1.84,4.48-1.93,4.6-.1,6,2.12,4.19,1.48A12.24,12.24,0,0,0,38.28,44.7Z" /><path class="tr8-j" d="M31.9,44.7c.8.34-.53-1.84-4.48-1.92-4.6-.11-6,2.11-4.19,1.47A12.24,12.24,0,0,1,31.9,44.7Z" /></g><path class="tr8-f" d="M55,5A50,50,0,1,1,5,55,50.06,50.06,0,0,1,55,5m0-2a52,52,0,1,0,52,52A52,52,0,0,0,55,3Z" /></svg>';
allSVGs["label"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 24"><path class="s-label-a" d="M0,0,4.41,12,0,24H120l-4.41-12L120,0Z" /><text x="50%" style="fill: #fff; text-anchor: middle;" y="16">{{text}}</text></svg>';
allSVGs["star"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.98 75.33"><path class="s-star-a" d="M37.85,64.37,17.48,75.07a2.21,2.21,0,0,1-3.21-2.33l3.89-22.67a3.53,3.53,0,0,0-1-3.13L.67,30.88a2.21,2.21,0,0,1,1.22-3.77L24.66,23.8a3.54,3.54,0,0,0,2.67-1.94L37.51,1.23a2.21,2.21,0,0,1,4,0L51.66,21.86a3.52,3.52,0,0,0,2.66,1.94l22.77,3.31a2.21,2.21,0,0,1,1.22,3.77L61.83,46.94a3.53,3.53,0,0,0-1,3.13l3.89,22.67a2.21,2.21,0,0,1-3.21,2.33L41.14,64.37A3.49,3.49,0,0,0,37.85,64.37Z" /></svg>';
// summer
//allSVGs["captain2020"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 134 111.92"><path class="s-cap-a" d="M106.6,95.56c-1,1-3.35.45-4.38,1.34s-.87,3.32-2,4.13-3.37-.06-4.53.67-1.35,3.15-2.56,3.79-3.32-.57-4.57,0-1.81,2.91-3.1,3.36-3.2-1-4.52-.7-2.22,2.61-3.57,2.86-3-1.52-4.36-1.37-2.59,2.25-4,2.3-2.74-1.94-4.11-2-2.89,1.84-4.25,1.69S58.31,109.28,57,109s-3.13,1.39-4.46,1-2-2.66-3.34-3.12-3.3.91-4.56.36-1.62-2.94-2.84-3.58-3.39.4-4.56-.33-1.16-3.15-2.27-4-3.41-.11-4.46-1-.68-3.29-1.65-4.26-3.38-.63-4.27-1.66-.2-3.36-1-4.46-3.24-1.11-4-2.27.31-3.35-.33-4.56-3-1.59-3.58-2.84.81-3.27.36-4.56-2.77-2-3.12-3.34,1.29-3.11,1-4.46-2.44-2.41-2.59-3.77S13.09,59.35,13,58s-2-2.74-2-4.11,2.14-2.59,2.3-4-1.62-3-1.37-4.36,2.51-2.24,2.86-3.57-1.15-3.22-.7-4.52,2.81-1.84,3.36-3.1-.66-3.35,0-4.57,3.05-1.4,3.79-2.56-.15-3.42.67-4.53,3.22-.92,4.13-2,.35-3.4,1.33-4.38,3.35-.44,4.38-1.33.87-3.32,2-4.13,3.37,0,4.53-.67,1.35-3.15,2.56-3.79,3.32.56,4.57,0,1.81-2.91,3.1-3.36,3.2,1.06,4.52.7,2.22-2.6,3.57-2.86,3,1.52,4.36,1.37,2.59-2.25,4-2.3S67.65,2,69,2,71.91.16,73.27.31,75.69,2.64,77,2.9s3.13-1.39,4.46-1,2,2.67,3.34,3.12,3.3-.91,4.56-.36S91,7.56,92.24,8.21s3.39-.41,4.56.33,1.16,3.15,2.27,4,3.41.1,4.46,1,.68,3.29,1.65,4.27,3.38.62,4.27,1.65.2,3.37,1,4.46,3.24,1.12,4,2.27-.31,3.36.33,4.56,3,1.59,3.58,2.84-.81,3.27-.36,4.56,2.77,2,3.12,3.35-1.29,3.11-1,4.45,2.44,2.41,2.59,3.77-1.74,2.88-1.69,4.25,2.05,2.75,2,4.12-2.14,2.59-2.3,3.95,1.62,3,1.37,4.37-2.51,2.24-2.86,3.56,1.15,3.22.7,4.52-2.81,1.84-3.36,3.1.66,3.36,0,4.58-3,1.39-3.79,2.56.15,3.41-.67,4.52-3.22.92-4.13,2S107.58,94.58,106.6,95.56Z" /><path class="s-cap-b" d="M0,44.46,4.92,56,0,67.46H134L129.08,56,134,44.46Z" /><circle class="s-cap-b" cx="67" cy="55.96" r="50" /><path class="s-cap-a" d="M67,10A46,46,0,1,1,21,56,46,46,0,0,1,67,10m0-1a47,47,0,1,0,47,47A47,47,0,0,0,67,9Z" /><circle class="s-cap-c" cx="67" cy="55.96" r="43" /><path class="s-cap-d" d="M65.35,79.46,45,90.17a2.21,2.21,0,0,1-3.21-2.33l3.89-22.68a3.55,3.55,0,0,0-1-3.13L28.18,46A2.21,2.21,0,0,1,29.4,42.2l22.77-3.31A3.53,3.53,0,0,0,54.84,37L65,16.33a2.21,2.21,0,0,1,4,0L79.16,37a3.53,3.53,0,0,0,2.67,1.93L104.6,42.2A2.21,2.21,0,0,1,105.82,46L89.34,62a3.55,3.55,0,0,0-1,3.13l3.89,22.68A2.21,2.21,0,0,1,89,90.17L68.65,79.46A3.56,3.56,0,0,0,65.35,79.46Z" /><path class="s-cap-e" d="M44.1,26.67l.37,1.79a1.22,1.22,0,0,1-.31,1.11L43,30.77a.6.6,0,0,0,.37,1l1.73.18a1.12,1.12,0,0,1,.85.58L46.73,34a.65.65,0,0,0,1.16,0l.69-1.54a1,1,0,0,1,.73-.57L51,31.51a.64.64,0,0,0,.31-1.1l-1.2-1.08a1.18,1.18,0,0,1-.38-1L50,26.58A.58.58,0,0,0,49.1,26l-1.45.84a1.28,1.28,0,0,1-1.2,0l-1.62-.78A.52.52,0,0,0,44.1,26.67Z" /><path class="s-cap-e" d="M84.1,26.67l.37,1.79a1.22,1.22,0,0,1-.31,1.11L83,30.77a.6.6,0,0,0,.37,1l1.73.18a1.12,1.12,0,0,1,.85.58L86.73,34a.65.65,0,0,0,1.16,0l.69-1.54a1,1,0,0,1,.73-.57L91,31.51a.64.64,0,0,0,.31-1.1l-1.2-1.08a1.18,1.18,0,0,1-.38-1L90,26.58A.58.58,0,0,0,89.1,26l-1.45.84a1.28,1.28,0,0,1-1.2,0l-1.62-.78A.52.52,0,0,0,84.1,26.67Z" /><path class="s-cap-e" d="M95.1,63.67l.37,1.79a1.22,1.22,0,0,1-.31,1.11L94,67.77a.6.6,0,0,0,.37,1l1.73.18a1.12,1.12,0,0,1,.85.58L97.73,71a.65.65,0,0,0,1.16,0l.69-1.54a1,1,0,0,1,.73-.57l1.69-.31a.64.64,0,0,0,.31-1.1l-1.2-1.08a1.18,1.18,0,0,1-.38-1l.23-1.72a.58.58,0,0,0-.86-.58l-1.45.84a1.28,1.28,0,0,1-1.2,0l-1.62-.78A.52.52,0,0,0,95.1,63.67Z" /><path class="s-cap-e" d="M63.5,86.76l.38,1.78a1.28,1.28,0,0,1-.32,1.12l-1.14,1.2a.59.59,0,0,0,.37,1l1.72.19a1.1,1.1,0,0,1,.85.57l.78,1.44a.64.64,0,0,0,1.15,0l.7-1.54a1,1,0,0,1,.73-.58l1.68-.31a.63.63,0,0,0,.31-1.09l-1.2-1.09a1.19,1.19,0,0,1-.37-1l.23-1.72a.58.58,0,0,0-.86-.57l-1.46.83a1.28,1.28,0,0,1-1.19,0l-1.63-.78A.52.52,0,0,0,63.5,86.76Z" /><path class="s-cap-e" d="M33.1,63.67l.37,1.79a1.22,1.22,0,0,1-.31,1.11L32,67.77a.6.6,0,0,0,.37,1l1.73.18a1.12,1.12,0,0,1,.85.58L35.73,71a.65.65,0,0,0,1.16,0l.69-1.54a1,1,0,0,1,.73-.57L40,68.51a.64.64,0,0,0,.31-1.1l-1.2-1.08a1.18,1.18,0,0,1-.38-1L39,63.58A.58.58,0,0,0,38.1,63l-1.45.84a1.28,1.28,0,0,1-1.2,0l-1.62-.78A.52.52,0,0,0,33.1,63.67Z" /><path class="s-cap-f" d="M53.34,44.82h1.57l2,6.24,2-6.24h1.5L57.61,53H56.07Z" /><path class="s-cap-f" d="M60.93,49.85V48c0-2.22,1-3.27,3.14-3.27s3,1,3.1,3H65.74c0-1.16-.54-1.68-1.65-1.68s-1.68.6-1.68,2v1.84c0,1.42.49,2,1.68,2s1.6-.52,1.65-1.67h1.43c-.06,2-1.06,2.95-3.1,2.95S60.93,52.07,60.93,49.85Z" /><path class="s-cap-f" d="M70.17,46.13H67.85V44.82H74v1.31H71.65V53H70.17Z" /><path class="s-cap-f" d="M76.25,44.82h1.52L80.66,53H79.08l-.63-1.85H75.52L74.88,53H73.37Zm1.8,5L77,46.52l-1.07,3.35Z" /><path class="s-cap-f" d="M49,66.21c0-2,.94-3.2,3.4-4.33,1.76-.8,2.35-1.41,2.35-2.42s-.59-1.52-1.83-1.52S51,58.55,51,59.79v.27H49.17v-.44c0-2.15,1.35-3.31,3.77-3.31s3.71,1.18,3.71,3.14c0,1.74-.92,2.82-3.3,3.87-1.72.76-2.35,1.31-2.45,2.18h5.73v1.67H49Z" /><path class="s-cap-f" d="M58.46,63.78V59.89c0-2.36,1.33-3.58,3.81-3.58s3.82,1.22,3.82,3.58v3.89c0,2.34-1.33,3.58-3.82,3.58S58.46,66.12,58.46,63.78Zm5.73-.1V60c0-1.4-.6-2-1.92-2s-1.9.64-1.9,2v3.7c0,1.4.6,2,1.9,2S64.19,65.08,64.19,63.68Z" /><path class="s-cap-f" d="M67.91,66.21c0-2,.93-3.2,3.39-4.33,1.76-.8,2.35-1.41,2.35-2.42s-.59-1.52-1.82-1.52-1.94.61-1.94,1.85v.27H68.08v-.44c0-2.15,1.35-3.31,3.76-3.31s3.71,1.18,3.71,3.14c0,1.74-.92,2.82-3.3,3.87-1.71.76-2.34,1.31-2.44,2.18h5.73v1.67H67.91Z" /><path class="s-cap-f" d="M77.37,63.78V59.89c0-2.36,1.33-3.58,3.81-3.58S85,57.53,85,59.89v3.89c0,2.34-1.33,3.58-3.82,3.58S77.37,66.12,77.37,63.78Zm5.73-.1V60c0-1.4-.61-2-1.92-2s-1.91.64-1.91,2v3.7c0,1.4.6,2,1.91,2S83.1,65.08,83.1,63.68Z" /></svg>';
// Winter 2021
//allSVGs["captain2020"] = '<svg id="skitser" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 203 171"><path class="s-capw-a" d="M186,85.5c0,11.19-6.07,21.09-10.11,30.81-4.18,10.09-7,21.34-14.64,28.94s-18.85,10.46-28.94,14.64c-9.72,4-19.62,10.11-30.81,10.11s-21.09-6.07-30.81-10.11c-10.09-4.18-21.34-7-28.94-14.64S31.29,126.4,27.11,116.31C23.07,106.59,17,96.69,17,85.5s6.07-21.09,10.11-30.81c4.18-10.09,7-21.34,14.64-28.94S60.6,15.29,70.69,11.11C80.41,7.07,90.31,1,101.5,1s21.09,6.07,30.81,10.11c10.09,4.18,21.34,7,28.94,14.64s10.46,18.85,14.64,28.94C179.93,64.41,186,74.31,186,85.5Z"/><path id="Path_855" data-name="Path 855" class="s-capw-b" d="M1,68.25,8.38,85.5,1,102.75H202L194.62,85.5,202,68.25Z"/><path class="s-capw-a" d="M177,85.5c0,7.93-5.16,15-7.48,22.1-2.41,7.42-2.44,16.11-6.94,22.28s-12.82,8.93-19.05,13.47-11.28,11.57-18.69,14c-7.16,2.33-15.41-.32-23.34-.32s-16.18,2.65-23.34.32c-7.41-2.4-12.52-9.48-18.69-14s-14.52-7.24-19-13.47S35.89,115,33.48,107.6C31.16,100.45,26,93.43,26,85.5s5.16-15,7.48-22.1c2.41-7.42,2.44-16.11,6.94-22.28s12.82-8.93,19-13.47,11.28-11.57,18.69-14c7.16-2.33,15.41.32,23.34.32s16.18-2.65,23.34-.32c7.41,2.4,12.52,9.48,18.69,14s14.52,7.24,19.05,13.47S167.11,56,169.52,63.4C171.84,70.55,177,77.57,177,85.5Z"/><path class="s-capw-c" d="M177,85.5c0,7.93-5.16,15-7.48,22.1-2.41,7.42-2.44,16.11-6.94,22.28s-12.82,8.93-19.05,13.47-11.28,11.57-18.69,14c-7.16,2.33-15.41-.32-23.34-.32s-16.18,2.65-23.34.32c-7.41-2.4-12.52-9.48-18.69-14s-14.52-7.24-19-13.47S35.89,115,33.48,107.6C31.16,100.45,26,93.43,26,85.5s5.16-15,7.48-22.1c2.41-7.42,2.44-16.11,6.94-22.28s12.82-8.93,19-13.47,11.28-11.57,18.69-14c7.16-2.33,15.41.32,23.34.32s16.18-2.65,23.34-.32c7.41,2.4,12.52,9.48,18.69,14s14.52,7.24,19.05,13.47S167.11,56,169.52,63.4C171.84,70.55,177,77.57,177,85.5Z"/><path class="s-capw-b" d="M174,85.5c0,7.61-5.11,14.31-7.33,21.17-2.31,7.12-2.2,15.53-6.51,21.45s-12.42,8.45-18.4,12.8S131,152.16,123.91,154.47c-6.86,2.23-14.8-.47-22.41-.47s-15.55,2.7-22.41.47c-7.11-2.31-11.93-9.24-17.85-13.55s-14.05-6.82-18.4-12.8-4.2-14.33-6.51-21.45C34.11,99.81,29,93.11,29,85.5s5.11-14.31,7.33-21.17c2.31-7.12,2.2-15.53,6.51-21.45s12.42-8.45,18.4-12.8S72,18.84,79.09,16.53C86,14.3,93.89,17,101.5,17s15.55-2.7,22.41-.47c7.11,2.31,11.93,9.24,17.85,13.55s14.05,6.82,18.4,12.8,4.2,14.33,6.51,21.45C168.89,71.19,174,77.89,174,85.5Z"/><path class="s-capw-d" d="M171.14,85c0,7.29-5.06,13.68-7.19,20.25-2.21,6.81-2,14.94-6.08,20.61s-12,8-17.73,12.14-10.21,10.91-17,13.12c-6.57,2.13-14.2-.62-21.48-.62s-14.91,2.75-21.48.62c-6.81-2.21-11.35-9-17-13.12s-13.57-6.42-17.73-12.14-3.87-13.8-6.08-20.61c-2.14-6.57-7.19-13-7.19-20.25s5-13.67,7.19-20.24c2.21-6.81,2-14.94,6.08-20.61s12-8,17.73-12.14,10.21-10.91,17-13.12c6.57-2.13,14.2.61,21.48.61s14.91-2.74,21.48-.61c6.81,2.21,11.35,9,17,13.12s13.56,6.42,17.73,12.14S161.74,58,164,64.76C166.08,71.33,171.14,77.72,171.14,85Z"/><path class="s-capw-c" d="M171.14,85c0,7.29-5.06,13.68-7.19,20.25-2.21,6.81-2,14.94-6.08,20.61s-12,8-17.73,12.14-10.21,10.91-17,13.12c-6.57,2.13-14.2-.62-21.48-.62s-14.91,2.75-21.48.62c-6.81-2.21-11.35-9-17-13.12s-13.57-6.42-17.73-12.14-3.87-13.8-6.08-20.61c-2.14-6.57-7.19-13-7.19-20.25s5-13.67,7.19-20.24c2.21-6.81,2-14.94,6.08-20.61s12-8,17.73-12.14,10.21-10.91,17-13.12c6.57-2.13,14.2.61,21.48.61s14.91-2.74,21.48-.61c6.81,2.21,11.35,9,17,13.12s13.56,6.42,17.73,12.14S161.74,58,164,64.76C166.08,71.33,171.14,77.72,171.14,85Z"/><path class="s-capw-e" d="M134.77,58.3l-.26-1,.64.33a.5.5,0,0,0,.44-.89l-1.42-.71-.13-.48,1.3.66A.5.5,0,0,0,136,56a.51.51,0,0,0-.22-.67l-2.08-1-.14-.52,1.72.86a.49.49,0,1,0,.44-.88l-2.5-1.26-.12-.45.32.16a.49.49,0,1,0,.44-.88l-1.11-.56-.11-.42,1.11-1.11.43.11.55,1.11.09.12a.5.5,0,0,0,.57.1.49.49,0,0,0,.22-.67l-.16-.32.45.12,1.26,2.51.09.12a.5.5,0,0,0,.57.1.49.49,0,0,0,.22-.67l-.86-1.72.52.14,1.05,2.09a.34.34,0,0,0,.09.12.5.5,0,0,0,.57.1.51.51,0,0,0,.22-.67L139,50.66l.47.12.72,1.43a.38.38,0,0,0,.09.13.5.5,0,0,0,.79-.58l-.32-.64,1,.26a.49.49,0,1,0,.25-1l-1-.26.6-.39A.5.5,0,0,0,141,49l-1.33.88-.48-.13,1.22-.8a.49.49,0,1,0-.55-.82L138,49.36l-.52-.14,1.6-1.06a.49.49,0,1,0-.54-.82l-2.34,1.54-.45-.12.3-.2a.49.49,0,0,0-.54-.82l-1,.68L134,48.3l-.41-1.52.31-.31,1.24.07a.49.49,0,1,0,0-1l-.35,0,.33-.33,2.79.16a.5.5,0,0,0,.06-1l-1.92-.11.38-.38,2.33.14a.51.51,0,0,0,.52-.47.5.5,0,0,0-.47-.52L137.43,43l.34-.35,1.59.09a.49.49,0,0,0,.53-.46.5.5,0,0,0-.47-.52l-.71,0,.7-.7a.49.49,0,0,0,0-.69.48.48,0,0,0-.7,0l-.7.7,0-.72a.5.5,0,0,0-1,.06l.09,1.59-.34.35-.09-1.45a.5.5,0,0,0-.52-.47.49.49,0,0,0-.46.53l.13,2.32-.38.38-.11-1.92a.49.49,0,0,0-.52-.46.5.5,0,0,0-.47.52l.17,2.8-.33.33,0-.36a.49.49,0,0,0-.53-.46.48.48,0,0,0-.46.52l.07,1.23-.31.31-1.52-.41-.11-.42.68-1a.5.5,0,0,0-.14-.69.51.51,0,0,0-.69.14l-.19.31-.12-.46,1.53-2.34a.49.49,0,1,0-.82-.54l-1.06,1.61-.14-.52,1.28-1.95a.49.49,0,1,0-.82-.54l-.8,1.21-.13-.47.88-1.34a.49.49,0,1,0-.82-.54l-.4.6-.25-1a.5.5,0,0,0-1,.26l.26,1-.64-.33a.5.5,0,0,0-.66.22.48.48,0,0,0,.09.57.45.45,0,0,0,.13.1l1.42.71.13.48-1.3-.66a.5.5,0,0,0-.66.22.48.48,0,0,0,.09.57l.13.1,2.08,1,.14.52-1.72-.86a.5.5,0,0,0-.66.22.49.49,0,0,0,.09.57.38.38,0,0,0,.13.09l2.5,1.26.12.45-.32-.16a.5.5,0,0,0-.66.22.49.49,0,0,0,.09.57.38.38,0,0,0,.13.09l1.1.56.12.42L129.31,47l-.42-.11-.55-1.11a.5.5,0,0,0-.89.45l.16.32-.45-.12L125.91,44a.5.5,0,0,0-.89.45l.87,1.72-.52-.14-1.05-2.09a.49.49,0,1,0-.88.45l.65,1.29-.47-.12-.72-1.43a.49.49,0,1,0-.88.45l.32.64-1-.26a.49.49,0,0,0-.6.35.48.48,0,0,0,.35.6l1,.26-.59.39a.5.5,0,0,0-.15.69l.07.07a.49.49,0,0,0,.62.07l1.33-.88.47.13-1.21.8a.49.49,0,0,0-.14.68l.06.08a.5.5,0,0,0,.62.06l2-1.28.52.14L124,48.14a.5.5,0,0,0-.14.68l.07.08a.5.5,0,0,0,.62.06l2.34-1.54.45.12-.3.2a.49.49,0,0,0-.14.68l.06.08a.5.5,0,0,0,.62.07l1-.69.42.12.41,1.52-.31.31-1.24-.07a.49.49,0,0,0-.52.46.51.51,0,0,0,.14.38.49.49,0,0,0,.32.14l.36,0-.33.33-2.8-.16a.5.5,0,0,0-.52.47.52.52,0,0,0,.47.52L127,52l-.38.38-2.33-.14a.5.5,0,0,0-.52.47.53.53,0,0,0,.14.38.52.52,0,0,0,.32.14l1.45.08-.35.35-1.59-.09a.49.49,0,0,0-.52.46.48.48,0,0,0,.15.38.45.45,0,0,0,.32.14l.71.05-.7.7a.49.49,0,1,0,.7.7l.7-.71,0,.72a.52.52,0,0,0,.14.32.51.51,0,0,0,.38.14.5.5,0,0,0,.47-.52l-.1-1.59.35-.35.08,1.45a.46.46,0,0,0,.15.32A.5.5,0,0,0,127,56a.49.49,0,0,0,.46-.53l-.14-2.32.39-.38.11,1.92a.49.49,0,0,0,.14.32.51.51,0,0,0,.38.14.49.49,0,0,0,.46-.52l-.16-2.8.33-.33,0,.36a.5.5,0,0,0,.14.32.49.49,0,0,0,.38.14.49.49,0,0,0,.47-.52l-.08-1.23.31-.31,1.53.41.11.42-.68,1a.5.5,0,0,0,.06.62l.08.07a.5.5,0,0,0,.68-.14l.2-.31.12.46-1.54,2.34a.49.49,0,0,0,.07.62l.07.06a.5.5,0,0,0,.69-.14l1-1.61.14.52-1.28,2a.49.49,0,0,0,.07.62l.07.06a.5.5,0,0,0,.69-.14l.8-1.21.12.47-.87,1.34a.5.5,0,0,0,.06.62l.08.06a.49.49,0,0,0,.68-.14l.39-.6.26,1a.45.45,0,0,0,.13.22.52.52,0,0,0,.48.13A.5.5,0,0,0,134.77,58.3Z"/><path class="s-capw-e" d="M74.06,38l-.26,1,.64-.32a.49.49,0,0,1,.66.22.48.48,0,0,1-.22.66l-1.42.72-.13.47,1.3-.65a.5.5,0,0,1,.66.22.49.49,0,0,1-.22.66L73,42l-.14.52,1.72-.87a.5.5,0,0,1,.44.89l-2.5,1.25-.12.46.32-.17a.5.5,0,0,1,.44.89l-1.1.55-.12.42L73.05,47l.42-.11L74,45.82a.64.64,0,0,1,.1-.13.49.49,0,0,1,.79.57l-.16.32.45-.12L76.45,44a.64.64,0,0,1,.1-.13.48.48,0,0,1,.57-.09.5.5,0,0,1,.22.66l-.87,1.72L77,46,78,43.9a.6.6,0,0,1,.09-.13.49.49,0,0,1,.79.57l-.65,1.3.47-.13.72-1.42a.6.6,0,0,1,.09-.13.49.49,0,0,1,.79.57l-.32.64,1-.26a.5.5,0,0,1,.25,1l-1,.25.59.4a.49.49,0,0,1,.15.68.5.5,0,0,1-.69.14L79,46.47l-.47.12,1.21.8a.5.5,0,0,1-.54.83l-2-1.28-.52.13,1.61,1.06a.5.5,0,0,1-.55.83l-2.34-1.54-.45.12.3.19a.5.5,0,0,1,.14.69.49.49,0,0,1-.68.14l-1-.68L73.3,48l-.41,1.52.31.31,1.24-.07a.5.5,0,0,1,.06,1l-.36,0,.33.33,2.8-.16a.49.49,0,1,1,0,1L75.4,52l.38.38,2.33-.13a.49.49,0,0,1,.52.46.48.48,0,0,1-.46.52l-1.45.09.35.35,1.59-.1a.51.51,0,0,1,.52.47.5.5,0,0,1-.47.52l-.71,0,.7.7a.49.49,0,0,1-.7.7l-.7-.7,0,.71a.5.5,0,0,1-.52.47.51.51,0,0,1-.47-.52l.1-1.6L76,54l-.08,1.45a.5.5,0,0,1-1-.06l.14-2.33-.39-.38-.11,1.92a.5.5,0,0,1-.52.47.49.49,0,0,1-.46-.53l.16-2.79-.33-.33,0,.36a.49.49,0,0,1-.52.46.51.51,0,0,1-.47-.52l.08-1.24-.31-.31-1.53.41-.11.42.68,1a.49.49,0,0,1-.82.54l-.2-.3-.12.45,1.54,2.34a.51.51,0,0,1-.14.69.5.5,0,0,1-.69-.15l-1-1.6-.14.52,1.28,2a.5.5,0,0,1-.83.54l-.8-1.22-.12.48L70,57.65a.49.49,0,0,1-.82.54l-.39-.59-.26.95a.5.5,0,0,1-1-.25l.26-1-.64.32a.49.49,0,0,1-.57-.79.38.38,0,0,1,.13-.09l1.42-.72.13-.47-1.3.65a.5.5,0,0,1-.66-.22.5.5,0,0,1,.09-.57.38.38,0,0,1,.13-.09l2.08-1,.14-.52-1.72.87a.49.49,0,0,1-.57-.79l.13-.1,2.5-1.25.12-.46-.32.17a.49.49,0,0,1-.57-.79l.13-.1,1.11-.55.11-.42-1.11-1.12-.43.11-.55,1.11a.5.5,0,0,1-.66.22.48.48,0,0,1-.22-.66l.16-.32-.45.12-1.26,2.5a.5.5,0,0,1-.66.22.48.48,0,0,1-.22-.66l.86-1.72-.52.14-1,2.08a.49.49,0,1,1-.88-.44l.65-1.3-.47.13-.72,1.42a.49.49,0,0,1-.66.22.5.5,0,0,1-.22-.66l.32-.64-1,.26a.49.49,0,0,1-.47-.83.54.54,0,0,1,.22-.13l1-.25-.6-.4a.49.49,0,0,1-.14-.68L60.7,49a.5.5,0,0,1,.62-.06l1.33.87.48-.12-1.22-.8a.5.5,0,0,1-.14-.68.27.27,0,0,1,.07-.08.5.5,0,0,1,.62-.07l1.94,1.28.52-.13-1.6-1.06a.49.49,0,0,1-.14-.68.24.24,0,0,1,.06-.08.49.49,0,0,1,.62-.07l2.34,1.54.45-.12-.3-.19a.5.5,0,0,1-.14-.69l.06-.08a.5.5,0,0,1,.62-.06l1,.68.42-.11.41-1.52-.31-.31-1.24.07a.5.5,0,0,1-.52-.47.52.52,0,0,1,.47-.52l.35,0-.33-.33-2.79.16a.49.49,0,0,1-.38-.84.5.5,0,0,1,.32-.14l1.92-.11-.38-.38L63.54,44a.49.49,0,0,1-.52-.46.51.51,0,0,1,.14-.38.49.49,0,0,1,.32-.14L64.93,43l-.34-.35L63,42.7a.51.51,0,0,1-.53-.47.54.54,0,0,1,.15-.38.5.5,0,0,1,.32-.14l.71,0L63,41a.49.49,0,0,1,.7-.7l.7.7,0-.71a.52.52,0,0,1,.52-.47.5.5,0,0,1,.47.52l-.09,1.6.34.34.09-1.45a.49.49,0,0,1,.14-.32.51.51,0,0,1,.38-.14.49.49,0,0,1,.46.52l-.13,2.33.38.38.11-1.92a.5.5,0,0,1,.14-.32.52.52,0,0,1,.38-.15.49.49,0,0,1,.46.53l-.16,2.79.33.33,0-.36a.5.5,0,0,1,.15-.32.5.5,0,0,1,.84.38l-.07,1.24.31.31L71,45.67l.11-.42-.68-1a.5.5,0,0,1,.06-.62l.08-.06a.5.5,0,0,1,.69.14l.19.3.12-.45L70,41.18a.5.5,0,0,1,.07-.62.27.27,0,0,1,.08-.07.49.49,0,0,1,.68.15l1.06,1.6.14-.52-1.28-1.95a.49.49,0,0,1,.06-.62l.08-.06a.49.49,0,0,1,.68.14l.8,1.22.13-.48-.88-1.33a.5.5,0,0,1,.06-.62s0-.05.08-.06a.49.49,0,0,1,.68.14l.4.59.25-.95a.48.48,0,0,1,.13-.22.47.47,0,0,1,.48-.13A.49.49,0,0,1,74.06,38Z"/><path class="s-capw-e" d="M156.15,92.9l-.72.69,0-.71a.49.49,0,1,0-1,0l.06,1.6-.35.34-.06-1.45a.5.5,0,0,0-.51-.48.51.51,0,0,0-.48.52l.1,2.33-.39.37-.08-1.92a.5.5,0,0,0-.51-.48.52.52,0,0,0-.48.52l.12,2.8-.34.32V97a.51.51,0,0,0-.52-.47.49.49,0,0,0-.47.51l.05,1.24-.32.3-1.51-.43-.11-.43.7-1a.37.37,0,0,0,.07-.14.5.5,0,0,0-.2-.55.49.49,0,0,0-.68.13l-.21.3-.11-.45,1.58-2.32a.27.27,0,0,0,.07-.14.48.48,0,0,0-.19-.54.49.49,0,0,0-.69.13l-1.09,1.58-.13-.52,1.32-1.92s0-.1.07-.14a.51.51,0,0,0-.2-.55.51.51,0,0,0-.69.13l-.81,1.2-.12-.48.9-1.31a.47.47,0,0,0,.06-.15.48.48,0,0,0-.19-.54.5.5,0,0,0-.69.13l-.4.59-.24-1a.49.49,0,0,0-1,.23l.24,1-.63-.34a.5.5,0,0,0-.67.21.5.5,0,0,0,.21.67l1.41.74.12.48-1.29-.68a.48.48,0,0,0-.66.21.49.49,0,0,0,.2.67l2.07,1.08.13.52-1.71-.89a.48.48,0,0,0-.66.2.49.49,0,0,0,.2.67l2.48,1.3.12.46-.32-.17a.5.5,0,0,0-.67.21.49.49,0,0,0,.21.66l1.1.58.1.43-1.13,1.09-.42-.12-.54-1.12a.49.49,0,1,0-.89.43l.16.32-.45-.13-1.21-2.52a.49.49,0,0,0-.66-.23.48.48,0,0,0-.23.65l.83,1.74-.52-.15-1-2.1a.49.49,0,0,0-.89.42l.63,1.31-.47-.13-.69-1.44a.49.49,0,1,0-.89.43l.31.64-1-.27a.49.49,0,0,0-.61.34.5.5,0,0,0,.34.61l.95.27-.6.38a.5.5,0,0,0,.53.84l1.34-.85.48.13-1.23.78a.49.49,0,0,0,.53.83l2-1.24.51.15-1.62,1a.5.5,0,1,0,.53.84l2.36-1.5.45.13-.3.19a.49.49,0,0,0-.15.68.5.5,0,0,0,.68.16l1-.66.42.12.38,1.53-.31.3-1.24-.09a.49.49,0,0,0-.53.45.5.5,0,0,0,.46.53l.36,0-.34.32-2.79-.21a.49.49,0,0,0-.08,1l1.92.15-.39.37-2.32-.17a.49.49,0,0,0-.53.45.49.49,0,0,0,.45.53l1.45.11-.35.34L140.9,106a.49.49,0,0,0-.08,1l.72.06-.72.69a.5.5,0,0,0,.69.71l.71-.69,0,.71a.49.49,0,0,0,.51.48.5.5,0,0,0,.46-.36.77.77,0,0,0,0-.15l-.07-1.6.36-.34.05,1.45a.49.49,0,0,0,1,.12.41.41,0,0,0,0-.16l-.09-2.33.38-.37.08,1.92a.5.5,0,0,0,.51.48.5.5,0,0,0,.46-.36.78.78,0,0,0,0-.16l-.11-2.8.33-.32,0,.36a.49.49,0,0,0,.51.47.48.48,0,0,0,.45-.36.25.25,0,0,0,0-.15L147.1,103l.32-.3,1.51.43.11.43-.7,1a.49.49,0,1,0,.81.56l.21-.3.11.45-1.58,2.32a.49.49,0,1,0,.81.55l1.09-1.58.13.52L148.6,109a.5.5,0,1,0,.82.56l.82-1.2.12.48-.9,1.31a.49.49,0,1,0,.81.56l.4-.59.24,1a.5.5,0,0,0,1,0,.53.53,0,0,0,0-.25l-.24-1,.64.34a.49.49,0,0,0,.66-.21.3.3,0,0,0,0-.1.49.49,0,0,0-.24-.57l-1.42-.74-.11-.48,1.28.68a.5.5,0,0,0,.67-.21.32.32,0,0,0,0-.09.5.5,0,0,0-.24-.58l-2.06-1.08-.13-.52,1.7.89a.49.49,0,0,0,.67-.2l0-.1a.48.48,0,0,0-.24-.57l-2.48-1.3-.11-.46.31.17a.5.5,0,0,0,.67-.21.36.36,0,0,0,0-.09.5.5,0,0,0-.25-.57l-1.09-.58-.11-.43,1.14-1.09.42.12L152,103a.49.49,0,0,0,.92-.08.48.48,0,0,0,0-.35l-.15-.32.45.13,1.21,2.52a.5.5,0,0,0,.92-.07.53.53,0,0,0,0-.35l-.83-1.74.51.15,1,2.1a.49.49,0,0,0,.66.23.48.48,0,0,0,.26-.31.45.45,0,0,0,0-.34l-.63-1.31.47.13.69,1.44a.49.49,0,0,0,.66.23.45.45,0,0,0,.26-.31.43.43,0,0,0,0-.35l-.3-.64.95.27a.49.49,0,0,0,.61-.34.5.5,0,0,0-.34-.61l-.95-.27.6-.38a.48.48,0,0,0,.21-.28.47.47,0,0,0-.05-.4.49.49,0,0,0-.68-.16l-1.35.85-.47-.13,1.22-.78a.45.45,0,0,0,.21-.28.48.48,0,0,0-.05-.4.49.49,0,0,0-.68-.15l-2,1.24-.52-.15,1.62-1a.54.54,0,0,0,.22-.28.51.51,0,0,0-.06-.4.49.49,0,0,0-.68-.16l-2.37,1.5-.45-.13.3-.19a.48.48,0,0,0,.21-.28.47.47,0,0,0-.05-.4.5.5,0,0,0-.68-.16l-1.05.66-.42-.12-.38-1.53.31-.3,1.24.09a.48.48,0,0,0,.51-.35.36.36,0,0,0,0-.1.49.49,0,0,0-.46-.53l-.35,0,.33-.32,2.8.21a.5.5,0,0,0,.51-.35s0-.07,0-.1a.5.5,0,0,0-.46-.53l-1.92-.15.39-.37,2.32.17a.5.5,0,0,0,.52-.35.34.34,0,0,0,0-.1.49.49,0,0,0-.45-.53l-1.45-.11.36-.34,1.59.12a.5.5,0,0,0,.51-.35s0-.07,0-.1a.49.49,0,0,0-.46-.53l-.71-.06.71-.69a.38.38,0,0,0,.13-.22.47.47,0,0,0-.12-.47A.48.48,0,0,0,156.15,92.9Z"/><path class="s-capw-e" d="M109.7,141l-.8-.59.7-.15a.49.49,0,0,0-.2-1l-1.56.33-.4-.29,1.42-.3a.5.5,0,1,0-.21-1l-2.28.49-.43-.32,1.88-.4a.49.49,0,0,0,.38-.59.51.51,0,0,0-.59-.38l-2.74.59-.37-.28.35-.07a.49.49,0,0,0,.38-.59.51.51,0,0,0-.59-.38l-1.21.26-.35-.26.17-1.56.4-.18,1.13.52.15,0a.49.49,0,0,0,.26-.94l-.33-.15.43-.19,2.55,1.17.15,0a.49.49,0,0,0,.26-.94l-1.75-.8L107,133l2.12,1a.42.42,0,0,0,.15,0,.5.5,0,0,0,.5-.28.49.49,0,0,0-.24-.66l-1.32-.6.45-.2,1.45.66a.44.44,0,0,0,.15,0,.49.49,0,0,0,.5-.29.48.48,0,0,0-.24-.65l-.65-.3.91-.4a.5.5,0,0,0-.4-.91l-.91.4.22-.68a.49.49,0,1,0-.94-.3l-.49,1.52-.45.19.45-1.38a.49.49,0,0,0-.94-.3l-.72,2.22-.49.21.59-1.83a.49.49,0,1,0-.94-.3l-.86,2.67-.43.18.11-.34a.49.49,0,0,0-.32-.62.5.5,0,0,0-.62.32l-.38,1.18-.4.17-1.27-.93,0-.43,1-.72a.49.49,0,1,0-.58-.8l-.29.2,0-.46,2.29-1.63a.48.48,0,0,0,.11-.68.49.49,0,0,0-.69-.12L102,129.26l0-.54,1.9-1.35a.49.49,0,0,0,.12-.69.51.51,0,0,0-.69-.12l-1.18.85,0-.49,1.3-.93a.49.49,0,1,0-.57-.8l-.58.41.1-1a.49.49,0,1,0-1-.11l-.11,1-.48-.53a.48.48,0,0,0-.69,0,.49.49,0,0,0,0,.7l1.07,1.18,0,.49-1-1.08a.49.49,0,0,0-.73.66l1.56,1.73-.06.54-1.28-1.43a.5.5,0,0,0-.74.66l1.88,2.08,0,.47-.24-.27a.5.5,0,0,0-.7,0,.49.49,0,0,0,0,.7l.83.92-.05.44-1.44.63-.36-.26-.11-1.23a.5.5,0,1,0-1,.09l0,.36-.38-.28-.26-2.79a.49.49,0,0,0-.54-.44.51.51,0,0,0-.45.54l.19,1.91-.44-.32-.22-2.32a.49.49,0,0,0-1,.1l.13,1.44-.39-.29-.15-1.58a.49.49,0,1,0-1,.09l.06.71-.8-.58a.48.48,0,0,0-.69.1.5.5,0,0,0,.11.69l.8.59-.7.15a.49.49,0,0,0,0,1,.45.45,0,0,0,.16,0l1.56-.33.39.29-1.42.3a.51.51,0,0,0-.38.59.52.52,0,0,0,.43.39H93l2.28-.49.43.32-1.88.4a.49.49,0,0,0-.38.59.52.52,0,0,0,.43.39H94l2.74-.59.37.28-.35.07a.51.51,0,0,0-.38.59.52.52,0,0,0,.43.39H97l1.21-.26.35.26-.17,1.56-.4.18-1.12-.52a.51.51,0,0,0-.66.25.49.49,0,0,0,.25.65l.32.15-.42.19-2.55-1.17a.51.51,0,0,0-.66.25.49.49,0,0,0,.25.65l1.75.8-.5.22-2.12-1a.49.49,0,0,0-.41.9l1.32.6-.45.2-1.45-.66a.48.48,0,0,0-.65.24.5.5,0,0,0,.24.65l.65.3-.9.4a.5.5,0,0,0-.26.65.48.48,0,0,0,.4.29.52.52,0,0,0,.25,0l.91-.4-.22.68a.49.49,0,0,0,.32.62l.1,0a.49.49,0,0,0,.52-.34L93.4,139l.45-.19-.45,1.38a.5.5,0,0,0,.32.62l.1,0a.49.49,0,0,0,.52-.34l.72-2.22.49-.21L95,139.84a.5.5,0,0,0,.32.62l.1,0a.49.49,0,0,0,.52-.34l.86-2.67.43-.18-.11.34a.5.5,0,0,0,.32.62l.1,0a.5.5,0,0,0,.52-.34l.38-1.18.4-.17,1.27.93,0,.43-1,.72a.5.5,0,0,0-.11.69.46.46,0,0,0,.35.2.44.44,0,0,0,.34-.09l.29-.2,0,.46-2.28,1.63a.48.48,0,0,0-.12.68.49.49,0,0,0,.69.12L99.69,141l-.06.54-1.9,1.35a.5.5,0,0,0-.12.69.49.49,0,0,0,.35.2.46.46,0,0,0,.34-.08l1.18-.85,0,.49-1.3.93A.48.48,0,0,0,98,145a.5.5,0,0,0,.34.21.52.52,0,0,0,.34-.09l.59-.41-.11,1a.5.5,0,0,0,.44.55.49.49,0,0,0,.54-.44l.11-1,.48.53a.43.43,0,0,0,.31.16.47.47,0,0,0,.39-.12.5.5,0,0,0,0-.7l-1.07-1.18.06-.49,1,1.08a.47.47,0,0,0,.31.16.52.52,0,0,0,.39-.13.49.49,0,0,0,0-.69l-1.56-1.73.06-.54,1.29,1.43a.47.47,0,0,0,.31.16.49.49,0,0,0,.38-.13.48.48,0,0,0,0-.69l-1.88-2.08,0-.47.24.27a.52.52,0,0,0,.32.16.54.54,0,0,0,.38-.12.5.5,0,0,0,0-.7l-.83-.92,0-.44,1.44-.63.36.26.11,1.23a.51.51,0,0,0,.44.45h.1a.51.51,0,0,0,.45-.54l0-.36.38.28.27,2.79a.5.5,0,0,0,.43.44h.1a.5.5,0,0,0,.45-.54l-.18-1.91.43.32.22,2.32a.5.5,0,0,0,.44.44h.1a.49.49,0,0,0,.44-.54l-.13-1.44.39.29.15,1.58a.51.51,0,0,0,.44.45h.1a.51.51,0,0,0,.45-.54l-.07-.71.8.58a.43.43,0,0,0,.24.1.48.48,0,0,0,.45-.2A.5.5,0,0,0,109.7,141Z"/><path class="s-capw-e" d="M55.66,91.57l-.17,1L55.05,92a.5.5,0,0,0-.78.62l1,1.24-.09.49-.9-1.14a.49.49,0,0,0-.69-.08.48.48,0,0,0-.08.69L55,95.64l-.1.53-1.19-1.51a.51.51,0,0,0-.7-.08.5.5,0,0,0-.08.7l1.75,2.19-.08.46-.23-.28a.49.49,0,0,0-.69-.08.5.5,0,0,0-.08.7l.77,1-.07.44-1.48.54-.34-.28,0-1.24a.37.37,0,0,0,0-.15.5.5,0,0,0-.48-.33.51.51,0,0,0-.48.51l0,.36-.36-.3L51,96a.37.37,0,0,0,0-.15A.49.49,0,0,0,50,96l.06,1.92-.41-.34-.07-2.33,0-.15a.51.51,0,0,0-.48-.33.49.49,0,0,0-.48.51l.05,1.45-.38-.31,0-1.6a.4.4,0,0,0,0-.15.48.48,0,0,0-.48-.32.48.48,0,0,0-.48.5l0,.72-.76-.64a.49.49,0,0,0-.69.07.48.48,0,0,0,.06.69l.76.64-.71.1a.5.5,0,0,0,.15,1l1.58-.23.37.31-1.43.21a.49.49,0,1,0,.14,1L49,98.35l.41.34-1.9.29a.5.5,0,0,0-.42.56.49.49,0,0,0,.56.41l2.77-.41.36.3-.35,0a.49.49,0,0,0,.14,1l1.23-.18.33.28-.27,1.55-.41.15-1.09-.59a.51.51,0,0,0-.67.21.49.49,0,0,0,.21.66l.31.17-.44.17L47.31,102a.48.48,0,0,0-.66.2.49.49,0,0,0,.2.67l1.69.91-.5.19L46,102.82a.5.5,0,0,0-.46.88l1.28.68-.46.17-1.41-.75a.49.49,0,1,0-.47.87l.64.33-.94.35a.49.49,0,0,0-.29.63.48.48,0,0,0,.63.29l.93-.34-.26.67a.49.49,0,1,0,.92.36l.59-1.48.46-.17-.54,1.35a.49.49,0,1,0,.92.36l.86-2.17.5-.18-.7,1.79a.49.49,0,0,0,.28.64.5.5,0,0,0,.64-.28l1-2.61.44-.16-.13.34a.49.49,0,1,0,.92.36l.45-1.15.41-.15,1.21,1-.07.43-1.05.65a.48.48,0,0,0-.16.68.5.5,0,0,0,.68.16l.3-.19-.08.46-2.38,1.48a.5.5,0,0,0-.16.68.49.49,0,0,0,.68.15l1.64-1-.1.53-2,1.23a.49.49,0,1,0,.52.84l1.24-.77-.09.49-1.35.84a.49.49,0,1,0,.52.84l.61-.38-.17,1a.49.49,0,0,0,.4.57.5.5,0,0,0,.57-.4l.17-1,.45.56a.49.49,0,0,0,.69.08.5.5,0,0,0,.16-.56,1,1,0,0,0-.08-.14l-1-1.24.08-.49.9,1.14a.49.49,0,0,0,.85-.48.33.33,0,0,0-.07-.13l-1.45-1.83.09-.53,1.2,1.51a.5.5,0,0,0,.69.08.51.51,0,0,0,.16-.56.64.64,0,0,0-.08-.14L54,106.82l.08-.46.22.28a.49.49,0,0,0,.69.08.49.49,0,0,0,.08-.7l-.77-1,.08-.44,1.48-.54.33.28,0,1.24a.5.5,0,0,0,1,0v-.36l.35.3.09,2.8a.5.5,0,0,0,1,0l-.06-1.92.41.34.08,2.33a.49.49,0,1,0,1,0l0-1.45.37.31.05,1.6a.49.49,0,0,0,.51.47.48.48,0,0,0,.48-.5l0-.72.76.64a.5.5,0,0,0,.7-.07.49.49,0,0,0,.08-.48.45.45,0,0,0-.15-.21l-.76-.64.71-.1a.49.49,0,0,0,.41-.56.3.3,0,0,0,0-.1.49.49,0,0,0-.54-.32L61,107.1l-.38-.31,1.44-.21a.49.49,0,0,0,.41-.56.3.3,0,0,0,0-.1.49.49,0,0,0-.54-.32l-2.3.34-.42-.34,1.9-.29a.5.5,0,0,0,.42-.56s0-.06,0-.09a.49.49,0,0,0-.54-.32l-2.77.41-.36-.3.35,0a.5.5,0,0,0,.42-.56.29.29,0,0,0,0-.1.49.49,0,0,0-.53-.32l-1.23.18-.33-.28.27-1.55.41-.15,1.09.59a.5.5,0,0,0,.7-.61.49.49,0,0,0-.23-.26l-.32-.17.44-.17,2.47,1.33a.49.49,0,0,0,.69-.61.45.45,0,0,0-.23-.26l-1.69-.91.5-.19,2.06,1.11a.5.5,0,0,0,.47-.88l-1.28-.68.46-.17,1.4.75a.49.49,0,0,0,.67-.2.47.47,0,0,0,0-.4.51.51,0,0,0-.23-.27l-.63-.33.93-.35a.49.49,0,1,0-.34-.92l-.93.34.26-.67a.5.5,0,0,0-.28-.64.5.5,0,0,0-.64.28L62,98.81l-.46.17.53-1.35a.53.53,0,0,0,0-.35.47.47,0,0,0-.28-.29.5.5,0,0,0-.64.28l-.85,2.17-.51.18.71-1.79a.53.53,0,0,0,0-.35.56.56,0,0,0-.28-.29.49.49,0,0,0-.64.28l-1,2.61-.44.16.13-.34a.47.47,0,0,0,0-.35.55.55,0,0,0-.29-.29.5.5,0,0,0-.64.28l-.45,1.15-.41.15-1.21-1,.07-.43,1.06-.65a.49.49,0,0,0,.2-.59l0-.09a.5.5,0,0,0-.68-.16l-.31.19.08-.46L58,96.16a.48.48,0,0,0,.2-.58.3.3,0,0,0,0-.1.49.49,0,0,0-.68-.15l-1.63,1,.09-.53,2-1.23a.5.5,0,0,0,.2-.59.36.36,0,0,0,0-.09.5.5,0,0,0-.68-.16l-1.24.77.09-.49,1.35-.84a.48.48,0,0,0,.21-.59.41.41,0,0,0,0-.09.5.5,0,0,0-.68-.16l-.6.38.16-1a.43.43,0,0,0,0-.25.5.5,0,0,0-.38-.32A.5.5,0,0,0,55.66,91.57Z"/><path class="s-capw-f" d="M99,121.05,68.48,137.11a3.32,3.32,0,0,1-4.81-3.49l5.84-34A5.3,5.3,0,0,0,68,94.91L43.27,70.82a3.32,3.32,0,0,1,1.84-5.66l34.15-5a5.3,5.3,0,0,0,4-2.9L98.53,26.35a3.31,3.31,0,0,1,5.94,0L119.75,57.3a5.3,5.3,0,0,0,4,2.9l34.15,5a3.32,3.32,0,0,1,1.84,5.66L135,94.91a5.3,5.3,0,0,0-1.53,4.69l5.84,34a3.32,3.32,0,0,1-4.81,3.49L104,121.05A5.33,5.33,0,0,0,99,121.05Z"/><path class="s-capw-g" d="M91.65,69.09,87.6,81.32H85.32l-4-12.23h2.32l2.93,9.34,2.92-9.34Z"/><path class="s-capw-g" d="M92.52,76.63V73.79c0-3.33,1.49-4.92,4.66-4.92,3,0,4.48,1.44,4.57,4.45H99.64c-.07-1.75-.8-2.52-2.44-2.52s-2.49.9-2.49,3v2.77c0,2.12.73,3,2.49,3s2.37-.77,2.44-2.5h2.11c-.09,3-1.57,4.43-4.57,4.43C94,81.54,92.52,80,92.52,76.63Z"/><path class="s-capw-g" d="M111.83,71.05h-3.44V81.32H106.2V71.05h-3.44v-2h9.07Z"/><path class="s-capw-g" d="M118.46,78.55h-4.34l-.93,2.77h-2.25l4.28-12.23h2.25l4.26,12.23h-2.34Zm-3.75-1.89h3.15l-1.56-5Z"/><path class="s-capw-g" d="M76.8,100.39h8.67v2.55H73.92v-1.47c0-3.07,1.42-4.9,5.14-6.63,2.64-1.22,3.55-2.16,3.55-3.69s-.89-2.33-2.76-2.33-2.93.93-2.93,2.83v.41H74.16v-.67c0-3.29,2-5.07,5.72-5.07s5.62,1.8,5.62,4.8c0,2.67-1.4,4.32-5,5.93C77.91,98.21,77,99.05,76.8,100.39Z"/><path class="s-capw-g" d="M88.35,97.75v-6c0-3.61,2-5.48,5.76-5.48s5.78,1.87,5.78,5.48v6c0,3.58-2,5.47-5.78,5.47S88.35,101.33,88.35,97.75ZM97,97.6V91.94c0-2.14-.91-3.12-2.9-3.12s-2.88,1-2.88,3.12V97.6c0,2.14.91,3.13,2.88,3.13S97,99.74,97,97.6Z"/><path class="s-capw-g" d="M105.55,100.39h8.67v2.55H102.67v-1.47c0-3.07,1.42-4.9,5.14-6.63,2.64-1.22,3.56-2.16,3.56-3.69s-.89-2.33-2.77-2.33-2.93.93-2.93,2.83v.41h-2.76v-.67c0-3.29,2-5.07,5.72-5.07s5.62,1.8,5.62,4.8c0,2.67-1.4,4.32-5,5.93C106.66,98.21,105.7,99.05,105.55,100.39Z"/><path class="s-capw-g" d="M129.08,100.39v2.55H118.27v-2.55h4V90.23a10.62,10.62,0,0,1-4.45.82V88.72c2.19-.07,3.58-.67,4.59-2.11h2.74v13.78Z"/><path class="s-capw-h" d="M90,106.65l-3.39,10.24H84.66l-3.39-10.24h1.94l2.46,7.82,2.44-7.82Z"/><path class="s-capw-h" d="M91.2,106.12h1.92v1.71H91.2Zm.06,3h1.8v7.81h-1.8Z"/><path class="s-capw-h" d="M101.74,111.73v5.16H99.93v-5c0-1-.36-1.4-1.1-1.4a2,2,0,0,0-1.76,1.33v5.07H95.26v-7.81H96.8l.06,1.06a2.77,2.77,0,0,1,2.42-1.24C100.91,108.9,101.74,109.86,101.74,111.73Z"/><path class="s-capw-h" d="M107.77,115.43v1.46h-1.45c-1.55,0-2.21-.74-2.21-2.5v-3.91h-1.24v-1.4h1.27l.12-2h1.65v2h1.77v1.4h-1.77v3.85c0,.86.22,1.1,1,1.1Z"/><path class="s-capw-h" d="M110.63,113.76c0,1.26.51,1.85,1.67,1.85,1,0,1.46-.41,1.54-1.08h1.73c-.11,1.67-1.27,2.54-3.27,2.54-2.29,0-3.48-1.14-3.48-3.33v-1.53c0-2.16,1.18-3.31,3.39-3.31s3.4,1.17,3.4,3.32v1.3h-5Zm0-1.58h3.27c0-1.27-.5-1.82-1.63-1.82S110.63,110.91,110.63,112.18Z"/><path class="s-capw-h" d="M121.73,108.93v1.71h-.41a1.87,1.87,0,0,0-2.06,1.82v4.43h-1.81v-7.81H119l.08,1.43a2,2,0,0,1,2.1-1.58Z"/></svg>';
allSVGs["people"] = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 143.45 84.51"><defs><clipPath id="s-peo-a"><path class="s-peo-a" d="M121.22,59.54A1.42,1.42,0,0,1,120,58.3l-1.57-17.87h-15.9s-.05.54-.05.57l-.7,7.89-.43,5a21.36,21.36,0,0,1-.52,4.67,1.73,1.73,0,0,1-.83,1c-.43.2-5.37.48-5.37.5l1.29,8.18a27.94,27.94,0,0,0,29.11,0l1.29-8.18C124.16,59.8,122.34,59.63,121.22,59.54Z"/></clipPath><clipPath id="s-peo-b"><path class="s-peo-a" d="M40.36,60c.12-.3.23-.59.34-.88.23-.59.44-1.17.64-1.72l0-.08c.32-1,.68-1.91,1-2.86.23-.62.44-1.25.64-1.88.13-.45.58-1.31,0-1.64a3.16,3.16,0,0,0-.54-.2,1.56,1.56,0,0,1-1-1.39L40,31.42H24.09l-.2,2.3L23.43,39l-.51,5.82c-.13,1.4-.27,2.8-.37,4.2a2.57,2.57,0,0,1-.18.83,1.5,1.5,0,0,1-.54.7c-.41.29-.92.34-1,.93a3.58,3.58,0,0,0,.35,1.63c.13.36.27.72.41,1.08.4,1,.79,2.08,1.17,3.13.2.57.42,1.16.65,1.78l.34.86c.08.22.17.44.26.66.23.58.47,1.16.73,1.77,2.55,6,5.38,20,6.65,22.13h1.35c1.27-2.15,4.1-16.16,6.65-22.13.26-.61.5-1.19.73-1.77C40.19,60.39,40.28,60.17,40.36,60Z"/></clipPath></defs><path d="M138.54,28.84a9.2,9.2,0,0,0-1-4.21c-.56-1.08-1.8-1.71-2.17-2.9a7.49,7.49,0,0,1-.06-2.06,5.88,5.88,0,0,0-.49-2,6,6,0,0,0-1.71-2.34c-.69-.54-1.62-.78-2.11-1.55-.62-1-.45-2.31-1.05-3.37a5.87,5.87,0,0,0-2.48-2.38c-4.26-2.12-5.36-6.79-11.12-6.79A10.19,10.19,0,0,0,109,4.38a9.29,9.29,0,0,0-3.88-.84c-3.64,0-5.2,1.86-7.54,4.06-1.72,1.62-4.68,2.25-5.4,4.76a3.13,3.13,0,0,1-.36,1,2.54,2.54,0,0,1-1.52.7,6.67,6.67,0,0,0-4.72,5.2c-.16,1,.07,2-.36,2.88s-1.54,1.74-2.07,2.81a8.57,8.57,0,0,0-.91,3.55A8.25,8.25,0,0,0,84.94,35c2.74,2.38,2.23,7,6,8.45a1.45,1.45,0,0,1,.87.55,1.58,1.58,0,0,1,.1.65c0,5.17,6.85,7.36,10,3.39a2.73,2.73,0,0,0,1.81-1.58c2.38-5.05-1.19-12-3.19-16.56a8.69,8.69,0,0,0-1-1.75,20.25,20.25,0,0,0,4.88-5.77s4,4.94,12.72,5.87a28.37,28.37,0,0,1,4.44.8,8.56,8.56,0,0,0,.51,2.69,3.39,3.39,0,0,0-.61.21,5.48,5.48,0,0,0-2,1.81,13,13,0,0,0-1.82,11.07c1.34,4.56,8,8.26,10.53,2.29.35-.82.47-1.72.79-2.55.75-2,3.18-2.54,4.23-4.4a23.16,23.16,0,0,0,1.06-2.52C135.7,34.29,138.52,32.75,138.54,28.84Z"/><path class="s-peo-b" d="M121.22,59.54A1.42,1.42,0,0,1,120,58.3l-1.57-17.87h-15.9s-.05.54-.05.57l-.7,7.89-.43,5a21.36,21.36,0,0,1-.52,4.67,1.73,1.73,0,0,1-.83,1c-.43.2-5.37.48-5.37.5l1.29,8.18a27.94,27.94,0,0,0,29.11,0l1.29-8.18C124.16,59.8,122.34,59.63,121.22,59.54Z"/><path class="s-peo-b" d="M128,32.53c-1.12-.83-2.77.77-3.69,3.58s-.74,5.76.39,6.6,2.78-.78,3.69-3.59S129.08,33.36,128,32.53Z"/><path class="s-peo-b" d="M91.77,32.62c1.14-.82,2.93.56,4,3.09s1,5.24-.11,6.06-2.93-.57-4-3.1S90.64,33.43,91.77,32.62Z"/><path class="s-peo-c" d="M122.45,84.51l3.23-17.59a29.53,29.53,0,0,1-15,4c-5.5,0-13-2.53-17-5l4.79,18.59Z"/><path class="s-peo-d" d="M142.13,65.16C140,62.37,132,60.85,126.3,60.09L125,68.27l-2.56,16.24h19.68S145.1,69,142.13,65.16Z"/><path class="s-peo-d" d="M94.61,60.09c-5.74.76-13.67,2.28-15.83,5.07-3,3.83,0,19.35,0,19.35H98.47L95.9,68.27Z"/><g class="s-peo-e"><path class="s-peo-f" d="M110.46,54.36a12.85,12.85,0,0,1-8.82-4l-.1,1a12.79,12.79,0,0,0,8,3.51,12.52,12.52,0,0,0,8.31-2.23,14.9,14.9,0,0,0,1.48-1.26l.31-1.48C117.08,52.42,113.67,54.36,110.46,54.36Z"/></g><path class="s-peo-b" d="M104.23,21.92s4.08,5,12.89,6a23.55,23.55,0,0,1,7.29,1.79c1,.44,3.38,1.57,3.37,2.83a21.45,21.45,0,0,1-1.56,6.22,34.52,34.52,0,0,1-2.59,5.75,21.81,21.81,0,0,1-7.56,8.22,11.56,11.56,0,0,1-5.81,1.67c-7.65,0-12.87-7.82-15.38-14.14a39.34,39.34,0,0,1-2.17-8,.45.45,0,0,1,0-.2c.16-.48,2-1.09,2.46-1.36A27.48,27.48,0,0,0,97.82,29a25.81,25.81,0,0,0,3.74-3.34A15.66,15.66,0,0,0,104.23,21.92Z"/><path class="s-peo-f" d="M110.13,37.16a1.07,1.07,0,0,1,.21.21,2.3,2.3,0,0,1,.4.67,1.65,1.65,0,0,1,.11.57,1.56,1.56,0,0,1-1.29,1.4,4.66,4.66,0,0,1-2.48-.22,5.36,5.36,0,0,1-.7-.29l-.26-.14.29,0a28,28,0,0,0,2.9-.14,1,1,0,0,0,1-1,4.11,4.11,0,0,0-.07-.7Z"/><path class="s-peo-g" d="M101.7,35.82a1.7,1.7,0,1,0-1.7-1.7A1.7,1.7,0,0,0,101.7,35.82Z"/><path class="s-peo-g" d="M117.79,36a1.7,1.7,0,1,0-1.7-1.7A1.7,1.7,0,0,0,117.79,36Z"/><path class="s-peo-h" d="M112.59,30.44c-.8.33.54-1.84,4.48-1.93,4.6-.1,6,2.12,4.19,1.48A12.18,12.18,0,0,0,112.59,30.44Z"/><path class="s-peo-h" d="M106.21,30.44c.8.33-.53-1.84-4.48-1.93-4.6-.1-6,2.12-4.18,1.48A12.15,12.15,0,0,1,106.21,30.44Z"/><path class="s-peo-i" d="M116.52,43.46c-1.16,4.62-11.68,4.62-12.84,0A54,54,0,0,0,116.52,43.46Z"/><path class="s-peo-j" d="M103.36,65.16c-3.34-4.32-20.54-5.61-22-5.71L71.18,64.56l-9.35-5.1C59.69,59.62,43.26,61,40,65.16,37,69,40,84.51,40,84.51h63.36S106.32,69,103.36,65.16Z"/><path class="s-peo-b" d="M79.64,40.43H63.73l-1.67,19c0,2.1,4.07,5.85,9.38,5.85s9.87-3.75,9.87-5.85Z"/><path class="s-peo-f" d="M71.89,55.88c2.54.34,6.14-1.79,8.76-3.91l-.06-.63h0A12.65,12.65,0,0,1,72.15,55c-3.07,0-6.74-1.91-9.33-4.25l-.07.8h0A18,18,0,0,0,71.89,55.88Z"/><path class="s-peo-k" d="M88.8,32.35c-1.43-.67-3.29,1-4.14,3.84s-.38,5.61,1,6.28,3.29-1,4.14-3.84S90.24,33,88.8,32.35Z"/><path class="s-peo-k" d="M54.49,32.14c1.62-.53,3.52,1.37,4.24,4.25s0,5.63-1.61,6.16-3.51-1.37-4.24-4.25S52.88,32.67,54.49,32.14Z"/><path class="s-peo-b" d="M89.4,27.7c0,12.52-7.93,26.66-17.72,26.66S54,40.22,54,27.7,61.9,9,71.68,9,89.4,15.17,89.4,27.7Z"/><polygon class="s-peo-f" points="40.59 53.2 40.59 53.2 40.59 53.22 40.59 53.2"/><path class="s-peo-g" d="M62,34.83a1.49,1.49,0,1,0-1.48-1.49A1.49,1.49,0,0,0,62,34.83Z"/><path class="s-peo-g" d="M80,34.83a1.49,1.49,0,1,0-1.49-1.49A1.49,1.49,0,0,0,80,34.83Z"/><path class="s-peo-l" d="M57.93,29c-.45-.77,1.94-1.13,4.36-1.11,4.06,0,6.23,2,4.28,1.93C65.11,29.73,58.06,29.19,57.93,29Z"/><path class="s-peo-l" d="M84.24,29.14C84.7,28.38,82.33,28,79.9,28c-4.06-.05-6.27,1.89-4.31,1.84C77,29.76,84.11,29.36,84.24,29.14Z"/><path class="s-peo-i" d="M76.1,43.62c-.85,4.74-8.47,4.74-9.32,0A5.55,5.55,0,0,0,76.1,43.62Z"/><path class="s-peo-m" d="M68.33,39.05s0,0,0,0,0-.11.12-.17a22.92,22.92,0,0,0,2.19-6.67c.56,0-.56,5.11-1,6.33a11,11,0,0,1,1.72-.12c1.64,0,3,.28,3,.63s-1.34.64-3,.64S68.42,39.38,68.33,39.05Z"/><path class="s-peo-n" d="M89.62,21.48A5.37,5.37,0,0,0,89,19.82c-2.64-5-6.67-9.14-12.33-10.53a20.8,20.8,0,0,0-5-.59,17.79,17.79,0,0,0-12.51,4.59c-1.56,0-3.84.23-1.05.7a4.87,4.87,0,0,0-3.46,1.75c4.35-1.62.76.09-.65,1.86-1.16,1.59,1.27-.77,2.28-.54a21.24,21.24,0,0,0-2.46,10.47,33.7,33.7,0,0,0,.69,6.6h1.18s.8-4.85,2.43-6.91c1.33-1.68,2-5.17,2.51-8.29A8.32,8.32,0,0,0,62.62,23s-1.08-2.42,0-3.48c0,0,1,3.72,2.35,4.63a3.39,3.39,0,0,1,.62-1.89S67.14,28,82.52,24.84c0,0,4.62,6,5.1,9.29h1.15a33.7,33.7,0,0,0,.69-6.6,23.57,23.57,0,0,0-1.12-7.45Z"/><path class="s-peo-o" d="M49.59,16.23l-17.43.46H14.39s-3.4,20.87-.6,25.54,18.37.19,18.37.19,16.61,4.85,18.63-.19S49.59,16.23,49.59,16.23Z"/><path class="s-peo-b" d="M40.36,60c.12-.3.23-.59.34-.88.23-.59.44-1.17.64-1.72l0-.08c.32-1,.68-1.91,1-2.86.23-.62.44-1.25.64-1.88.13-.45.58-1.31,0-1.64a3.16,3.16,0,0,0-.54-.2,1.56,1.56,0,0,1-1-1.39L40,31.42H24.09l-.2,2.3L23.43,39l-.51,5.82c-.13,1.4-.27,2.8-.37,4.2a2.57,2.57,0,0,1-.18.83,1.5,1.5,0,0,1-.54.7c-.41.29-.92.34-1,.93a3.58,3.58,0,0,0,.35,1.63c.13.36.27.72.41,1.08.4,1,.79,2.08,1.17,3.13.2.57.42,1.16.65,1.78l.34.86c.08.22.17.44.26.66.23.58.47,1.16.73,1.77,2.55,6,5.38,20,6.65,22.13h1.35c1.27-2.15,4.1-16.16,6.65-22.13.26-.61.5-1.19.73-1.77C40.19,60.39,40.28,60.17,40.36,60Z"/><path class="s-peo-k" d="M48.13,23.25c-1.61-.46-3.36,1.52-3.92,4.42s.29,5.62,1.9,6.08,3.35-1.52,3.91-4.42S49.73,23.7,48.13,23.25Z"/><path class="s-peo-k" d="M15.41,23.3c1.41-.61,3.08,1.19,3.75,4s.06,5.62-1.34,6.22-3.08-1.19-3.75-4S14,23.91,15.41,23.3Z"/><path class="s-peo-p" d="M62.72,56.16c-1.88-1.89-6.56-3.5-11.34-4.37-1.55-.29-3.09-.52-4.49-.71-1.79-.23-3.37-.4-4.49-.5a74.85,74.85,0,0,1-4,11.8c-1.3,3.05-2.68,5.85-3.88,8.14a2.76,2.76,0,0,1-4.89,0c-1.2-2.29-2.58-5.09-3.88-8.14a74.85,74.85,0,0,1-4-11.8c-1.12.1-2.7.27-4.49.5-1.4.19-2.94.42-4.49.71-4.78.87-9.58,2.37-11.34,4.37-3.58,4.07,1,28.35,1,28.35H61.72S66.79,60.23,62.72,56.16Z"/><path class="s-peo-b" d="M49.76,18.69c0,12.52-7.93,26.67-17.71,26.67S14.33,31.21,14.33,18.69,22.26,0,32.05,0,49.76,6.16,49.76,18.69Z"/><path class="s-peo-o" d="M28.79,10.23s2,9,20.88,6.21C48.78,5.43,41.23,0,32.05,0,22.26,0,14.33,6.16,14.33,18.69A17,17,0,0,0,28.79,10.23Z"/><g class="s-peo-q"><path class="s-peo-f" d="M32,45.36c-3.21,0-6.22-1.54-8.82-4l-2.43-1.1c2.62,2.54,7,6,11,6,3,0,7.38-2.46,10-5l-.92.1C38.27,43.82,35.26,45.36,32,45.36Z"/></g><path class="s-peo-f" d="M33.1,27a1.63,1.63,0,0,1,.21.21,2.23,2.23,0,0,1,.41.68,1.81,1.81,0,0,1,.1.56,1.54,1.54,0,0,1-1.29,1.4,4.57,4.57,0,0,1-2.48-.22,6,6,0,0,1-.7-.29l-.25-.14.29,0a25.59,25.59,0,0,0,2.9-.14,1,1,0,0,0,1-1,5.46,5.46,0,0,0-.08-.7Z"/><path class="s-peo-r" d="M25.84,35.12c1.38,2.54,3.7,4.16,6.24,4s4.66-2,5.76-4.69Z"/><path class="s-peo-s" d="M28.1,35.77A4.31,4.31,0,0,0,32,38.27a4.28,4.28,0,0,0,3.58-2.92Z"/><path class="s-peo-g" d="M24.68,25.62a1.7,1.7,0,1,0-1.7-1.7A1.7,1.7,0,0,0,24.68,25.62Z"/><path class="s-peo-g" d="M40.77,25.76a1.7,1.7,0,1,0-1.7-1.7A1.7,1.7,0,0,0,40.77,25.76Z"/><path class="s-peo-l" d="M35.57,20.24c-.8.34.53-1.84,4.48-1.92,4.6-.1,6,2.11,4.18,1.47A12.2,12.2,0,0,0,35.57,20.24Z"/><path class="s-peo-l" d="M29.19,20.24c.8.34-.54-1.84-4.48-1.92-4.6-.1-6,2.11-4.19,1.47A12.24,12.24,0,0,1,29.19,20.24Z"/></svg>';
allSVGs["bank"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 233.62 157"><path class="s-ban-a" d="M193.12,62a3,3,0,0,1-.92-5.86l3.19-1c3.91-1.18,7.71-2.33,10.8-4.19a23.48,23.48,0,0,1-4.85-2.65,14.09,14.09,0,0,1-6.17-10.74,11.9,11.9,0,0,1,4.46-9.78A12.43,12.43,0,0,1,209.82,25a10.7,10.7,0,0,1,7.46,5.62,19.15,19.15,0,0,1,1.12,14c2.93-1.54,6.21-4.31,9.87-8.93A3,3,0,0,1,233,39.36c-6.24,7.88-12.53,12.14-18.79,12.78-4.52,5-11.12,7-17.07,8.76-1,.32-2.07.63-3.08,1A3.21,3.21,0,0,1,193.12,62Zm14.56-31.21a6.63,6.63,0,0,0-4.2,1.62,5.93,5.93,0,0,0-2.31,4.92,8.07,8.07,0,0,0,3.62,6.08,13.92,13.92,0,0,0,6.46,2.67,6.44,6.44,0,0,0,.36-.63c2-3.69,2.11-8.74.37-12a4.74,4.74,0,0,0-3.31-2.55A4.62,4.62,0,0,0,207.68,30.79Z"/><path class="s-ban-a" d="M199.62,70.25C199.62,31.45,159.44,0,109.87,0c-20.29,0-39,5.28-54,14.17a3.33,3.33,0,0,1-3.72-.24A48.51,48.51,0,0,0,40.56,7.3C34.66,4.92,27.65,3.84,22,6.55A1.73,1.73,0,0,0,21.29,9c4.09,7.36,7.81,15.15,11.34,22.86A3.1,3.1,0,0,1,32.27,35,61.58,61.58,0,0,0,22,56a3.42,3.42,0,0,1-1.3,1.92,17.55,17.55,0,0,1-2.77,1.64,41.88,41.88,0,0,1-8.19,2.65A52.35,52.35,0,0,1,.8,64a.77.77,0,0,0-.72.72c-.51,8,1.59,15.88,3.7,23.51A51,51,0,0,0,6.13,95c2.4,5.46,8.88,11.67,14.57,13.45a29.44,29.44,0,0,0,12.9.87,2.73,2.73,0,0,1,2.45.93,79.72,79.72,0,0,0,14,12.41,3.23,3.23,0,0,1,1.31,2l6.35,30.51A2.45,2.45,0,0,0,60.09,157H82.48a2.24,2.24,0,0,0,2.14-1.56l4.23-15.08A2,2,0,0,1,91.07,139a113.48,113.48,0,0,0,18.8,1.55q5.82,0,11.44-.56a2.47,2.47,0,0,1,2.69,2l2.79,13.48a2,2,0,0,0,2,1.62h22.83a2.23,2.23,0,0,0,2.08-1.4l12.05-29.72a3,3,0,0,1,1.15-1.38C186.88,111.61,199.62,92.1,199.62,70.25Z"/><circle class="s-ban-b" cx="48.62" cy="58.5" r="7.5"/><path class="s-ban-b" d="M139.07,27.36a1.24,1.24,0,0,1-1.68.44c-22.53-12.74-42.93-4.92-50.69-1.95l-1,.39a1.39,1.39,0,0,1-1.79-.86l-1.38-4.15a1.25,1.25,0,0,1,.73-1.56l1-.36c8.62-3.3,31.32-12,56.74,2.46a1.23,1.23,0,0,1,.45,1.68Z"/><circle class="s-ban-c" cx="112.31" cy="72.5" r="37.5"/><circle class="s-ban-d" cx="112.31" cy="72.5" r="32.5"/><circle class="s-ban-c" cx="112.31" cy="72.5" r="28"/><path class="s-ban-b" d="M96.54,59.79h3.85V73.84l6.49-7.28h4.62l-6.07,6.77,6.16,9.88H107.1l-4.4-7.09-2.31,2.53v4.56H96.54Z"/><path class="s-ban-b" d="M113.84,66.56h3.27l.16,3a4.27,4.27,0,0,1,4.49-3.37H123V69.9h-.87c-2.57,0-3.88,1.09-4.39,3.75v9.56h-3.85Z"/><path class="s-ban-b" d="M123.91,79h4.17v4.17h-4.17Z"/></svg>';
allSVGs["heart"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 232.89 200.6"><path class="s-hea-a" d="M232.89,61A60.93,60.93,0,0,0,116.44,35.83,60.92,60.92,0,1,0,14.77,100.65a60.38,60.38,0,0,0,6.8,6.77l92.95,92.33a2.91,2.91,0,0,0,2.07.85,3,3,0,0,0,2.09-.85L215.08,104v0a60.58,60.58,0,0,0,17.82-43Z"/><path class="s-hea-b" d="M147.72,106.44l-8.56-22.59-14.82,54.24a4.83,4.83,0,0,1-9.38-.19L99.64,71.07l-10.47,35a4.85,4.85,0,0,1-4.64,3.46H46a4.84,4.84,0,0,1,0-9.68h35L95.63,50.7A4.84,4.84,0,0,1,105,51l15.1,65.92,13.64-50a4.84,4.84,0,0,1,9.2-.45l12.66,33.38h63.18a60.91,60.91,0,1,0-102.33-64A60.92,60.92,0,1,0,14.77,100.65a60.38,60.38,0,0,0,6.8,6.77l92.95,92.33a2.91,2.91,0,0,0,2.07.85,3,3,0,0,0,2.09-.85l90.77-90.19H152.24A4.83,4.83,0,0,1,147.72,106.44Z"/></svg>';
allSVGs["vs"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.4 97.17"><path class="s-vs-a" d="M43.2,0c8,0,13.07,11.05,19.51,14.78,6.65,3.84,18.72,2.86,22.57,9.51,3.73,6.44-3,16.31-3,24.29s6.78,17.86,3,24.3c-3.85,6.65-15.92,5.66-22.57,9.51C56.27,86.12,51.18,97.17,43.2,97.17s-13.07-11-19.51-14.78C17,78.54,5,79.53,1.12,72.88c-3.73-6.44,3.05-16.32,3.05-24.3s-6.78-17.85-3-24.29C5,17.64,17,18.62,23.69,14.78,30.13,11.05,35.22,0,43.2,0Z"/><circle class="s-vs-b" cx="43.2" cy="48.58" r="35.04"/><circle class="s-vs-c" cx="43.46" cy="7.04" r="3.19"/><circle class="s-vs-c" cx="6.83" cy="27.74" r="3.19"/><circle class="s-vs-c" cx="6.83" cy="69.96" r="3.19"/><circle class="s-vs-c" cx="43.46" cy="90.66" r="3.19"/><circle class="s-vs-c" cx="79.3" cy="27.74" r="3.19"/><circle class="s-vs-c" cx="79.3" cy="69.96" r="3.19"/><circle class="s-vs-c" cx="43.2" cy="48.85" r="31.86"/><line class="s-vs-d" x1="52.63" y1="18.41" x2="33.34" y2="79.15"/><path class="s-vs-e" d="M26.33,30h4.21a.55.55,0,0,1,.52.39L37.18,50a.22.22,0,0,0,.43,0l6.16-19.62a.55.55,0,0,1,.52-.39h4.5l-9,27.08H35.21a.61.61,0,0,1-.58-.42L26,30.48A.37.37,0,0,1,26.33,30Z"/><path class="s-vs-e" d="M41.17,59.31H45a.53.53,0,0,1,.53.51c.2,2.56,1.95,3.79,5.2,3.79s4.9-1.2,4.9-3.59c0-2.55-1.59-3.66-6.05-4.34-6.14-.91-8.41-3.06-8.41-7.88,0-5.38,3.35-8.13,9.64-8.13,5.95,0,9,2.48,9.27,7.59a.57.57,0,0,1-.56.58H55.85a.56.56,0,0,1-.56-.51c-.18-2.36-1.69-3.52-4.6-3.52-3.07,0-4.7,1.24-4.7,3.51s1.55,3.42,5.74,4c6.41.88,8.72,3.23,8.72,8.24,0,5.46-3.23,8.17-9.8,8.17s-9.74-2.57-9.91-8A.43.43,0,0,1,41.17,59.31Z"/></svg>';
allSVGs["vsalt"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.4 97.17"><path class="s-vsa-a" d="M43.2,0c8,0,13.07,11.05,19.51,14.78,6.65,3.84,18.72,2.86,22.57,9.51,3.73,6.44-3,16.31-3,24.29s6.78,17.86,3,24.3c-3.85,6.65-15.92,5.66-22.57,9.51C56.27,86.12,51.18,97.17,43.2,97.17s-13.07-11-19.51-14.78C17,78.54,5,79.53,1.12,72.88c-3.73-6.44,3.05-16.32,3.05-24.3s-6.78-17.85-3-24.29C5,17.64,17,18.62,23.69,14.78,30.13,11.05,35.22,0,43.2,0Z"/><circle class="s-vsa-b" cx="43.2" cy="48.58" r="35.04"/><circle class="s-vsa-c" cx="43.46" cy="7.04" r="3.19"/><circle class="s-vsa-c" cx="6.83" cy="27.74" r="3.19"/><circle class="s-vsa-c" cx="6.83" cy="69.96" r="3.19"/><circle class="s-vsa-c" cx="43.46" cy="90.66" r="3.19"/><circle class="s-vsa-c" cx="79.3" cy="27.74" r="3.19"/><circle class="s-vsa-c" cx="79.3" cy="69.96" r="3.19"/><circle class="s-vsa-c" cx="43.2" cy="48.85" r="31.86"/><path class="s-vsa-d" d="M35.71,48.18,21.62,40a.78.78,0,0,0-1.17.68V57a.78.78,0,0,0,1.17.68l14.09-8.14A.77.77,0,0,0,35.71,48.18Z"/><path class="s-vsa-d" d="M50.82,49.55l13.83,8a.87.87,0,0,0,1.3-.75v-16a.86.86,0,0,0-1.3-.74l-13.83,8A.86.86,0,0,0,50.82,49.55Z"/><line class="s-vsa-e" x1="43.2" y1="21.77" x2="43.2" y2="23.36"/><line class="s-vsa-f" x1="43.2" y1="31.09" x2="43.2" y2="70.47"/><line class="s-vsa-e" x1="43.2" y1="74.34" x2="43.2" y2="75.93"/></svg>';

﻿addDomReadyEventListener(() => {
    let campaignDropdowns = document.querySelectorAll("select[name='campaigns']");

    if (campaignDropdowns && campaignDropdowns.length > 0) {
        toAPI("adminCampaigns", function (data) {
            let options = '';
            let count = 0;
            forEach(data, function (c) {
                options += '<option value="' + c.id + '">' + c.name + ' (' + c.startDataEntry.substr(0, c.startDataEntry.indexOf('T')) + ')</option>';
                count++;
            });
            if (count > 1) options += '<option value="">Vælg kampagne</option>';
            forEach(campaignDropdowns, function (el) {
                el.innerHTML = options;
            });
        }, "{}");
    }

    addEvent("#adminusers .cf", "submit", function (e) {
        let text = e.target.querySelector("input[name='text']");
        let post = { "Users": true, "Text": text.value };
        toAPI("adminSearch", function (data) {
            if (data.participants) {
                let table = "<table>";
                forEach(data.participants, function (el) {
                    table += '<tr><td>' + el.name + '</td><td><a href="/umbraco/surface/adminabcsurface/impersonate?email=' + el.email + '" target="_blank">' + el.email + '</a></td><td>' + (el.phone ?? '') + '</td></tr>';
                });
                if (data.participants.length === 0) table += "<tr><td>Ingen resultater</td></tr>";
                table += "</table>";
                e.target.closest("div").querySelector(".table").innerHTML = table;
            }

        }, JSON.stringify(post));
        stopAll(e);
    });


    addEvent("#adminteams .cf", "submit", function (e) {
        let text = e.target.querySelector("input[name='text']");
        let campaign = e.target.querySelector("select[name='campaigns']");
        let campaignId = campaign.value ? parseInt(campaign.value) : 0;
        let post = { "Groups": true, "Text": text.value, "CampaignId": campaignId };
        toAPI("adminSearch", function (data) {
            if (data.participants) {
                let table = "<table>";
                forEach(data.groups, function (el) {
                    // <td><textarea>' + JSON.stringify(el) + '</textarea></td>
                    table += '<tr>' + (campaignId ? '' : '<td>' + el.ci + '<br />' + el.cn + '</td>') + '<td>' + el.l + '. ' + el.n + '</td><td>' + el.sNa + ' (' + el.z + ')</td><td><a href="/umbraco/surface/adminabcsurface/impersonate?email=' + el.pe + '" target="_blank">' + el.pe + '</a></td></tr>';
                });
                if (data.groups.length === 0) table += "<tr><td>Ingen resultater</td></tr>";
                table += "</table>";
                e.target.closest("div").querySelector(".table").innerHTML = table;
            }

        }, JSON.stringify(post));
        stopAll(e);
    });


    addEvent("#admincampaigns .cf", "submit", function (e) {
        let campaign = e.target.querySelector("select[name='campaigns']").value;
        let type = e.target.querySelector("select[name='type']").value;
        let url = '/umbraco/surface/adminabcsurface/' + (type === 'Klasser' ? 'groups' : 'participants') + '?campaignId=' + campaign;
        window.open(url);
        stopAll(e);
    });

    addEvent("#adminwinners .cf", "submit", function (e) {
        let campaign = e.target.querySelector("select[name='campaigns']").value;
        let url = ABCAPIUrl + 'groups/' + campaign + '/false';
        httpr(url, function (data) {
            drawData = data;
            drawDataCampaignId = campaign;
            let drawForm = document.querySelector("#admindraw");
            removeClass(drawForm, "hidden");
            let regions = {};
            let municipalities = {};
            let schools = {};
            let potentialCount = 0;
            let sumSeatDays = 0;

            forEach(data, function (el) {
                if (el.V0 && el.V0 > 0 && (el.V1 && el.V1 > 0 || el.V2 && el.V2 > 0)) {
                    regions[el.R] = true;
                    municipalities[el.M] = true;
                    schools[el.SNa] = true;
                    potentialCount++;
                    if (el.V1 && el.V1 > 0) sumSeatDays += (el.V1 / el.V0);
                    if (el.V2 && el.V2 > 0) sumSeatDays += (el.V2 / el.V0);
                    // Hardcode for cykeltjek, must be V5
                    if (el.V5 && el.V5 > 0) sumSeatDays += (el.V5 / el.V0);
                }
            });

            _log(potentialCount);
            _log(sumSeatDays);

            addOverlayMessage("Kampagnen har " + potentialCount + " klasser med mindst en cykeldag, cykeltjek eller hjelmdag");

            drawForm.querySelector("select[name='region']").innerHTML = '<option>Alle</option>' + createOptions(Object.entries(regions));
            drawForm.querySelector("select[name='municipality']").innerHTML = '<option>Alle</option>' + createOptions(Object.entries(municipalities));
            drawForm.querySelector("select[name='school']").innerHTML = '<option>Alle</option>' + createOptions(Object.entries(schools));
            drawForm.querySelector("select[name='type']").innerHTML = '<option>Standard</option><option>Udskoling</option>';
        });
        stopAll(e);
    });

    function download(data, filename, type) {
        var file = new Blob([data], { type: type });
        if (window.navigator.msSaveOrOpenBlob) // IE10+
            window.navigator.msSaveOrOpenBlob(file, filename);
        else {
            var a = document.createElement("a"),
                url = URL.createObjectURL(file);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }
    }

    addEvent("#admindraw .cf", "submit", function (e) {
        let region = e.target.querySelector("select[name='region']").value;
        let municipality = e.target.querySelector("select[name='municipality']").value;
        let school = e.target.querySelector("select[name='school']").value;
        let type = e.target.querySelector("select[name='type']").value;

        let potentials = [];
        let sumSeatDays = 0;
        let sumV4 = 0;

        if (type == 'Udskoling') {
            forEach(drawData, function (el) {
                if (el.V4 && el.V4 > 0 && el.V0 && el.V0 > 0 && (region === "Alle" || region === el.R) && (municipality === "Alle" || municipality === el.M) && (school === "Alle" || school === el.SNa)) {
                    potentials.push(el);
                    // Hardcode for cykeltjek, must be V5
                    if (el.V5 && el.V5 > 0) sumSeatDays += (el.V5 / el.V0);
                    // Hardcode for KM on V4
                    sumV4 += (el.V4 / el.V0);
                    el.sumV4 = sumV4;
                }
            });

            let r = rnd();
            let winningSD = r * sumV4;

            var winner;

            for (var i = 0; i < potentials.length; i++) {
                if (potentials[i].sumV4 >= winningSD) {
                    winner = potentials[i];
                    break;
                }
            }

            if (winner) {
                let post = { "Groups": true, "Text": (winner.I + ""), "CampaignId": parseInt(drawDataCampaignId) };
                toAPI("adminSearch", function (data) {
                    if (data.groups) {
                        let wg = data.groups[0];
                        let date = new Date().toISOString().replace(/:/gi, "-");
                        let message = "Vinderen er: " + winner.L + ". " + winner.N + "<br />Klasse id: " + winner.I + "<br />Region: " + winner.R + "<br />Kommune: " + winner.M + "<br />Skole: " + winner.SNa + "<br />Lærer email: " + wg.pe +
                            "<br /><br />Filter matcher " + potentials.length + " hold, summen af V4 (km totalt) / Deltagere er " + sumV4 +
                            "<br /><br />Dagens vindernummer er " + winningSD + " baseret på det tilfældige tal " + r + " ganget med summen af V4 for alle matchede hold " + sumV4 +
                            "<br /><br />Udtræk vinder, filtrer Region: '" + region + "' Kommune: '" + municipality + "' Skole: '" + school + "'" +
                            "<br /><br />" + date;
                        addOverlayMessage(message);
                        download("<html><head></head><body>" + message + "</body></html>", "draw-" + date + ".html", "html");
                    }
                }, JSON.stringify(post));
            }
            else {
                addOverlayMessage("Der kunne ikke findes en vinder, der er sandsynligvis sket en fejl.");
            }
        }
        else {
            forEach(drawData, function (el) {
                if ((el.V0 && el.V0 > 0 && (el.V1 && el.V1 > 0 || el.V2 && el.V2 > 0)) && (region === "Alle" || region === el.R) && (municipality === "Alle" || municipality === el.M) && (school === "Alle" || school === el.SNa)) {
                    potentials.push(el);
                    if (el.V1 && el.V1 > 0) sumSeatDays += (el.V1 / el.V0);
                    if (el.V2 && el.V2 > 0) sumSeatDays += (el.V2 / el.V0);
                    // Hardcode for cykeltjek, must be V5
                    if (el.V5 && el.V5 > 0) sumSeatDays += (el.V5 / el.V0);
                    el.ssd = sumSeatDays;
                }
            });

            let r = rnd();
            let winningSD = r * sumSeatDays;

            var winner;

            for (var i = 0; i < potentials.length; i++) {
                if (potentials[i].ssd >= winningSD) {
                    winner = potentials[i];
                    break;
                }
            }

            if (winner) {
                let post = { "Groups": true, "Text": (winner.I + ""), "CampaignId": parseInt(drawDataCampaignId) };
                toAPI("adminSearch", function (data) {
                    if (data.groups) {
                        let wg = data.groups[0];
                        let date = new Date().toISOString().replace(/:/gi, "-");
                        let message = "Vinderen er: " + winner.L + ". " + winner.N + "<br />Klasse id: " + winner.I + "<br />Region: " + winner.R + "<br />Kommune: " + winner.M + "<br />Skole: " + winner.SNa + "<br />Lærer email: " + wg.pe +
                            "<br /><br />Filter matcher " + potentials.length + " hold, summen af SeatDays (Cykeldage, cykeltjek og Hjelmdage) / Deltagere er " + sumSeatDays +
                            "<br /><br />Dagens vindernummer er " + winningSD + " baseret på det tilfældige tal " + r + " ganget med SeatDays summen " + sumSeatDays +
                            "<br /><br />Udtræk vinder, filtrer Region: '" + region + "' Kommune: '" + municipality + "' Skole: '" + school + "'" +
                            "<br /><br />" + date;
                        addOverlayMessage(message);
                        download("<html><head></head><body>" + message + "</body></html>", "draw-" + date + ".html", "html");
                    }
                }, JSON.stringify(post));
            }
            else {
                addOverlayMessage("Der kunne ikke findes en vinder, der er sandsynligvis sket en fejl.");
            }
        }
        stopAll(e);
    });

});

function createOptions(a) {
    let s = '';
    forEach(a, function (el) {
        s += '<option>' + el[0] + '</option>';
    });
    return s;
}

var drawData = [];
var drawDataCampaignId = 0;

function rnd() {
    return crypto.getRandomValues(new Uint32Array(1))[0] / 2 ** 32;
}
﻿var apiData = {};
var unsavedChanges = 0;
var validInteger = /^\d+$/;
var validNumber = /^\d*([,\.]\d+)?$/;
var genericError = "Der er sket en fejl der ikke burde ske, vi beklager ulejligheden, prøv evt. igen om et par minutter.";

window.onbeforeunload = function (e) {
    if (unsavedChanges > 0) {
        let text = "Du har ændringer du ikke har gemt, er du sikker på du vil forlade denne side?";
        e = e || window.event;

        if (e) {
            e.returnValue = text;
        }
        return text;
    }
};

addDomReadyEventListener(() => {
    forEach("div[data-memberaction]", function (el) {
        let action = el.dataset.memberaction;
        if (action) {
            switch (action) {
                case "profile":
                    showProfile(action);
                    break;
                default:
            }
        }
    });
});

function showApiError(error, internal, extra) {
    if (internal) {
        if (error) {
            addOverlayMessage(error, extra);
        }
        addOverlayMessage(genericError, extra);
    }
    else {
        addOverlayMessage(error);
    }
}

function showApiMessages(messages) {
    if (messages && messages.length) {
        forEach(messages, function (msg) {
            addOverlayMessage(msg);
        });
    }
}

function showProfile(action) {
    let postData = {};

    toAPI(action, function (data) {
        apiData[action] = data;
        let participantName = document.getElementById("participantName");
        if (participantName) {
            participantName.innerHTML = data.name;
            removeClass(participantName.closest(".r"), "hidden");
        }
        let campaign = apiData.profile.campaign;
        if (campaign) {
            let s = '<datalist id="schools">';
            forEach(apiData.profile.schools, function (school) {
                s += '<option>' + school.name + '</option>';
            });
            s += '</datalist>';
            document.querySelector("body").insertAdjacentHTML("beforeend", s);

            drawGroups();

            let invite = document.getElementById("invite");
            if (invite) {
                removeClass(invite.closest(".r"), "hidden");
                invite.addEventListener("submit", function (e) {
                    stopAll(e);

                    let form = e.target.closest("form");
                    let emailText = form.querySelector("textarea[name='email']").value.replace(/(\r\n|\n|\r)/gm, ',').replace(/\s/g, '').replace(/,,/g, ',');

                    if (!emailText) {
                        showApiMessages(["Udfyld feltet med email på den eller dem du gerne vil invitere."]);
                        return;
                    }

                    let sourceEmails = emailText.split(',');
                    _log(sourceEmails);
                    let emails = [];
                    let validationMessages = [];
                    forEach(sourceEmails, function (email) {
                        if (isValidEmail(email)) {
                            emails.push(email);
                        }
                        else {
                            validationMessages.push(email + " er ikke en gyldig email");
                        }
                    });

                    if (validationMessages.length) {
                        showApiMessages(validationMessages);
                        return;
                    }

                    form.querySelector("input[type='submit']").disabled = true;
                    toAPI("invite", function (data) {
                        if (data.messages.length > 0) {
                            form.querySelector("textarea[name='email']").value = "";
                            showApiMessages(data.messages);
                        }
                        else {
                            addBrief("Der er sket en fejl...", data);
                        }
                        form.querySelector("input[type='submit']").disabled = false;
                    }, emails);
                });
            }
        }
        else {
            let noCampaign = document.getElementById("ProfileNoActiveCampaigns");
            if (noCampaign) {
                removeClass(noCampaign, "hidden");
            }
        }
    }, JSON.stringify(postData));
}

function updateInputVisibility(el) {
    let form = el.closest("form");
    if (form) {
        var vcs = apiData.profile.campaign.campaignConfiguration.valueConfigurations;
        let inputs = form.querySelectorAll("input.val");
        let level = el.value;
        forEach(inputs, function (field) {
            let vcName = field.getAttribute("name");
            let vc = first(vcs, vcName, 'value');
            if (vc.forGrades && vc.forGrades.indexOf("," + level + ",")) {
                addClass(field.previousElementSibling, "hidden");
                addClass(field, "hidden");
            }
            else {
                removeClass(field.previousElementSibling, "hidden");
                removeClass(field, "hidden");
            }
        });
    }
}

function drawLevelDropdown(selectedLevel) {
    let s = '<label>Klassetrin</label><select name="level" class="number" required>';
    if (selectedLevel < 0) {
        s += '<option value="">Vælg...</option>';
    }
    for (var i = 0; i < 11; i++) {
        s += '<option' + (i === selectedLevel ? ' selected' : '') + '>' + i + '</option>';
    }
    s += '</select>';
    return s;
}

function drawGroups() {
    let profile = document.getElementById("profile");
    let campaign = apiData.profile.campaign;
    profile.innerHTML = "";
    let singleSchool = true;
    let lastId = 0;
    forEach(apiData.profile.groups, function (group) {
        if (lastId !== 0 && group.schoolId !== lastId) singleSchool = false;
        lastId = group.schoolId;
    });

    if (apiData.profile.groups && apiData.profile.groups.length > 0) {
        profile.insertAdjacentHTML('beforeend', '<br /><h2>Dine tilmeldte klasser</h2>');

        forEach(apiData.profile.groups, function (group) {
            drawGroup(group, profile, campaign, singleSchool);
        });

        profile.insertAdjacentHTML('beforeend', '<br />');
    }

    let newGroup = { name: '', schoolId: 0, id: 0, campaignId: campaign.id, level: -1 };
    drawGroup(newGroup, profile, campaign);

    removeClass(profile.closest(".r"), "hidden");

    // add datalist, draw create, init forms, activate toggles
    addEvents("#profile select", "change", function (e) {
        updateInputVisibility(e.target);
        let form = e.target.closest("form");
        addClass(form, "changed");
        form.querySelector("input[type='submit']").disabled = false;
    });

    addEvents("#profile .toggler", "click", function (e) {
        toggle(e);
    });

    addEvents("#profile input", "input", function (e) {
        let form = e.target.closest("form");
        addClass(form, "changed");
        form.querySelector("input[type='submit']").disabled = false;
    });

    addEvents("#profile .delete", "click", function (e) {
        if (confirm("Er du sikker, du kan ikke fortryde bagefter? (men du kan altid oprette klassen igen)")) {
            let form = e.target.closest("form");
            let groupId = parseInt(form.getAttribute("data-id"));
            let profile = {
                "groups": [{ id: groupId, campaignId: apiData.profile.campaign.id, delete: true }]
            };
            toAPI("profile", function (data) {
                apiData["profile"] = data;
                addBrief("Klassen er slettet.", data);
                drawGroups();
            }, profile);
        }
        stopAll(e);
    });

    addEvents("#profile form", "submit", function (e) {
        stopAll(e);

        let form = e.target.closest("form");
        saveForm(form);
    });

    throwEvent("togglers:changed");
}

function saveForm(form) {
    form.querySelector("input[type='submit']").disabled = true;

    let validationResult = validateGroup(form);
    if (validationResult.messages.length) {
        showApiMessages(validationResult.messages);
        return;
    }

    let profile = { groups: [validationResult.group] };

    toAPI("profile", function (data) {
        apiData["profile"] = data;
        if (data.messages.length > 0) {
            showApiMessages(data.messages);
        }
        else {
            addBrief("Klassen er gemt.", data);
        }
        drawGroups();
    }, profile, undefined, form);
}

function drawGroup(group, parentEl, campaign, singleSchool) {
    if (group.id === 0 && group.schoolId === 0 && apiData.profile.groups.length > 0) {
        group.schoolId = apiData.profile.groups[apiData.profile.groups.length - 1].schoolId;
    }
    let school = first(apiData.profile.schools, group.schoolId, "id");
    let schoolName = (school ? school.name : "");
    let toggleTag = 'p';
    let buttonText = 'Gem klasse';
    let values = "";
    let headingText = "Tilmeld ny klasse";
    let event = "";

    if (group.id !== 0) {
        headingText = group.level + '. ' + group.name + (!singleSchool && schoolName ? ' - ' + schoolName : '');
        forEach(campaign.campaignConfiguration.valueConfigurations, function (vc) {
            let val = group.values[vc.value];
            let cls = 'val';
            let type = "text";
            let maxLength = 500;
            if (vc.type === 0 || vc.type === 1) {
                cls += ' number';
                maxLength = 8;
            }
            let pattern = "";
            if (vc.value === "V0") {
                maxLength = 2;
                pattern = ' pattern="^(?:[1-9]|(?:[1-2][0-9])|(?:30))$"';
            }
            if (vc.forGrades && vc.forGrades.indexOf("," + group.level + ",") < 0) {
                cls += ' hidden';
            }
            if (vc.value == "V1" || vc.value == "V2") {
                maxLength = 3;
                maxValue = "*V0";
                type = "number";
            }
            cls = ' class="' + cls + '"';
            if (vc.type === 3) {
                let parts = vc.label.split('|');
                let lbl = parts[0];
                let options = '<option value="">Vælg...</option>';
                parts.forEach(function (o, i) {
                    if (i) {
                        if (o == val) {
                            options += '<option selected>' + o + '</option>';
                        }
                        else {
                            options += '<option>' + o + '</option>';
                        }
                    }
                });
                values += '<label' + cls + '>' + lbl + (vc.helpText ? '<span>' + vc.helpText + '</span>' : '') + '</label><select name="' + vc.value + '"' + cls +'>' + options + '</select>';
            }
            else {
                values += '<label' + cls + '>' + vc.label + (vc.helpText ? '<span>' + vc.helpText + '</span>' : '') + '</label><input name="' + vc.value + '" type="' + type + '" maxlength="' + maxLength + '" value="' +
                    (val ? (vc.type === 1 ? toComma(val) : val) : '') + '" ' + cls + pattern +
                    ' />';
            }
        });
    }
    else {
        toggleTag = 'h4';
        buttonText = 'Tilmeld ny klasse';
        event = "create";

        let vc = campaign.campaignConfiguration.valueConfigurations[0];
        let cls = 'val';
        let maxLength = 500;
        if (vc.type === 0 || vc.type === 1) {
            cls += ' number';
            maxLength = 8;
        }
        let pattern = "";
        if (vc.type === 0) {
            maxLength = 2;
            pattern = ' pattern="^(?:[1-9]|(?:[1-2][0-9])|(?:30))$"';
        }
        cls = ' class="' + cls + '"';
        values += '<label' + cls + '>' + vc.label + (vc.helpText ? '<span>' + vc.helpText + '</span>' : '') + '</label><input name="' + vc.value + '" type="text" maxlength="' + maxLength + '" value="" ' + cls + pattern + ' required="required" />';
    }

    let s = '<div class="team">' +
        '<' + toggleTag + ' class="toggler off">' + headingText + '</' + toggleTag + '><div>' +
        '<form autocomplete="off" class="cf team" data-id="' + group.id + '" data-campaignId="' + group.campaignId + '" data-event="' + event + '">' +
        (group.id !== 0 ? '<p class="highlight toggler off" style="margin-top: 6px;">Ret klassedetaljer</p><div><label class="small" style="text-align: right;"><a href="#" class="danger delete">Slet klasse</a></label>' : '') +
        drawLevelDropdown(group.level) +
        '<label>Klassenavn<span>Klassens bogstav f.eks. A</span></label><input placeholder="Klassenavn" name="name" value="' + group.name + '" required />' +
        '<label>Skole<span>Start med at skrive skolens navn, og vælg i listen der kommer frem</span></label><input class="wide" placeholder="Skole" name="school" list="schools" value="' + schoolName + '" required />' +
        (group.id !== 0 ? '</div>' : '') +
        values +
        '<input type="submit" value="' + buttonText + '" disabled></div></form></div>';
    parentEl.insertAdjacentHTML("beforeend", s);

    throwEvent("togglers:changed");
}

function validateGroup(form) {
    var messages = [];
    var group = {};

    group.id = parseInt(form.getAttribute("data-id"));
    let level = form.querySelector("select[name='level']").value;
    if (level === "") {
        messages.push("Vælg et klassetrin");
        group.level = -1;
    }
    else {
        group.level = parseInt(level);
    }
    group.name = form.querySelector("input[name='name']").value;
    if (!group.name) messages.push("Klassenavn skal udfyldes");
    if (group.name.indexOf(group.level) == 0) messages.push("Klassens navn skal ikke indeholde klassetrin");

    let school = form.querySelector("input[name='school']").value;
    let schoolElement = first(apiData.profile.schools, school, "name", true);
    if (school) {
        if (!schoolElement) {
            messages.push("Den indtastede skole matcher ikke nogen på listen, kontakt os hvis din skole mangler.");
            group.schoolId = 0;
        }
        else {
            group.schoolId = schoolElement.id;
        }
    }
    else {
        messages.push("Skole feltet skal udfyldes");
    }
    if (group.id === 0 && messages.length === 0) {
        forEach(apiData.profile.groups, function (g) {
            if (g.name.toLowerCase() === group.name.toLowerCase() && g.level === group.level && g.schoolId === group.schoolId) {
                messages.push("Klassen findes allerede");
            }
        });
    }

    group.values = {};
    let inputs = form.querySelectorAll("input.val,select.val");
    let vcs = apiData.profile.campaign.campaignConfiguration.valueConfigurations;
    let students = 0;
    forEach(inputs, function (input) {
        let val = input.value;
        let key = input.getAttribute("name");
        if (key == "V0") students = val;
        if (val) {
            let vc = first(vcs, key, "value");
            if (vc.forGrades && vc.forGrades.indexOf("," + group.level + ",") < 0) return;
            if (vc.type === 0 && !validInteger.test(val)) {
                messages.push(vc.errorText ? vc.errorText : vc.label + " skal være et heltal");
            }
            if (vc.type === 1 && !validNumber.test(val)) {
                messages.push(vc.errorText ? vc.errorText : vc.label + " skal være et tal, maks 1 komma");
            }
        }
        if (key === "V1" || key === "V2") {
            if (validInteger.test(val) && validInteger.test(students)) {
                if (val > (14 * students)) {
                    let vc = first(vcs, key, "value");
                    messages.push(vc.label + " kan max være 14 * antallet af elever i klassen (" + (14 * students) + ")");
                }
            }
        }
        if (key === "V5" && validInteger.test(students) && validInteger.test(val) && parseInt(val) > parseInt(students)) {
            let vc = first(vcs, key, "value");
            messages.push(vc.label + " kan max være antallet af elever i klassen (" + (students) + ")");
        }
        group.values[key] = val;
    });

    if (messages.length === 0) {
        group.campaignId = apiData.profile.campaign.id;
        group.changed = true;
    }

    return { messages: messages, group: group };
}

function toComma(n, pretty) {
    if (pretty) {
        return n.toLocaleString('da-DK', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        });
    }
    else {
        return n.toString().replace('.', ',');
    }
}

function toPoint(n) {
    if (!validNumber.test(n)) return n;
    return Math.round((parseFloat(n.toString().replace(',', '.')) + 0.00001) * 100) / 100;
}


function toAPI(action, callback, postData, noAuth, form) {
    let url = noAuth ? ABCAPIUrl + action : abcSurface + "ToAPI?action=" + action;
    httpr(url, function (data) {
        if (data === -1) {
            _log(data);
            _log(action);
            _log(url);
            addOverlayMessage(genericError, url);
        }
        else if (data === "0") {
            window.location = "/login";
        }
        else {
            callback(data);
        }
    }, typeof postData === "string" ? postData : JSON.stringify(postData), form);
}

function getApiData(action, callback, refresh) {
    if (refresh || !apiData[action]) {
        toAPI(action, function (data) {
            apiData[action] = data;
            callback(data);
        }, "{}");
    }
    else {
        callback(apiData[action]);
    }
}

function campaignById(id) {
    return first(apiData.profile.campaigns, parseInt(id), "id");
}

function customLog(level, ...args) {
    if (level < 0) {
        console.log(...args);
        return;
    }
    if (level > 0) {
        try {
            let err = {};
            args.forEach((a, i) => {
                err["p" + i] = a;
            });
            plausible(level > 1 ? "error" : "warn", { "props": err });
        }
        catch (error) {
            console.error("plausible", error);
            if (visibleLogging) {
                printError(2, ...args)
            }
        }
    }
    if (visibleLogging) {
        printError(level, ...args)
    }
    switch (level) {
        case 0:
            console.log(...args);
            break;
        case 1:
            console.warn(...args);
            break;
        case 2:
            console.error(...args);
            break;
        default:
            console.log(...args);
    }
}

function printError(level, ...args) {
    let errors = document.querySelector("#errors");
    if (errors) {
        let html = `<code class="${(level > 0 ? `level${level}` : '')}">`;
        args.forEach((a, i) => {
            html += `${typeof a == "string" ? a : (isElement(a) ? escapeHTML(a.outerHTML) : JSON.stringify(a, null, 2))}${i < (args.length - 1) ? " | " : ""}`;
        });
        errors.insertAdjacentHTML("afterbegin", html + "</code>\n");
    }
}


function isElement(o) {
    try {
        return o instanceof HTMLElement;
    } catch (e) {
        return (typeof o === "object") &&
            (o.nodeType === 1) &&
            (typeof o.style === "object") &&
            (typeof o.ownerDocument === "object");
    }
}
/*

    <form class="bwz-newsletter cf">
        <label for="name">Navn</label>
        <input type="text" id="name" name="name" required>

        <label for="email">Email</label>
        <input type="email" id="email" name="email" required>

        <!-- Hidden fields -->
        <input type="hidden" id="fid" name="fid" value="11">
        <input type="hidden" id="ucrc" name="ucrc" value="4F6B04BA75">

        <div class="message"></div>

        <input type="submit" id="submit-button" value="Tilmeld">
    </form>


 */

/**
 * Submits a form to BizWizard API
 * @param {string} name - The name field value
 * @param {string} email - The email field value
 * @param {string} fid - Form ID (hidden field)
 * @param {string} ucrc - UCRC value (hidden field)
 * @returns {Promise<Object>} - Response object with success status and data
 */
async function submitBizWizardForm(name, email, fid, ucrc) {
    const url = `https://app.bwz.se/cyklistforbundet/b/f/?fid=${fid}&ucrc=${ucrc}`;

    const formData = {
        "Name": name,
        "E-mail": email
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // 'Accept-Language': 'en|se|no|fi|da'
            },
            body: JSON.stringify(formData)
        });

        const result = await response.json();

        if (result.successful) {
            return handleSuccessfulSubmissionBWZ(result);
        } else {
            return handleFailedSubmissionBWZ(result);
        }

    } catch (error) {
        return handleNetworkErrorBWZ(error);
    }
}

/**
 * Handles successful form submissions
 * @param {Object} result - The successful response from BizWizard
 * @returns {Object} - Formatted success response
 */
function handleSuccessfulSubmissionBWZ(result) {
    let message = '';

    switch (result.optInResultCode) {
        case 1:
            message = 'Din email er nu tilmeldt.';
            break;
        case 2:
            message = 'Din email er allerede tilmeldt.';
            break;
        case 3:
            message = 'Check din email for at bekræfte din tilmelding.';
            break;
        default:
            message = 'Form afsendt!';
    }

    return {
        success: true,
        message: message,
        data: {
            optInResultCode: result.optInResultCode,
            optInResultCodeText: result.optInResultCodeText,
            recipientId: result.recipientId,
            isNewRecipient: result.isNewRecipient,
            formResponseId: result.formResponseId,
            redirectUrl: result.redirectUrl
        }
    };
}

/**
 * Handles failed form submissions
 * @param {Object} result - The failed response from BizWizard
 * @returns {Object} - Formatted error response
 */
function handleFailedSubmissionBWZ(result) {
    const errorMessages = {
        1: 'Invalid form field data provided.',
        2: 'This form is currently closed for registration.',
        3: 'This form is not yet open for registration.',
        4: 'This form has been deleted.',
        5: 'Email field is required but not found.',
        6: 'This form does not accept JSON submissions.'
    };

    let mainError = errorMessages[result.errorCode] || 'An unknown error occurred.';
    let fieldErrors = [];

    if (result.fieldValidationErrors && result.fieldValidationErrors.length > 0) {
        fieldErrors = result.fieldValidationErrors.map(error => ({
            field: error.formFieldName,
            message: error.errorMessage,
            errorCode: error.errorCode,
            errorCodeText: error.errorCodeText
        }));
    }

    return {
        success: false,
        message: mainError,
        errorCode: result.errorCode,
        errorCodeText: result.errorCodeText,
        fieldErrors: fieldErrors
    };
}

/**
 * Handles network or other errors
 * @param {Error} error - The error that occurred
 * @returns {Object} - Formatted error response
 */
function handleNetworkErrorBWZ(error) {
    return {
        success: false,
        message: 'Network error occurred. Please try again later.',
        error: error.message
    };
}
function initBWZNewsletterForms() {
    const forms = document.querySelectorAll('.bwz-newsletter');
    forms.forEach(form => {
        bwzNewsletterForm(form);
    });
}
function bwzNewsletterForm(form) {
    const submitButton = form.querySelector("input[type=submit]");
    const messageDiv = form.querySelector('.message');

    if (form) {
        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            // Disable submit button during submission
            submitButton.disabled = true;

            // Clear previous messages
            messageDiv.innerHTML = '';
            messageDiv.className = '';

            // Get form values
            const name = document.getElementById('name').value;
            const email = document.getElementById('email').value;
            const fid = document.getElementById('fid').value;
            const ucrc = document.getElementById('ucrc').value;

            try {
                const result = await submitBizWizardForm(name, email, fid, ucrc);

                if (result.success) {
                    messageDiv.innerHTML = `<p class="success">${result.message}</p>`;
                    messageDiv.className = 'success';

                    // Redirect if URL is provided
                    if (result.data.redirectUrl) {
                        setTimeout(() => {
                            window.location.href = result.data.redirectUrl;
                        }, 2000);
                    }

                    // Clear form on success
                    form.reset();
                } else {
                    let errorHtml = `<p class="error">${result.message}</p>`;

                    // Display field-specific errors
                    if (result.fieldErrors && result.fieldErrors.length > 0) {
                        errorHtml += '<ul class="field-errors">';
                        result.fieldErrors.forEach(fieldError => {
                            errorHtml += `<li><strong>${fieldError.field}:</strong> ${fieldError.message}</li>`;
                        });
                        errorHtml += '</ul>';
                    }

                    messageDiv.innerHTML = errorHtml;
                    messageDiv.className = 'error';
                }
            } catch (error) {
                messageDiv.innerHTML = `<p class="error">An unexpected error occurred. Please try again.</p>`;
                messageDiv.className = 'error';
                console.error('Form submission error:', error);
            } finally {
                // Re-enable submit button
                submitButton.disabled = false;
            }
        });
    }
}

// Initialize form handler when DOM is loaded
document.addEventListener('DOMContentLoaded', initBWZNewsletterForms);
﻿addDomReadyEventListener(() => {
    var elements = document.querySelectorAll('input,select,textarea');
    var invalidListener = function () {
        let form = this.closest("form");
        let firstInvalid = form.querySelector(":invalid");
        if (firstInvalid === this) {
            this.scrollIntoView(false);
            scrollToElement(this);
        }
    };

    for (var i = elements.length; i--;) {
        elements[i].addEventListener('invalid', invalidListener);
    }

    let prefillEmail = urlParam("email");
    if (prefillEmail) {
        forEach(document.querySelectorAll("form.prefill"), function (el) {
            let field = el.querySelector("input[type='email']");
            if (field) field.value = prefillEmail;
        });
    }

    initForms();

    forEach(".products .product", function (el) {
        el.addEventListener("input", function (e) {
            let el = e.target;
            if (el) {
                let v = el.value;
                let p = el.nextElementSibling;
                let pr = el.dataset.price;
                if (v && isInt(v) && p && pr) {
                    p.innerHTML = "I alt " + toComma(v * toPoint(pr), true) + " kr.";
                    removeClass(p, "hidden");
                }
                else {
                    p.innerHTML = "";
                    addClass(p, "hidden");
                }
            }
        });
    });
});

function initForms() {
    let forms = document.querySelectorAll("form.simple:not(.initdone)");
    addEvents(forms, "submit", function (e) {
        let form = e.target;
        if (hasClass(form, "pw")) {
            let pw = form.querySelector("input[name=password]");
            let newpw = form.querySelector("input[name=newpassword]");
            let pwe = form.querySelector("span[for=password]");
            let blankOk = hasClass(form, "update");

            if (blankOk && pw.value.length === 0) {
                addClass(pwe, "hidden");
            }
            else {
                if (pw.value.length < 6 || pw.value !== newpw.value) {
                    removeClass(pwe, "hidden");
                    return stopAll(e);
                }
                else {
                    addClass(pwe, "hidden");
                }
            }
        }
        if (hasClass(form, "hasProducts")) {
            let sum = 0;
            forEach(form.querySelectorAll(".product"), function (el) {
                let val = el.value;
                if (val && isInt(val) && val > 0) sum += parseInt(val);
            });
            if (sum === 0) {
                scrollToElement(form.querySelector(".products"));
                return stopAll(e);
            }
        }

        httpr(abcSurface + form.getAttribute("data-method"), undefined, new FormData(form), form);
        return stopAll(e);
    });
    addClasses(forms, "initdone");


    forms = document.querySelectorAll("form.simpleToAPI:not(.initdone)");
    addEvents(forms, "submit", function (e) {
        let form = e.target.closest("form");
        removeClasses(form.querySelectorAll(".result"), "active");

        let dto = {};
        forEach(form.querySelectorAll("select, input:not([type=submit]):not([type=button])"), function (formEl) {
            dto[formEl.getAttribute("name")] = (formEl.getAttribute("data-type") === "int" ? parseInt(formEl.value) : formEl.value);
        });

        toAPI(form.getAttribute("data-method"), function (data) {
            if (data) {
                let activeResult = form.querySelector(".result[data-status='" + data.result + "']");
                if (activeResult) addClass(activeResult, "active");
            }
            else {
                let activeResult = form.querySelector(".result[data-status='0']");
                if (activeResult) addClass(activeResult, "active");
            }
        }, dto, false);

        return stopAll(e);
    });
    addClasses(forms, "initdone");
}
﻿function webPsupport(callback) {
    var webP = new Image();
    webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
    webP.onload = webP.onerror = function () {
        callback(webP.height === 2);
    };
}

addDomReadyEventListener(() => {
    webPsupport(function (hasWebP) {
        let skipSteppingSize = [370, 570, 1170];
        forEach("img[data-src]", function (img) {
            if (hasClass(img, "lazy")) return;
            if (!isVisible(img)) {
                addClass(img, "lazy");
                return;
            }
            let mode = img.closest(".images") ? "max" : "crop";
            let src = img.getAttribute("data-src")?.toLowerCase();
            let isPNG = src.indexOf(".png") > 0;
            let height = img.clientHeight;
            let width = img.clientWidth;
            let uw = img.getAttribute("data-uw");
            if (uw && width > uw) width = uw;
            let allowSizeSteps = true;
            if (hasClass(img, "defaultAspect")) {
                if (uw) {
                    img.style.maxWidth = uw + "px";
                    if (uw < width) {
                        width = uw;
                        allowSizeSteps = false;
                    }
                }
                if (img.getAttribute("data-aspect")) {
                    height = width * img.getAttribute("data-aspect");
                }
                else {
                    height = "";
                }
            }
            if (hasClass(img, "sizebyheight")) {
                height = img.parentNode.clientHeight;
                width = "";
            }
            let pe = img.parentElement;
            if (width <= 1) {
                while (pe) {
                    width = pe.offsetWidth;
                    if (width > 1) {
                        break;
                    }
                    else {
                        pe = pe.parentElement;
                    }
                }
            }

            if (allowSizeSteps && width && skipSteppingSize.indexOf(width) < 0) {
                let stepSize = 10;
                if (width > 1200) {
                    stepSize = 200;
                }
                else if (width > 600) {
                    stepSize = 100;
                }
                else if (width > 300) {
                    stepSize = 50;
                }
                let steppedWidth = Math.ceil(width / stepSize) * stepSize;
                let steppedHeight = height ? Math.round(height / width * steppedWidth) : height;
                width = steppedWidth;
                height = steppedHeight;
            }

            if ((pe === img.parentElement) && pe.tagName !== 'DIV' && pe.closest('article')) height = 0;

            if (src.indexOf(".svg") < 0) {
                src = src.split('?')[0] + "?quality=80&rmode=" + mode + "&width=" + (width <= 0 ? "" : width) + "&height=" + (height <= 1 ? "" : height) + (img.getAttribute("data-center") ? "&rxy=" + img.getAttribute("data-center") : "") + (hasWebP && !isPNG ? "&format=webp" : "") + (hasClass(img, "preflow") ? "&autorotate=true" : "");
            }
            img.addEventListener("load", function (e) {
                var parent = e.target.parentNode;
                if (parent) {
                    setTimeout(function () { addClass(parent, "hlc"); }, 300);
                    if (parent.classList.contains("img")) addClass(parent, "lazyloaded");
                }
                img.removeAttribute("data-src");
                addClass(img, "lazyloaded");
            });
            img.setAttribute("loading", "lazy");
            img.setAttribute("src", src);
            if (hasClass(img.parentNode, "contain")) {
                img.parentNode.setAttribute("data-bg", "url(" + img.getAttribute("data-src") + ")");
            }
        });
    });
});

function injectSVG(el) {
    let src = el.src;
    let parent = el.parentNode;
    removeElement(el);
    loadInto(parent, src, function () { }, "image/svg+xml");
}
﻿var enableLog = true;
var enableLogDebug = true;

var cseUrl = 'https://www.googleapis.com/customsearch/v1/siterestrict?key=AIzaSyBmepL_ZguYZcP0ksZ7wT6GwOeLrUqPKTU&cx=002024686760376196567:vftrx4tbstk&q=';
var abcSurface = "/umbraco/surface/abcsurface/";

//var videoAccept = '<div class="cookieconsent-optout-statistics">Du skal <a href="javascript:Cookiebot.renew()">acceptere marketing cookies</a> for at se video.</div>';
//$(function () {
//    if (window.videoAccept !== undefined) $("iframe[data-cookieconsent]").closest(".embed-container").before(videoAccept);
//    $("iframe[data-cookieconsent]").each(function () {
//        $(this).attr("src", $(this).attr("data-src"));
//    });
//});

window.addEventListener('resize', function () {
    setDataScale();
});

function setDataScale() {
    forEach(document.querySelectorAll(".rscaled"), function (el) {
        let max = el.getAttribute("data-max");
        if (!max) max = 1170;

        let vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (vw > 30) vw = vw - 30;
        let scale = vw < max ? vw / max : 1;
        el.setAttribute("style", '--rscale: ' + scale + '; --scalemax: ' + max + 'px');
        if (vw < max) {
            addClass(el, "scaled");
        }
        else {
            removeClass(el, "scaled");
        }
    });
}

addDomReadyEventListener(() => {
    setDataScale();

    let map = document.querySelector("#map");
    if (map) {
        var refs = document.getElementsByTagName('script');
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBwUmOPOhiVRK3mg2VIwEvldOjF_lSR5Kg&callback=initMap&v=quarterly';
        refs[refs.length - 1].parentNode.insertBefore(script, refs[refs.length - 1]);
    }

    forEach(".pu", function (el) {
        addClass(el.parentNode, "haspu");
    });

    forEach(".filter", function (el) {
        pageListFilter(el);
    });

    var someshare = document.querySelector("li.share");
    if (someshare) {
        var url = window.location.href.split('?')[0].split('#')[0];
        var canonical = document.querySelector("link[rel='canonical']");
        if (canonical) url = canonical.getAttribute("href");

        let sh = someshare.querySelector(".tw");
        if (sh) sh.setAttribute("href", "http://twitter.com/share?text=&hashtags=abc&url=" + encodeURIComponent(url));
        sh = someshare.querySelector(".fb");
        if (sh) sh.setAttribute("href", "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url));
    }

    forEach(".banner .bike", function (el) {
        var url = cssVar("logocykel" + el.getAttribute("data-bike"));
        var svg = decodeURIComponent(url.substring(url.indexOf(",") + 1, url.indexOf(")") - 1));
        el.innerHTML = svg;
    });

    let mega = document.querySelector("nav.mega > ul");
    forEach(".stick a", function (el) {
        if (!hasClass(el, "search") && el !== el.parentNode.children[0]) {
            let li = document.createElement("li");
            addClass(li, "added");
            li.innerHTML = el.outerHTML;
            removeClass(li.querySelector("a"), "button");
            mega?.prepend(li);
        }
    });

    addEvents(".toggler", "click", function (e) {
        toggle(e);
    });

    addEvent("nav.mega", "click", function (e) {
        e.stopPropagation();
    });

    addEvent(".burger", "click", function (e) {
        toggleClass("nav.mega", "showMobile");
        document.getElementById("burger-check").checked = !document.getElementById("burger-check").checked;
        return stopAll(e);
    });

    addEvent("a.search", "click", function (e) {
        toggleClass(e.target, "out");
        return stopAll(e);
    });

    addEvents(".main a, .sub a:not(.search)", "click", function (e) {
        if (hasClass(e.target, "show")) {
            hideMenu();
        }
        else {
            let mega = document.querySelector("nav.mega");
            removeClass(mega, "showMobile");
            document.getElementById("burger-check").checked = false;

            return showMenu(e.target, e);
        }
        return stopAll(e);
    });

    addEvent(".sub form", "click", function (e) {
        e.stopPropagation();
    });

    addEvent("body", "click", function (e) {
        let s = document.querySelector("a.search");
        if (s) removeClass(s, "out");
        hideMenu();
    });

    forEach("p.limit", function (el) {
        if (el.offsetHeight > 150) {
            addClass(el, "limited");
        }
        else {
            removeClass(el, "limit");
        }
    });

    addEvent("p.limit", "click", function (e) {
        removeClass(e.target, "limited");
        stopAll(e);
    });


    var pop = document.querySelector("div.pop");
    if (pop) {
        let popId = pop.dataset.id;
        let popKey = "pop" + popId;
        let today = new Date().toISOString().split('T')[0];
        let lastShown = localStorage.getItem(popKey);
        if (!lastShown || lastShown != today) {
            localStorage.setItem(popKey, today);
            const dialog = document.getElementById('imageDialog');
            document.body.classList.add("noscroll");
            dialog.addEventListener("close", (e) => {
                document.body.classList.remove("noscroll");
            });
            dialog.querySelector("form").insertAdjacentHTML("beforeend", pop.outerHTML);

            let delay = pop.dataset.delay;
            if (delay) {
                setTimeout(function () { dialog.showModal(); }, delay * 1000);
            }
            else {
                dialog.showModal();
            }
        }
    }


    if (window.gtmId !== undefined && window.gtmId !== '') {
        window.dataLayer = window.dataLayer || [];

        gtag("consent", "default", {
            ad_storage: "denied",
            analytics_storage: "denied",
            wait_for_update: 500
        });
        gtag("set", "ads_data_redaction", true);

        (function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l !== 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', gtmId);
    }
    throwEvent("togglers:changed");
});

function throwEvent(eventName, data) {
    let event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
}
function numberToggles() {
    const toggles = document.querySelectorAll(".toggler");
    toggles.forEach(function (el, i) {
        el.dataset.toggler = i.toString();
    });
}

document.addEventListener("togglers:changed", numberToggles);

function pageListFilter(filter) {
    let pages = filter.closest(".r").querySelectorAll(".base");
    let types = [];
    let topics = [];
    forEach(pages, function (page) {
        let dataTypes = page.getAttribute("data-types");
        let dataTopics = page.getAttribute("data-topics");
        let s = "";
        let allNumbers = true;
        if (dataTypes) {
            forEach(dataTypes.split(','), function (t) {
                if (types.indexOf(t) < 0) types.push(t);
                if (validInteger.test(t)) {
                    s += t + ". ";
                }
                else {
                    allNumbers = false;
                    s += (s ? ", " + t : t);
                }
            });
        }
        if (s) s = (allNumbers ? "Klassetrin: " : "") + s +  "<br/>";
        let s2 = "";
        if (dataTopics) {
            forEach(dataTopics.split(','), function (t) {
                if (topics.indexOf(t) < 0) topics.push(t);
                s2 += (s2 ? ", " + t : t);
            });
        }
        if ((s + s2)) {
            let div = page.querySelector(".content > div");
            if (div) div.insertAdjacentHTML("beforeend", '<p class="small">' + s + s2 + '</p>');
        }
    });
    let allNumbers = true;
    forEach(types, function (type) {
        if (!validInteger.test(type)) {
            allNumbers = false;
        }
    });
    if (allNumbers) {
        for (var i = 0; i < types.length; i++) {
            types[i] = parseInt(types[i]);
        }
        types.sort(function (a, b) {
            return a - b;
        });
    }
    else {
        types.sort();
    }
    topics.sort();
    let typeDropdown = filter.querySelector("select[name=type]");
    let topicDropdown = filter.querySelector("select[name=topic]");
    let s = typeDropdown.innerHTML;
    forEach(types, function (type) {
        s += '<option value="' + type + '">' + (allNumbers ? type + '. klasse' : type)+ '</option>'
    });
    typeDropdown.innerHTML = s;

    s = topicDropdown.innerHTML;
    forEach(topics, function (topic) {
        s += '<option value="' + topic + '">' + topic + '</option>'
    });
    topicDropdown.innerHTML = s;
    addEvents(filter.querySelectorAll("select"), "change", function (e) {
        updatePageFilter(filter);
    });
}

function updatePageFilter(filter) {
    let typeDropdown = filter.querySelector("select[name=type]");
    let topicDropdown = filter.querySelector("select[name=topic]");
    let type = typeDropdown.value;
    let topic = topicDropdown.value;
    let container = filter.closest(".r");
    if (container.querySelector(".base")) container = container.querySelector(".base").closest(".co");
    let pages = container.querySelectorAll(".base");
    let empty = true;
    forEach(pages, function (page) {
        let pageType = page.getAttribute("data-types");
        let pageTopic = page.getAttribute("data-topics");
        let hide = false;
        if (type && (!pageType || ("," + pageType + ",").indexOf("," + type + ",") < 0)) {
            hide = true;
        }
        if (topic && (!pageTopic || ("," + pageTopic + ",").indexOf("," + topic + ",") < 0)) {
            hide = true;
        }
        if (hide) {
            addClass(page, "hidden");
        }
        else {
            empty = false;
            removeClass(page, "hidden");
        }
    });
    if (empty) {
        addClass(container, "empty");
    }
    else {
        removeClass(container, "empty");
    }
}

function gtag() {
    dataLayer.push(arguments);
}

function toggle(e) {
    stopAll(e);
    let toggle = e.target;
    if (hasClass(toggle, "off")) {
        removeClass(toggle, "off");
    }
    else {
        addClass(toggle, "off");
    }
}

function hideMenu() {
    let mega = document.querySelector("nav.mega");
    if (mega) {
        addClass(mega, "hidden");
        removeClass(mega, "showMobile");
        document.getElementById("burger-check").checked = false;

        forEach(".main a, .sub a:not(.search)", function (el) {
            removeClass(el, "show");
        });
    }
}

function showMenu(el, e) {
    forEach(".main a, .sub a:not(.search)", function (el) {
        removeClass(el, "show");
    });
    addClass(el, "show");

    var href = el.getAttribute("href");
    var solo = false;
    forEach(".mega > ul > li > a", function (elx) {
        if (elx.getAttribute("href") === href) {
            if (!solo) solo = hasClass(elx, "solo");
            removeClass(elx.parentNode, "hidden");
        }
        else {
            addClass(elx.parentNode, "hidden");
        }
    });
    if (solo) return;

    removeClass(document.querySelector("nav.mega"), "hidden");

    if (e) return stopAll(e);
}
﻿var mapData;
var valueHeadings;
var map;
var lastMarkerId;
var extraR = 250;
var extraL = 70;
var extraT = 300;
var lastBounds;

var smallWidth = 800;
var centerMapX = 56.3;
var centerMapY = 11.4;
var searchZoom = 12;
var searchZoomSmall = 10;
var defaultZoom = 7;
var defaultZoomSmall = 6;

function CustomMarker(latlng, map, args) {
    this.latlng = latlng;
    this.args = args;
    this.setMap(map);
}

window.initMap = function initMap() {
    CustomMarker.prototype = new google.maps.OverlayView();

    CustomMarker.prototype.draw = function () {

        var self = this;

        var div = this.div;

        if (!div) {

            div = this.div = document.createElement('div');

            div.className = 'marker';

            div.dataset.markerid = self.args.markerid;
            if (self.args.i) div.dataset.i = self.args.i;
            if (self.args.n) div.dataset.n = self.args.n;
            if (self.args.ls) div.dataset.ls = self.args.ls;
            if (self.args.size) div.dataset.size = self.args.size;
            if (self.args.ll) div.dataset.ll = self.args.ll;

            google.maps.event.addDomListener(div, "click", function (e) {
                let el = e.target;
                addClass(el, "active");
                let $map = document.querySelector("#map");
                let $mapinfo = document.querySelector("#mapinfo");
                let to = getOffset(el);
                let mo = getOffset($map);

                mo.right = getWidth($map) + mo.left;
                mo.bottom = getHeight($map) + mo.top;
                var panX = 0;
                var panY = 0;
                if (to.left < mo.left + extraL) panX = (mo.left + extraL) - to.left;
                if (to.left > mo.right - extraR) panX = (mo.right - extraR) - to.left;
                if (to.top < mo.top + extraT) panY = (mo.top + extraT) - to.top;

                map.panBy(-panX, -panY);

                if (lastMarkerId) {
                    let $lm = $map.querySelector("div[data-markerid='" + lastMarkerId + "']");
                    removeClass($lm, "active");
                    $lm.innerHTML = "";
                }
                lastMarkerId = el.getAttribute("data-markerid");

                var item = mapData[lastMarkerId];
                let text = '<table class="plain">';
                for (let i = 0; i < valueHeadings.length; i++) {
                    text += '<tr><td>' + valueHeadings[i] + '</td><td>' + toComma(item.v[i]) + '</td></tr>';
                }
                text += '</table>';
                el.innerHTML = '<div><a class="close"></a><h4>' + item.n + '</h4>' + text + '<p><a class="stats" href="/statistik/?id=' + mapCampaignId + '&show=groups&filter=' + item.n + '&by=schools&sort=2,1">Vis deltagende klasser</a></p></div>';

                let $stats = el.querySelector(".stats");
                $stats.addEventListener("click", function (e) {
                    window.open(e.target.href);
                    stopAll(e);
                });

                //el.innerHTML = '<div><a class="close"></a><h3>' + item.n + '</h3>' + item.t + '<p><a class="mapinfo" href="#mapinfo">Se alle hold i ' + item.z + '</a></p><p><a class="stats" href="/statistik/?id=' + mapCampaignId + '&show=teams&filter=' + item.z + '&by=zips&sort=3,1">Gå til statistik for hold i ' + item.z + '</a></p></div>';

                //let $mi = el.querySelector(".mapinfo");
                //$mi.addEventListener("click", function (e) {
                //    scrollToElement(document.querySelector("#mapinfo"));
                //    stopAll(e);
                //});


                //let s = "";
                //let lastGroup = "";
                //let lastCompany = "";
                //forEach(item.wp, function (wp) {
                //    if (wp.g !== lastGroup) {
                //        lastGroup = wp.g;
                //        lastCompany = wp.c;
                //        s += '<h2>' + lastGroup + '</h2>';
                //        if (lastCompany !== lastGroup) {
                //            s += '<h3>' + lastCompany + '</h3>';
                //        }
                //    }
                //    else if (wp.c !== lastCompany) {
                //        lastCompany = wp.c;
                //        s += '<h3>' + lastCompany + '</h3>';
                //    }
                //    forEach(wp.t, function (t) {
                //        s += "<p>" + t.n + " (" + t.s + " deltagere, " + t.d + " cykeldage, " + toComma(t.k, true) + " KM)</p>";
                //    });
                //});
                //$mapinfo.innerHTML = s;
                //removeClass($mapinfo.closest(".r"), "hidden");

                el.querySelector("div").addEventListener("click", function (e) {
                    stopAll(e);
                });
                el.querySelector(".close").addEventListener("click", function (e) {
                    e.target.closest(".marker").innerHTML = "";
                    stopAll(e);
                    return false;
                });
            });

            var panes = this.getPanes();
            panes.overlayImage.appendChild(div);
        }

        var point = this.getProjection().fromLatLngToDivPixel(this.latlng);

        if (point) {
            div.style.left = point.x - 10 + 'px';
            div.style.top = point.y - 10 + 'px';
        }
    };

    CustomMarker.prototype.remove = function () {
        if (this.div) {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
        }
    };

    CustomMarker.prototype.getPosition = function () {
        return this.latlng;
    };

    var request = new XMLHttpRequest();
    request.open('GET', ABCAPIUrl + 'mapStats/' + mapCampaignId, true);

    request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
            var data = JSON.parse(request.responseText);
            var mapOptions = {
                zoom: window.innerWidth > smallWidth ? defaultZoom : defaultZoomSmall,
                center: new google.maps.LatLng(centerMapX, centerMapY),
                disableDefaultUI: true,
                styles: mapStyles
            };

            map = new google.maps.Map(document.getElementById('map'), mapOptions);

            //map.addListener('bounds_changed', function () {
            //    log("bounds changed");
            //});

            mapData = data.items;
            valueHeadings = data.vh;

            for (let i = 0; i < data.items.length; i++) {
                let item = data.items[i];
                let size = 1;

                overlay = new CustomMarker(
                    new google.maps.LatLng(item.x, item.y),
                    map,
                    {
                        markerid: i,
                        i: item.i,
                        n: item.n,
                        ls: item.ls,
                        ll: item.x + "," + item.y
                    }
                );
            }
        } else {
            console.log("error loading map data");
        }
    };

    request.onerror = function () {
        console.log("request error loading map data");
    };

    request.send();
}

var mapStyles = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ebe3cd"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#523735"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#f5f1e6"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#c9b2a6"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#dcd2be"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#ae9e90"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dfd2ae"
            }
        ]
    },
    {
        "featureType": "poi",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dfd2ae"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#93817c"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#a5b076"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#447530"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f1e6"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "stylers": [
            {
                //"visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#fdfcf8"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f8c967"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#e9bc62"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e98d58"
            }
        ]
    },
    {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#db8555"
            }
        ]
    },
    {
        "featureType": "road.local",
        "stylers": [
            {
                //"visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#806b63"
            }
        ]
    },
    {
        "featureType": "transit",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dfd2ae"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#8f7d77"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#ebe3cd"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dfd2ae"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#b9d3c2"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#92998d"
            }
        ]
    }
];
﻿var cseUrl = 'https://www.googleapis.com/customsearch/v1/siterestrict?key=AIzaSyDR8Wdq-g47Pf5-bYEdwBKqFL6e_qPyLio&cx=002541532685811098227:95zewwkwhw0&fields=items(title,link,snippet,htmlSnippet,pagemap/cse_image),searchInformation(totalResults),queries(request/searchTerms,nextPage/startIndex)&q=';

addDomReadyEventListener(() => {
    var q = urlParam("q");
    if (q && q !== '') {
        var searchResult = document.getElementById("searchResult");
        if (searchResult) {
            addEvent(".moreResults a.button", "click", function () {
                showSearchResults(searchResult.getAttribute("data-q"), searchResult, searchResult.getAttribute("data-next"));
            });

            forEach(".searchForm input[type=text]", function (el) {
                el.value = q;
            });

            addEvent(".searchForm", "submit", function (e) {
                let q = e.target.querySelector("input[type=text]");
                if (q && q.value !== "") {
                    showSearchResults(q.value, searchResult);
                }
                return false;
            });

            showSearchResults(q, searchResult);
        }
    }
});

function showSearchResults(q, searchResult, start) {
    if (!start) start = 1;
    if (q) {
        httpr(cseUrl + encodeURIComponent(q) + "&start=" + start, function (data) {
            if (start === 1) searchResult.innerHTML = "";
            showItems(data, searchResult);
        });
    }
}

function showItems(data, searchResult) {
    searchResult.setAttribute("data-q", data.queries.request[0].searchTerms);
    var moreResults = document.querySelector(".moreResults");
    if (data.queries.nextPage) {
        removeClass(moreResults, "hidden");
        searchResult.setAttribute("data-next", data.queries.nextPage[0].startIndex);
    }
    else {
        addClass(moreResults, "hidden");
    }
    var html = "";
    if (data.items) {
        for (var i = 0; i < data.items.length; i++) {
            var item = data.items[i];

            html += '<a href="' + item.link + '" class="c">' +
                '<span class="h3">' + item.title + '</span>' +
                '<p>' + item.htmlSnippet.replace(/<br>/gi, "").replace(/&nbsp;/gi, "") + '</p>' +
                '</a>';
        }
    }
    else {
        html = "<p class=\"c\">Ingen resultater</p>";
    }
    searchResult.insertAdjacentHTML("beforeend", html);
}
﻿var tableData = {
    min: [],
    max: [],
    vh: [],
    sort: 3,
    order: 0,
    valueLength: 0,
    rows: [],
    schools: {}
};

var tableSort = 3;
var statsKey = "stats";

addDomReadyEventListener(() => {
    initStats();
});

function initStats() {
    let sf = document.querySelector("#statfilter");
    if (!sf) return;

    let id = urlParam("id");
    if (id) statsCampaignId = id;
    httpr(ABCAPIUrl + statsKey + '/' + statsCampaignId, function (data) {
        apiData[statsKey] = data;

        if (!data.v) {
            addOverlayMessage(genericError);
            return;
        }

        tableData.valueLength = data.v.length;
        tableData.vh[0] = "";
        tableData.vh[1] = "Navn";
        for (let i = 0; i < tableData.valueLength; i++) {
            tableData.vh[i + 2] = data.vh[i];
        }
        let dict = apiData[statsKey]["schools"];
        Object.keys(dict).forEach(function (key) {
            let ids = dict[key].gis;
            forEach(ids, function (id) {
                tableData.schools[id] = key;
            });
        });

        let show = urlParam("show");
        let by = urlParam("by");
        let filter = urlParam("filter");
        let sort = urlParam("sort");
        if (!show) {
            show = "schools";
        }
        if (!sort) {
            sort = data.v[1] > 0 ? "3,1" : "2,1";
        }

        let showEl = document.querySelector("select[name='show']");
        let byEl = document.querySelector("select[name='by']");
        let sortEl = document.querySelector("select[name='sort']");

        sortEl.addEventListener("change", function (e) {
            showStatsTable();
        });

        showEl.addEventListener("change", function (e) {
            let v = e.target.value;
            if (v === "groups") {
                removeClass(document.getElementById("bySelect"), "hidden");
            }
            else {
                if (v !== "totals") {
                    byEl.value = v;
                    setFilterData(v);
                }
                addClass(document.getElementById("bySelect"), "hidden");
            }
            showStatsTable();
        });

        byEl.addEventListener("change", function (e) {
            let by = document.querySelector("select[name='by']").value;
            setFilterData(by);
        });

        if (show) showEl.value = show;

        if (filter) document.querySelector("input[name='filter']").value = filter;
        if (sort) sortEl.value = sort;

        if (by) {
            byEl.value = by;
            sendEvent(byEl, "change");
        }
        else {
            setFilterData(document.querySelector("select[name='by']").value);
        }

        sendEvent(showEl, "change");
        showStatsTable();

        addClass(document.getElementById("statloading"), "hidden");
        removeClass(document.getElementById("statfilter"), "hidden");
    });

    sf.querySelector("form").addEventListener("submit", function (e) {
        showStatsTable();
        stopAll(e);
    });
}

function extraE(s, n) {
    return s + (n === 1 ? '' : 'e');
}

function sendEvent(el, e) {
    var event;
    if (typeof (Event) === 'function') {
        event = new Event(e);
    } else {
        event = document.createEvent('Event');
        event.initEvent(e, true, true);
    }

    el.dispatchEvent(event);
}

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

function setFilterData(by) {
    let show = document.querySelector("select[name='show']").value;
    let dl = document.getElementById("filterdata");
    let s = "";
    if (by && show !== "totals") {
        let dict = apiData[statsKey][by];
        Object.keys(dict).forEach(function (key) {
            s += '<option>' + key + '</option>';
        });
    }
    dl.innerHTML = s;
}

function sortByColumn(a, index, order) {
    a.sort(sortFunction);

    function sortFunction(a, b) {
        let c = a[index];
        let d = b[index];
        if (c < d) {
            return order === 0 ? -1 : 1;
        }
        if (c > d) {
            return order === 0 ? 1 : -1;
        }
        return 0;
    }

    return a;
}

function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    };
}

function dynamicSortMultiple() {
    var props = arguments;
    return function (obj1, obj2) {
        var i = 0, result = 0, numberOfProperties = props.length;
        while (result === 0 && i < numberOfProperties) {
            result = dynamicSort(props[i])(obj1, obj2);
            i++;
        }
        return result;
    }
}

function showStatsTable(all) {
    let rs = [];
    let show = document.querySelector("select[name='show']").value;
    let by = document.querySelector("select[name='by']").value;
    let filter = document.querySelector("input[name='filter']").value;
    if (filter) filter = filter.toLowerCase();

    if (all) {
        rs = tableData.rows;
    }
    else {
        let sort = document.querySelector("select[name='sort']").value;

        let loc = document.location;
        window.history.replaceState({}, document.title, loc.protocol + "//" + loc.host + loc.pathname + "?id=" + statsCampaignId + "&show=" + encodeURIComponent(show) + "&filter=" + encodeURIComponent(filter) + "&by=" + encodeURIComponent(by) + "&sort=" + sort);

        tableData.sort = parseInt(sort.split(",")[0]);
        tableData.order = parseInt(sort.split(",")[1]);
        for (var i = 0; i < tableData.valueLength; i++) {
            tableData.min[i] = 0;
            tableData.max[i] = 0;
        }

        if (show === "groups") {
            let hash = {};
            let useHash = false;
            if (by && by !== "groups") {
                useHash = true;
                let ids = [];
                let dict = apiData[statsKey][by];
                Object.keys(dict).forEach(function (key) {
                    let v = dict[key];
                    if (!filter || key.toLowerCase().indexOf(filter) >= 0) {
                        ids = ids.concat(v.gis);
                    }
                });
                forEach(ids, function (id) {
                    hash[id] = 0;
                });
            }
            forEach(apiData[statsKey][show], function (g) {
                if ((useHash && hash.hasOwnProperty(g.i)) || (!useHash && (!filter || g.n.toLowerCase().indexOf(filter) >= 0))) {
                    let r = [g.i, g.l + ". " + g.n];
                    for (let i = 0; i < tableData.valueLength; i++) {
                        let v = g.v[i];
                        r.push(v);
                        if (tableData.min[i] < v) tableData.min[i] = v;
                        if (tableData.max[i] < v) tableData.max[i] = v;
                    }
                    rs.push(r);
                }
            });
        }
        else if (show === "totals") {
            let r = ["totals", "Total"];
            for (var i = 0; i < tableData.valueLength; i++) {
                let v = apiData[statsKey].v[i];
                r.push(v);
                tableData.min[i] = v;
                tableData.max[i] = v;
            }
            rs.push(r);
        }
        else {
            let dict = apiData[statsKey][show];
            Object.keys(dict).forEach(function (key) {
                let items = dict[key].v;
                if (!filter || key.toLowerCase().indexOf(filter) >= 0 || (show === "municipalities" && filter === dict[key].r) || (show === "schools" && (filter === dict[key].r || filter === dict[key].m || filter == dict[key].z))) {
                    let r = [key, key];
                    for (let i = 0; i < tableData.valueLength; i++) {
                        let v = items[i];
                        r.push(v);
                        if (tableData.min[i] < v) tableData.min[i] = v;
                        if (tableData.max[i] < v) tableData.max[i] = v;
                    }
                    rs.push(r);

                }
            });
        }
        rs = sortByColumn(rs, tableData.sort, tableData.order);

        tableData.rows = rs;
    }
    let max = all ? rs.length : rs.length > 100 ? 100 : rs.length;
    let table = document.querySelector("#stattable table");
    let s = '<tr>';
    for (let i = 1; i < tableData.valueLength + 2; i++) {
        s += '<th><a>' + tableData.vh[i] + '</a></th>';
    }
    s += '</tr>';
    let linkName = show === "groups" || show === "totals" ? false : true;

    for (let i = 0; i < max; i++) {
        let r = rs[i];

        let itag = '';
        let name = linkName ? '<a class="name">' + r[1] + '</a>' : r[1];
        if (show === "groups") itag = '<br><i>' + tableData.schools[r[0]] + '</i>';
        s += '<tr data-id="' + r[0] + '"><td>' + name + itag + '</td>';
        for (let j = 2; j < tableData.valueLength + 2; j++) {
            s += '<td>' + toComma(r[j]) + '</td>';
        }
        '</tr>';
    }

    table.setAttribute("data-show", show);
    table.innerHTML = s;

    let statinfo = document.querySelector("#statinfo");
    s = "";
    if (max < rs.length) {
        s += '<p>Viser de første 100 resultater<br /><a href="#" class="showall">Vis alle ' + rs.length + ' resultater</a></p>';
    }
    else {
        s += '<p>' + rs.length + " resultat" + (rs.length !== 1 ? "er" : "") + '</p>';
    }
    s += '<p><a href="' + ABCAPIUrl + 'groups/' + statsCampaignId + '/true" target="_blank">Hent statistik for hele kampagnen som CSV fil til Excel</a></p>';

    statinfo.innerHTML = s;

    let ths = table.querySelectorAll("th");
    forEach(ths, function (el, i) {
        let a = el.querySelector("a");
        if (a) {
            a.setAttribute("data-sort", i + 1);
            a.addEventListener("click", function (e) {
                let sort = document.querySelector("select[name='sort']");
                let s = parseInt(e.target.getAttribute("data-sort"));
                let o = s !== tableData.sort ? (s === 1 ? 0 : 1) : (tableData.order === 0 ? 1 : 0);
                sort.value = s + "," + o;
                sendEvent(sort, "change");
                stopAll(e);
            });
        }
        if (i === tableData.sort - 1) {
            addClass(el, "sort");
            if (tableData.order === 0) {
                removeClass(el, "down");
            }
            else {
                addClass(el, "down");
            }
        }
        else {
            removeClass(el, "sort");
        }
    });

    addEvents("#stattable a.name", "click", function (e) {
        stopAll(e);
        let ds = document.querySelector("#stattable table").getAttribute("data-show");
        document.querySelector("select[name='by']").value = ds;
        let v = e.target.innerHTML;
        if (v.indexOf("<") > 0) v = v.substr(0, v.indexOf("<"));
        document.querySelector("input[name='filter']").value = v;
        let sw = document.querySelector("select[name='show']");
        sw.value = (ds === "schools" ? "groups" : "schools");
        sendEvent(sw, "change");
    });

    let showAll = document.querySelector("a.showall");
    if (showAll) {
        showAll.addEventListener("click", function (e) {
            if (tableData.rows.length > 1000) {
                addBrief("Det kan tage nogle sekunder at tegne tabellen når der er mange resultater.");
                setTimeout(function () { showStatsTable(true); }, 200);
            }
            else {
                showStatsTable(true);
            }
            stopAll(e);
        });
    }
}

function drawBar(v, max, notext, extra, graphic, height) {
    if (!height) height = 30;
    height -= 10;
    let scale = v > 0 ? v / max : 0;
    return (graphic ? '<span class="baricon" style="height: ' + (10 + height * scale) + 'px">' + graphic + '</span>' : '') + '<span class="bar"><span' + (v === max ? ' class="max"' : '') + ' style="width: ' + (scale * 100) + '%"></span></span>' + (notext ? "" : '<u>' + toComma(v, true)) + (extra ? extra : '') + '</u>';
}

document.addEventListener("readystatechange", (e) => {
    let count = window.domReadyEventListeners.length;
    if (document.readyState !== "loading") {
        window.domReadyEventListeners.forEach((l) => l());
        window.domReadyEventListeners = [];
    }
    console.log("rsc", document.readyState, count);
});

console.log("zl");
document.querySelector("html").classList.remove("jsshow");
